var map = {
	"./TRM": 1012,
	"./TRM.js": 1012,
	"./TRM/filter": 173,
	"./TRM/filter.js": 173,
	"./TRM/table": 174,
	"./TRM/table.js": 174,
	"./accounting/accounts": 1013,
	"./accounting/accounts.js": 1013,
	"./accounting/accounts/filter": 175,
	"./accounting/accounts/filter.js": 175,
	"./accounting/accounts/table": 176,
	"./accounting/accounts/table.js": 176,
	"./accounting/area": 1014,
	"./accounting/area.js": 1014,
	"./accounting/area/filter": 969,
	"./accounting/area/filter.js": 969,
	"./accounting/area/table": 177,
	"./accounting/area/table.js": 177,
	"./accounting/area_copy": 1015,
	"./accounting/area_copy.js": 1015,
	"./accounting/closingDayReport": 1016,
	"./accounting/closingDayReport.js": 1016,
	"./accounting/closingDayReport/filter": 178,
	"./accounting/closingDayReport/filter.js": 178,
	"./accounting/closingDayReport/table": 179,
	"./accounting/closingDayReport/table.js": 179,
	"./accounting/concepts": 1017,
	"./accounting/concepts.js": 1017,
	"./accounting/concepts/filter": 180,
	"./accounting/concepts/filter.js": 180,
	"./accounting/concepts/table": 181,
	"./accounting/concepts/table.js": 181,
	"./accounting/costCenter": 1018,
	"./accounting/costCenter.js": 1018,
	"./accounting/costCenter/filter": 182,
	"./accounting/costCenter/filter.js": 182,
	"./accounting/costCenter/table": 183,
	"./accounting/costCenter/table.js": 183,
	"./accounting/employees": 1019,
	"./accounting/employees.js": 1019,
	"./accounting/employees/filter": 970,
	"./accounting/employees/filter.js": 970,
	"./accounting/employees/table": 184,
	"./accounting/employees/table.js": 184,
	"./accounting/expenses": 1020,
	"./accounting/expenses.js": 1020,
	"./accounting/expenses/filter": 185,
	"./accounting/expenses/filter.js": 185,
	"./accounting/expenses/table": 186,
	"./accounting/expenses/table.js": 186,
	"./accounting/incomes": 1021,
	"./accounting/incomes.js": 1021,
	"./accounting/incomes/filter": 187,
	"./accounting/incomes/filter.js": 187,
	"./accounting/incomes/table": 188,
	"./accounting/incomes/table.js": 188,
	"./accounting/position": 1022,
	"./accounting/position.js": 1022,
	"./accounting/position/filter": 971,
	"./accounting/position/filter.js": 971,
	"./accounting/position/table": 189,
	"./accounting/position/table.js": 189,
	"./accounting/productsThirdBetShop": 1023,
	"./accounting/productsThirdBetShop.js": 1023,
	"./accounting/productsThirdBetShop/filter": 972,
	"./accounting/productsThirdBetShop/filter.js": 972,
	"./accounting/productsThirdBetShop/table": 190,
	"./accounting/productsThirdBetShop/table.js": 190,
	"./accounting/productsThirdByBetShop": 1024,
	"./accounting/productsThirdByBetShop.js": 1024,
	"./accounting/productsThirdByBetShop/filter": 191,
	"./accounting/productsThirdByBetShop/filter.js": 191,
	"./accounting/productsThirdByBetShop/table": 192,
	"./accounting/productsThirdByBetShop/table.js": 192,
	"./accounting/productsThirdQuota": 1025,
	"./accounting/productsThirdQuota.js": 1025,
	"./accounting/productsThirdQuota/filter": 193,
	"./accounting/productsThirdQuota/filter.js": 193,
	"./accounting/productsThirdQuota/table": 194,
	"./accounting/productsThirdQuota/table.js": 194,
	"./accounting/providers": 1026,
	"./accounting/providers.js": 1026,
	"./accounting/providers/filter": 973,
	"./accounting/providers/filter.js": 973,
	"./accounting/providers/table": 195,
	"./accounting/providers/table.js": 195,
	"./accounting/providers/tableProductsThirdBetShop": 1027,
	"./accounting/providers/tableProductsThirdBetShop.js": 1027,
	"./accounting/providers_copy": 1028,
	"./accounting/providers_copy.js": 1028,
	"./accounting/squareDayReport": 1029,
	"./accounting/squareDayReport.js": 1029,
	"./accounting/squareDayReport/filter": 196,
	"./accounting/squareDayReport/filter.js": 196,
	"./accounting/squareDayReport/table": 197,
	"./accounting/squareDayReport/table.js": 197,
	"./accounting/squareDayReport2": 1030,
	"./accounting/squareDayReport2.js": 1030,
	"./accounting/squareDayReport2/filter": 198,
	"./accounting/squareDayReport2/filter.js": 198,
	"./accounting/squareDayReport2/table": 199,
	"./accounting/squareDayReport2/table.js": 199,
	"./accounting/typeCenterPosition": 1031,
	"./accounting/typeCenterPosition.js": 1031,
	"./accounting/typeDocument": 1032,
	"./accounting/typeDocument.js": 1032,
	"./accounting/typeDocument/filter": 201,
	"./accounting/typeDocument/filter.js": 201,
	"./accounting/typeDocument/table": 202,
	"./accounting/typeDocument/table.js": 202,
	"./accounting/types/filter": 974,
	"./accounting/types/filter.js": 974,
	"./accounting/types/table": 200,
	"./accounting/types/table.js": 200,
	"./activateRegistration": 1033,
	"./activateRegistration.js": 1033,
	"./addAdminUserManagement": 1034,
	"./addAdminUserManagement.js": 1034,
	"./addAgentListManagement": 1035,
	"./addAgentListManagement.js": 1035,
	"./addBetShopManagement": 1036,
	"./addBetShopManagement.js": 1036,
	"./adminUser": 1037,
	"./adminUser.js": 1037,
	"./adminUserManagement": 1038,
	"./adminUserManagement.js": 1038,
	"./affiliatesBetShop": 1039,
	"./affiliatesBetShop.js": 1039,
	"./agent/addInformationAgentList": 1040,
	"./agent/addInformationAgentList.js": 1040,
	"./agent/age": 1041,
	"./agent/age.js": 1041,
	"./agent/agent-list/detailsAgentList": 209,
	"./agent/agent-list/detailsAgentList.js": 209,
	"./agent/agent-list/filterAgentList": 210,
	"./agent/agent-list/filterAgentList.js": 210,
	"./agent/agent-list/recordAgentList": 211,
	"./agent/agent-list/recordAgentList.js": 211,
	"./agent/agent-list/recordTableAgentList": 975,
	"./agent/agent-list/recordTableAgentList.js": 975,
	"./agent/agent-list/tableAgentList": 212,
	"./agent/agent-list/tableAgentList.js": 212,
	"./agent/agent-retraction/PagoPremio": 213,
	"./agent/agent-retraction/PagoPremio.js": 213,
	"./agent/agent-retraction/search": 214,
	"./agent/agent-retraction/search.js": 214,
	"./agent/agent-retraction/transfers": 215,
	"./agent/agent-retraction/transfers.js": 215,
	"./agent/agent-retraction/transfers1": 216,
	"./agent/agent-retraction/transfers1.js": 216,
	"./agent/agent-transfers/PagoPremio": 217,
	"./agent/agent-transfers/PagoPremio.js": 217,
	"./agent/agent-transfers/search": 218,
	"./agent/agent-transfers/search.js": 218,
	"./agent/agent-transfers/transfers": 219,
	"./agent/agent-transfers/transfers.js": 219,
	"./agent/agent-transfers/transfers1": 220,
	"./agent/agent-transfers/transfers1.js": 220,
	"./agent/agent-tree/details": 976,
	"./agent/agent-tree/details.js": 976,
	"./agent/agent-tree/filter": 221,
	"./agent/agent-tree/filter.js": 221,
	"./agent/agent-tree/record": 130,
	"./agent/agent-tree/record.js": 130,
	"./agent/agent-tree/recordTableAgentList": 222,
	"./agent/agent-tree/recordTableAgentList.js": 222,
	"./agent/agent-tree/table": 223,
	"./agent/agent-tree/table.js": 223,
	"./agent/bonusReportAgentList": 1042,
	"./agent/bonusReportAgentList.js": 1042,
	"./agent/casinoGamesReportAgentList": 1043,
	"./agent/casinoGamesReportAgentList.js": 1043,
	"./agent/comissions": 1044,
	"./agent/comissions.js": 1044,
	"./agent/comissions/autoexclusionUsers": 1045,
	"./agent/comissions/autoexclusionUsers.js": 1045,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1046,
	"./agent/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1046,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1047,
	"./agent/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1047,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1048,
	"./agent/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1048,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1049,
	"./agent/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1049,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1050,
	"./agent/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1050,
	"./agent/comissions/betsReport/detailsReport": 1051,
	"./agent/comissions/betsReport/detailsReport.js": 1051,
	"./agent/comissions/betsReport/filterReport": 1052,
	"./agent/comissions/betsReport/filterReport.js": 1052,
	"./agent/comissions/betsReport/recordReport": 1053,
	"./agent/comissions/betsReport/recordReport.js": 1053,
	"./agent/comissions/betsReport/recordTableReport": 1054,
	"./agent/comissions/betsReport/recordTableReport.js": 1054,
	"./agent/comissions/betsReport/recordTableTransReport": 1055,
	"./agent/comissions/betsReport/recordTableTransReport.js": 1055,
	"./agent/comissions/betsReport/recordTransReport": 1056,
	"./agent/comissions/betsReport/recordTransReport.js": 1056,
	"./agent/comissions/betsReport/tableReport": 1057,
	"./agent/comissions/betsReport/tableReport.js": 1057,
	"./agent/comissions/betsReportBetShop": 1058,
	"./agent/comissions/betsReportBetShop.js": 1058,
	"./agent/comissions/bonusReport/detailsBonusReport": 1059,
	"./agent/comissions/bonusReport/detailsBonusReport.js": 1059,
	"./agent/comissions/bonusReport/filterBonusReport": 1060,
	"./agent/comissions/bonusReport/filterBonusReport.js": 1060,
	"./agent/comissions/bonusReport/recordBonusReport": 1061,
	"./agent/comissions/bonusReport/recordBonusReport.js": 1061,
	"./agent/comissions/bonusReport/recordTableBonusReport": 1062,
	"./agent/comissions/bonusReport/recordTableBonusReport.js": 1062,
	"./agent/comissions/bonusReport/tableBonusReport": 1063,
	"./agent/comissions/bonusReport/tableBonusReport.js": 1063,
	"./agent/comissions/casinoReport/detailsCasinoReport": 1064,
	"./agent/comissions/casinoReport/detailsCasinoReport.js": 1064,
	"./agent/comissions/casinoReport/filterCasinoReport": 1065,
	"./agent/comissions/casinoReport/filterCasinoReport.js": 1065,
	"./agent/comissions/casinoReport/recordCasinoReport": 1066,
	"./agent/comissions/casinoReport/recordCasinoReport.js": 1066,
	"./agent/comissions/casinoReport/recordTableCasinoReport": 1067,
	"./agent/comissions/casinoReport/recordTableCasinoReport.js": 1067,
	"./agent/comissions/casinoReport/tableCasinoReport": 1068,
	"./agent/comissions/casinoReport/tableCasinoReport.js": 1068,
	"./agent/comissions/casinoReport2/detailsCasinoReport": 1069,
	"./agent/comissions/casinoReport2/detailsCasinoReport.js": 1069,
	"./agent/comissions/casinoReport2/filterCasinoReport": 1070,
	"./agent/comissions/casinoReport2/filterCasinoReport.js": 1070,
	"./agent/comissions/casinoReport2/recordCasinoReport": 1071,
	"./agent/comissions/casinoReport2/recordCasinoReport.js": 1071,
	"./agent/comissions/casinoReport2/recordTableCasinoReport": 1072,
	"./agent/comissions/casinoReport2/recordTableCasinoReport.js": 1072,
	"./agent/comissions/casinoReport2/tableCasinoReport": 1073,
	"./agent/comissions/casinoReport2/tableCasinoReport.js": 1073,
	"./agent/comissions/comissions": 1074,
	"./agent/comissions/comissions.js": 1074,
	"./agent/comissions/comissions/table": 232,
	"./agent/comissions/comissions/table.js": 232,
	"./agent/comissions/comissionsReportBetShop": 1075,
	"./agent/comissions/comissionsReportBetShop.js": 1075,
	"./agent/comissions/comissionsReportBetShopDetail": 1076,
	"./agent/comissions/comissionsReportBetShopDetail.js": 1076,
	"./agent/comissions/comissions_report/detailsDepositReports": 1077,
	"./agent/comissions/comissions_report/detailsDepositReports.js": 1077,
	"./agent/comissions/comissions_report/filter": 233,
	"./agent/comissions/comissions_report/filter.js": 233,
	"./agent/comissions/comissions_report/recordDepositReports": 1078,
	"./agent/comissions/comissions_report/recordDepositReports.js": 1078,
	"./agent/comissions/comissions_report/recordTableDepositReports": 1079,
	"./agent/comissions/comissions_report/recordTableDepositReports.js": 1079,
	"./agent/comissions/comissions_report/table": 234,
	"./agent/comissions/comissions_report/table.js": 234,
	"./agent/comissions/comissions_report_detail/detailsDepositReports": 1080,
	"./agent/comissions/comissions_report_detail/detailsDepositReports.js": 1080,
	"./agent/comissions/comissions_report_detail/filter": 235,
	"./agent/comissions/comissions_report_detail/filter.js": 235,
	"./agent/comissions/comissions_report_detail/recordDepositReports": 1081,
	"./agent/comissions/comissions_report_detail/recordDepositReports.js": 1081,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports": 1082,
	"./agent/comissions/comissions_report_detail/recordTableDepositReports.js": 1082,
	"./agent/comissions/comissions_report_detail/table": 236,
	"./agent/comissions/comissions_report_detail/table.js": 236,
	"./agent/comissions/expenses": 1083,
	"./agent/comissions/expenses.js": 1083,
	"./agent/comissions/expenses/filter": 1084,
	"./agent/comissions/expenses/filter.js": 1084,
	"./agent/comissions/expenses/table": 1085,
	"./agent/comissions/expenses/table.js": 1085,
	"./agent/comissions/flujocaja/detailsFlujoCaja": 1086,
	"./agent/comissions/flujocaja/detailsFlujoCaja.js": 1086,
	"./agent/comissions/flujocaja/filterFlujoCaja": 1087,
	"./agent/comissions/flujocaja/filterFlujoCaja.js": 1087,
	"./agent/comissions/flujocaja/recordFlujoCaja": 1088,
	"./agent/comissions/flujocaja/recordFlujoCaja.js": 1088,
	"./agent/comissions/flujocaja/recordTableFlujoCaja": 1089,
	"./agent/comissions/flujocaja/recordTableFlujoCaja.js": 1089,
	"./agent/comissions/flujocaja/tableFlujoCaja": 1090,
	"./agent/comissions/flujocaja/tableFlujoCaja.js": 1090,
	"./agent/comissions/incomes": 1091,
	"./agent/comissions/incomes.js": 1091,
	"./agent/comissions/incomes/filter": 1092,
	"./agent/comissions/incomes/filter.js": 1092,
	"./agent/comissions/incomes/table": 1093,
	"./agent/comissions/incomes/table.js": 1093,
	"./agent/comissions/productsThird": 1094,
	"./agent/comissions/productsThird.js": 1094,
	"./agent/comissions/productsThird/filter": 1095,
	"./agent/comissions/productsThird/filter.js": 1095,
	"./agent/comissions/productsThird/table": 1096,
	"./agent/comissions/productsThird/table.js": 1096,
	"./agent/comissions/promotionalCodes": 1097,
	"./agent/comissions/promotionalCodes.js": 1097,
	"./agent/comissions/promotionalCodes/filter": 1098,
	"./agent/comissions/promotionalCodes/filter.js": 1098,
	"./agent/comissions/promotionalCodes/table": 1099,
	"./agent/comissions/promotionalCodes/table.js": 1099,
	"./agent/comissions/withdrawalRequests": 1100,
	"./agent/comissions/withdrawalRequests.js": 1100,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests": 239,
	"./agent/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 239,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest": 237,
	"./agent/comissions/withdrawalRequests/filterWithdrawalRequest.js": 237,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1101,
	"./agent/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1101,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest": 240,
	"./agent/comissions/withdrawalRequests/recordWithdrawalRequest.js": 240,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest": 238,
	"./agent/comissions/withdrawalRequests/tableWithdrawalRequest.js": 238,
	"./agent/configuration/changePassword": 1102,
	"./agent/configuration/changePassword.js": 1102,
	"./agent/configuration/changePassword/changePasswordView": 59,
	"./agent/configuration/changePassword/changePasswordView.js": 59,
	"./agent/configuration/generateToken": 1103,
	"./agent/configuration/generateToken.js": 1103,
	"./agent/configuration/generateToken/filter": 60,
	"./agent/configuration/generateToken/filter.js": 60,
	"./agent/configuration/generateToken/table": 61,
	"./agent/configuration/generateToken/table.js": 61,
	"./agent/configuration/qrgoogle": 1104,
	"./agent/configuration/qrgoogle.js": 1104,
	"./agent/configuration/securityChanges": 1105,
	"./agent/configuration/securityChanges.js": 1105,
	"./agent/configuration/securityChanges/filter": 46,
	"./agent/configuration/securityChanges/filter.js": 46,
	"./agent/configuration/securityChanges/table": 37,
	"./agent/configuration/securityChanges/table.js": 37,
	"./agent/configurationAgentList": 1106,
	"./agent/configurationAgentList.js": 1106,
	"./agent/depositReportAgentList": 1107,
	"./agent/depositReportAgentList.js": 1107,
	"./agent/financescustomerAgentList": 1108,
	"./agent/financescustomerAgentList.js": 1108,
	"./agent/financial/comisiones": 1109,
	"./agent/financial/comisiones.js": 1109,
	"./agent/financial/comisiones/table": 243,
	"./agent/financial/comisiones/table.js": 243,
	"./agent/financial/informationFinancialAgentList": 1110,
	"./agent/financial/informationFinancialAgentList.js": 1110,
	"./agent/financial/withdrawalRequestsAgentList": 1111,
	"./agent/financial/withdrawalRequestsAgentList.js": 1111,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList": 131,
	"./agent/financial/withdrawalRequestsAgentList/detailsWithdrawalRequestsAgentList.js": 131,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList": 244,
	"./agent/financial/withdrawalRequestsAgentList/filterWithdrawalRequestAgentList.js": 244,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList": 1112,
	"./agent/financial/withdrawalRequestsAgentList/recordTableWithdrawalRequestAgentList.js": 1112,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList": 132,
	"./agent/financial/withdrawalRequestsAgentList/recordWithdrawalRequestAgentList.js": 132,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList": 245,
	"./agent/financial/withdrawalRequestsAgentList/tableWithdrawalRequestAgentList.js": 245,
	"./agent/flujoCajaAgentList": 1113,
	"./agent/flujoCajaAgentList.js": 1113,
	"./agent/flujoCajaHijosAgentList": 1114,
	"./agent/flujoCajaHijosAgentList.js": 1114,
	"./agent/geo": 1115,
	"./agent/geo.js": 1115,
	"./agent/informationAgentList": 1116,
	"./agent/informationAgentList.js": 1116,
	"./agent/informeRed/details": 1117,
	"./agent/informeRed/details.js": 1117,
	"./agent/informeRed/filter": 252,
	"./agent/informeRed/filter.js": 252,
	"./agent/informeRed/record": 1118,
	"./agent/informeRed/record.js": 1118,
	"./agent/informeRed/recordTable": 1119,
	"./agent/informeRed/recordTable.js": 1119,
	"./agent/informeRed/table": 253,
	"./agent/informeRed/table.js": 253,
	"./agent/money": 1120,
	"./agent/money.js": 1120,
	"./agent/paymenthistory": 1121,
	"./agent/paymenthistory.js": 1121,
	"./agent/positions": 1122,
	"./agent/positions.js": 1122,
	"./agent/reports/autoexclusionUsers": 1123,
	"./agent/reports/autoexclusionUsers.js": 1123,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1124,
	"./agent/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1124,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers": 1125,
	"./agent/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1125,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers": 1126,
	"./agent/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1126,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1127,
	"./agent/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1127,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers": 1128,
	"./agent/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1128,
	"./agent/reports/balanceTransactionReport": 1129,
	"./agent/reports/balanceTransactionReport.js": 1129,
	"./agent/reports/balanceTransactionReport/filter": 254,
	"./agent/reports/balanceTransactionReport/filter.js": 254,
	"./agent/reports/balanceTransactionReport/table": 255,
	"./agent/reports/balanceTransactionReport/table.js": 255,
	"./agent/reports/betsReport/detailsReport": 1130,
	"./agent/reports/betsReport/detailsReport.js": 1130,
	"./agent/reports/betsReport/filterReport": 256,
	"./agent/reports/betsReport/filterReport.js": 256,
	"./agent/reports/betsReport/recordReport": 133,
	"./agent/reports/betsReport/recordReport.js": 133,
	"./agent/reports/betsReport/recordTableReport": 1131,
	"./agent/reports/betsReport/recordTableReport.js": 1131,
	"./agent/reports/betsReport/recordTableTransReport": 1132,
	"./agent/reports/betsReport/recordTableTransReport.js": 1132,
	"./agent/reports/betsReport/recordTransReport": 134,
	"./agent/reports/betsReport/recordTransReport.js": 134,
	"./agent/reports/betsReport/tableReport": 257,
	"./agent/reports/betsReport/tableReport.js": 257,
	"./agent/reports/betsReportAgentList": 1133,
	"./agent/reports/betsReportAgentList.js": 1133,
	"./agent/reports/bonusReport/detailsBonusReport": 226,
	"./agent/reports/bonusReport/detailsBonusReport.js": 226,
	"./agent/reports/bonusReport/filterBonusReport": 224,
	"./agent/reports/bonusReport/filterBonusReport.js": 224,
	"./agent/reports/bonusReport/recordBonusReport": 227,
	"./agent/reports/bonusReport/recordBonusReport.js": 227,
	"./agent/reports/bonusReport/recordTableBonusReport": 1134,
	"./agent/reports/bonusReport/recordTableBonusReport.js": 1134,
	"./agent/reports/bonusReport/tableBonusReport": 225,
	"./agent/reports/bonusReport/tableBonusReport.js": 225,
	"./agent/reports/casinoReport/detailsCasinoReport": 230,
	"./agent/reports/casinoReport/detailsCasinoReport.js": 230,
	"./agent/reports/casinoReport/filterCasinoReport": 228,
	"./agent/reports/casinoReport/filterCasinoReport.js": 228,
	"./agent/reports/casinoReport/recordCasinoReport": 231,
	"./agent/reports/casinoReport/recordCasinoReport.js": 231,
	"./agent/reports/casinoReport/recordTableCasinoReport": 1135,
	"./agent/reports/casinoReport/recordTableCasinoReport.js": 1135,
	"./agent/reports/casinoReport/tableCasinoReport": 229,
	"./agent/reports/casinoReport/tableCasinoReport.js": 229,
	"./agent/reports/casinoReport2/detailsCasinoReport": 1136,
	"./agent/reports/casinoReport2/detailsCasinoReport.js": 1136,
	"./agent/reports/casinoReport2/filterCasinoReport": 1137,
	"./agent/reports/casinoReport2/filterCasinoReport.js": 1137,
	"./agent/reports/casinoReport2/recordCasinoReport": 1138,
	"./agent/reports/casinoReport2/recordCasinoReport.js": 1138,
	"./agent/reports/casinoReport2/recordTableCasinoReport": 1139,
	"./agent/reports/casinoReport2/recordTableCasinoReport.js": 1139,
	"./agent/reports/casinoReport2/tableCasinoReport": 1140,
	"./agent/reports/casinoReport2/tableCasinoReport.js": 1140,
	"./agent/reports/deposit_report/detailsDepositReports": 1141,
	"./agent/reports/deposit_report/detailsDepositReports.js": 1141,
	"./agent/reports/deposit_report/filterDepositReports": 241,
	"./agent/reports/deposit_report/filterDepositReports.js": 241,
	"./agent/reports/deposit_report/recordDepositReports": 1142,
	"./agent/reports/deposit_report/recordDepositReports.js": 1142,
	"./agent/reports/deposit_report/recordTableDepositReports": 1143,
	"./agent/reports/deposit_report/recordTableDepositReports.js": 1143,
	"./agent/reports/deposit_report/tableDepositReports": 242,
	"./agent/reports/deposit_report/tableDepositReports.js": 242,
	"./agent/reports/flujocaja/detailsFlujoCaja": 1144,
	"./agent/reports/flujocaja/detailsFlujoCaja.js": 1144,
	"./agent/reports/flujocaja/filterFlujoCaja": 246,
	"./agent/reports/flujocaja/filterFlujoCaja.js": 246,
	"./agent/reports/flujocaja/recordFlujoCaja": 1145,
	"./agent/reports/flujocaja/recordFlujoCaja.js": 1145,
	"./agent/reports/flujocaja/recordTableFlujoCaja": 1146,
	"./agent/reports/flujocaja/recordTableFlujoCaja.js": 1146,
	"./agent/reports/flujocaja/tableFlujoCaja": 247,
	"./agent/reports/flujocaja/tableFlujoCaja.js": 247,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos": 250,
	"./agent/reports/flujocajahijos/detailsFlujoCajaHijos.js": 250,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos": 248,
	"./agent/reports/flujocajahijos/filterFlujoCajaHijos.js": 248,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos": 251,
	"./agent/reports/flujocajahijos/recordFlujoCajaHijos.js": 251,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos": 1147,
	"./agent/reports/flujocajahijos/recordTableFlujoCajaHijos.js": 1147,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos": 249,
	"./agent/reports/flujocajahijos/tableFlujoCajaHijos.js": 249,
	"./agent/reports/managementReport": 1148,
	"./agent/reports/managementReport.js": 1148,
	"./agent/reports/managementReport/filterReports": 258,
	"./agent/reports/managementReport/filterReports.js": 258,
	"./agent/reports/managementReport/tableReports": 259,
	"./agent/reports/managementReport/tableReports.js": 259,
	"./agent/reports/marketing/filterReports": 260,
	"./agent/reports/marketing/filterReports.js": 260,
	"./agent/reports/marketing/tableReports": 261,
	"./agent/reports/marketing/tableReports.js": 261,
	"./agent/reports/marketingReport": 1149,
	"./agent/reports/marketingReport.js": 1149,
	"./agent/reports/promotionalCodes": 1150,
	"./agent/reports/promotionalCodes.js": 1150,
	"./agent/reports/promotionalCodes/filter": 262,
	"./agent/reports/promotionalCodes/filter.js": 262,
	"./agent/reports/promotionalCodes/table": 263,
	"./agent/reports/promotionalCodes/table.js": 263,
	"./agent/reports/quotaRetractionReport/filter": 264,
	"./agent/reports/quotaRetractionReport/filter.js": 264,
	"./agent/reports/quotaRetractionReport/table": 265,
	"./agent/reports/quotaRetractionReport/table.js": 265,
	"./agent/reports/quotaRetractionReportAgent": 1151,
	"./agent/reports/quotaRetractionReportAgent.js": 1151,
	"./agent/reports/transfersReport/filter": 266,
	"./agent/reports/transfersReport/filter.js": 266,
	"./agent/reports/transfersReport/table": 267,
	"./agent/reports/transfersReport/table.js": 267,
	"./agent/reports/trasnfersReport": 1152,
	"./agent/reports/trasnfersReport.js": 1152,
	"./agent/reports/userAfilliatesReport": 1153,
	"./agent/reports/userAfilliatesReport.js": 1153,
	"./agent/reports/user_affiliates/detailsReports": 270,
	"./agent/reports/user_affiliates/detailsReports.js": 270,
	"./agent/reports/user_affiliates/filterReports": 268,
	"./agent/reports/user_affiliates/filterReports.js": 268,
	"./agent/reports/user_affiliates/recordReports": 271,
	"./agent/reports/user_affiliates/recordReports.js": 271,
	"./agent/reports/user_affiliates/recordTableReports": 1154,
	"./agent/reports/user_affiliates/recordTableReports.js": 1154,
	"./agent/reports/user_affiliates/tableReports": 269,
	"./agent/reports/user_affiliates/tableReports.js": 269,
	"./agent/reportscustomerAgentList": 1155,
	"./agent/reportscustomerAgentList.js": 1155,
	"./agent/requestsAgent": 1156,
	"./agent/requestsAgent.js": 1156,
	"./agent/requestsAgent/filter": 272,
	"./agent/requestsAgent/filter.js": 272,
	"./agent/requestsAgent/table": 273,
	"./agent/requestsAgent/table.js": 273,
	"./agent/requirementsAgent": 1157,
	"./agent/requirementsAgent.js": 1157,
	"./agent/requirementsAgent/details": 276,
	"./agent/requirementsAgent/details.js": 276,
	"./agent/requirementsAgent/detailsFilter": 278,
	"./agent/requirementsAgent/detailsFilter.js": 278,
	"./agent/requirementsAgent/detailsTable": 277,
	"./agent/requirementsAgent/detailsTable.js": 277,
	"./agent/requirementsAgent/filter": 274,
	"./agent/requirementsAgent/filter.js": 274,
	"./agent/requirementsAgent/table": 275,
	"./agent/requirementsAgent/table.js": 275,
	"./agent/statistics/age": 279,
	"./agent/statistics/age.js": 279,
	"./agent/statistics/marketing": 280,
	"./agent/statistics/marketing.js": 280,
	"./agent/statistics/marketingvsregistros": 281,
	"./agent/statistics/marketingvsregistros.js": 281,
	"./agent/statistics/money": 282,
	"./agent/statistics/money.js": 282,
	"./agent/statisticsAgentList": 1158,
	"./agent/statisticsAgentList.js": 1158,
	"./agent/tags": 1159,
	"./agent/tags.js": 1159,
	"./agentList": 1160,
	"./agentList.js": 1160,
	"./agentListManagement": 1161,
	"./agentListManagement.js": 1161,
	"./agentRetraction": 1162,
	"./agentRetraction.js": 1162,
	"./agentTransfers": 1163,
	"./agentTransfers.js": 1163,
	"./agentsInform": 1164,
	"./agentsInform.js": 1164,
	"./agentsTree": 1165,
	"./agentsTree.js": 1165,
	"./alltactions": 283,
	"./alltactions.js": 283,
	"./approvalLogs": 1166,
	"./approvalLogs.js": 1166,
	"./approvalLogs2": 1167,
	"./approvalLogs2.js": 1167,
	"./approvalLogsBetShop": 1168,
	"./approvalLogsBetShop.js": 1168,
	"./assignmentQuotaMade": 1169,
	"./assignmentQuotaMade.js": 1169,
	"./assignmentQuotaR": 1170,
	"./assignmentQuotaR.js": 1170,
	"./autoexclusionUsers": 1171,
	"./autoexclusionUsers.js": 1171,
	"./balanceAdjustments": 1172,
	"./balanceAdjustments.js": 1172,
	"./balanceHistory": 1173,
	"./balanceHistory.js": 1173,
	"./balanceHistory2": 1174,
	"./balanceHistory2.js": 1174,
	"./balanceHistoryAdminUser": 1175,
	"./balanceHistoryAdminUser.js": 1175,
	"./balanceHistoryBetShop": 1176,
	"./balanceHistoryBetShop.js": 1176,
	"./balanceHistoryBetShop2": 1177,
	"./balanceHistoryBetShop2.js": 1177,
	"./balanceHistoryForAgent": 1178,
	"./balanceHistoryForAgent.js": 1178,
	"./balanceHistoryForBetShop": 1179,
	"./balanceHistoryForBetShop.js": 1179,
	"./balanceHistoryMachine": 1180,
	"./balanceHistoryMachine.js": 1180,
	"./balanceUsers": 1181,
	"./balanceUsers.js": 1181,
	"./bankAccounts": 1182,
	"./bankAccounts.js": 1182,
	"./banks": 1183,
	"./banks.js": 1183,
	"./betShop": 1184,
	"./betShop.js": 1184,
	"./betShopCompetence": 1185,
	"./betShopCompetence.js": 1185,
	"./betShopManagement": 1186,
	"./betShopManagement.js": 1186,
	"./betShopManagement/addInformationBetShop": 1187,
	"./betShopManagement/addInformationBetShop.js": 1187,
	"./betShopManagement/age": 1188,
	"./betShopManagement/age.js": 1188,
	"./betShopManagement/betShop/detailsBetShop": 977,
	"./betShopManagement/betShop/detailsBetShop.js": 977,
	"./betShopManagement/betShop/filterBetShop": 324,
	"./betShopManagement/betShop/filterBetShop.js": 324,
	"./betShopManagement/betShop/recordBetShop": 326,
	"./betShopManagement/betShop/recordBetShop.js": 326,
	"./betShopManagement/betShop/recordTableBetShop": 90,
	"./betShopManagement/betShop/recordTableBetShop.js": 90,
	"./betShopManagement/betShop/tableBetShop": 325,
	"./betShopManagement/betShop/tableBetShop.js": 325,
	"./betShopManagement/betShopCompetence/detailsBetShop": 1189,
	"./betShopManagement/betShopCompetence/detailsBetShop.js": 1189,
	"./betShopManagement/betShopCompetence/filterBetShop": 327,
	"./betShopManagement/betShopCompetence/filterBetShop.js": 327,
	"./betShopManagement/betShopCompetence/recordBetShop": 1190,
	"./betShopManagement/betShopCompetence/recordBetShop.js": 1190,
	"./betShopManagement/betShopCompetence/recordTableBetShop": 1191,
	"./betShopManagement/betShopCompetence/recordTableBetShop.js": 1191,
	"./betShopManagement/betShopCompetence/tableBetShop": 328,
	"./betShopManagement/betShopCompetence/tableBetShop.js": 328,
	"./betShopManagement/bonusReportBetShop": 1192,
	"./betShopManagement/bonusReportBetShop.js": 1192,
	"./betShopManagement/cashier/betShopAdvertising": 333,
	"./betShopManagement/cashier/betShopAdvertising.js": 333,
	"./betShopManagement/cashier/betShopAdvertisingCashier": 335,
	"./betShopManagement/cashier/betShopAdvertisingCashier.js": 335,
	"./betShopManagement/cashier/betShopCashier": 1193,
	"./betShopManagement/cashier/betShopCashier.js": 1193,
	"./betShopManagement/cashier/betShopComissions": 978,
	"./betShopManagement/cashier/betShopComissions.js": 978,
	"./betShopManagement/cashier/filterCashier": 338,
	"./betShopManagement/cashier/filterCashier.js": 338,
	"./betShopManagement/cashier/tableAdvertising": 334,
	"./betShopManagement/cashier/tableAdvertising.js": 334,
	"./betShopManagement/cashier/tableAdvertisingCashier": 336,
	"./betShopManagement/cashier/tableAdvertisingCashier.js": 336,
	"./betShopManagement/cashier/tableCashier": 91,
	"./betShopManagement/cashier/tableCashier.js": 91,
	"./betShopManagement/cashier/tableComissions": 337,
	"./betShopManagement/cashier/tableComissions.js": 337,
	"./betShopManagement/casinoGamesReportBetShop": 1194,
	"./betShopManagement/casinoGamesReportBetShop.js": 1194,
	"./betShopManagement/comissions": 1195,
	"./betShopManagement/comissions.js": 1195,
	"./betShopManagement/comissions/autoexclusionUsers": 1196,
	"./betShopManagement/comissions/autoexclusionUsers.js": 1196,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers": 1197,
	"./betShopManagement/comissions/autoexclusionUsers/detailsAutoexclusionUsers.js": 1197,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers": 1198,
	"./betShopManagement/comissions/autoexclusionUsers/filterAutoexclusionUsers.js": 1198,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers": 1199,
	"./betShopManagement/comissions/autoexclusionUsers/recordAutoexclusionUsers.js": 1199,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers": 1200,
	"./betShopManagement/comissions/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1200,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers": 1201,
	"./betShopManagement/comissions/autoexclusionUsers/tableAutoexclusionUsers.js": 1201,
	"./betShopManagement/comissions/betsReport/detailsReport": 1202,
	"./betShopManagement/comissions/betsReport/detailsReport.js": 1202,
	"./betShopManagement/comissions/betsReport/filterReport": 1203,
	"./betShopManagement/comissions/betsReport/filterReport.js": 1203,
	"./betShopManagement/comissions/betsReport/recordReport": 1204,
	"./betShopManagement/comissions/betsReport/recordReport.js": 1204,
	"./betShopManagement/comissions/betsReport/recordTableReport": 1205,
	"./betShopManagement/comissions/betsReport/recordTableReport.js": 1205,
	"./betShopManagement/comissions/betsReport/recordTableTransReport": 1206,
	"./betShopManagement/comissions/betsReport/recordTableTransReport.js": 1206,
	"./betShopManagement/comissions/betsReport/recordTransReport": 1207,
	"./betShopManagement/comissions/betsReport/recordTransReport.js": 1207,
	"./betShopManagement/comissions/betsReport/tableReport": 1208,
	"./betShopManagement/comissions/betsReport/tableReport.js": 1208,
	"./betShopManagement/comissions/betsReportBetShop": 1209,
	"./betShopManagement/comissions/betsReportBetShop.js": 1209,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport": 1210,
	"./betShopManagement/comissions/bonusReport/detailsBonusReport.js": 1210,
	"./betShopManagement/comissions/bonusReport/filterBonusReport": 1211,
	"./betShopManagement/comissions/bonusReport/filterBonusReport.js": 1211,
	"./betShopManagement/comissions/bonusReport/recordBonusReport": 1212,
	"./betShopManagement/comissions/bonusReport/recordBonusReport.js": 1212,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport": 1213,
	"./betShopManagement/comissions/bonusReport/recordTableBonusReport.js": 1213,
	"./betShopManagement/comissions/bonusReport/tableBonusReport": 1214,
	"./betShopManagement/comissions/bonusReport/tableBonusReport.js": 1214,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport": 1215,
	"./betShopManagement/comissions/casinoReport/detailsCasinoReport.js": 1215,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport": 1216,
	"./betShopManagement/comissions/casinoReport/filterCasinoReport.js": 1216,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport": 1217,
	"./betShopManagement/comissions/casinoReport/recordCasinoReport.js": 1217,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport": 1218,
	"./betShopManagement/comissions/casinoReport/recordTableCasinoReport.js": 1218,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport": 1219,
	"./betShopManagement/comissions/casinoReport/tableCasinoReport.js": 1219,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport": 1220,
	"./betShopManagement/comissions/casinoReport2/detailsCasinoReport.js": 1220,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport": 1221,
	"./betShopManagement/comissions/casinoReport2/filterCasinoReport.js": 1221,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport": 1222,
	"./betShopManagement/comissions/casinoReport2/recordCasinoReport.js": 1222,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport": 1223,
	"./betShopManagement/comissions/casinoReport2/recordTableCasinoReport.js": 1223,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport": 1224,
	"./betShopManagement/comissions/casinoReport2/tableCasinoReport.js": 1224,
	"./betShopManagement/comissions/comissions": 1225,
	"./betShopManagement/comissions/comissions.js": 1225,
	"./betShopManagement/comissions/comissions/table": 343,
	"./betShopManagement/comissions/comissions/table.js": 343,
	"./betShopManagement/comissions/comissionsReportBetShop": 1226,
	"./betShopManagement/comissions/comissionsReportBetShop.js": 1226,
	"./betShopManagement/comissions/comissionsReportBetShopDetail": 1227,
	"./betShopManagement/comissions/comissionsReportBetShopDetail.js": 1227,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports": 1228,
	"./betShopManagement/comissions/comissions_report/detailsDepositReports.js": 1228,
	"./betShopManagement/comissions/comissions_report/filter": 344,
	"./betShopManagement/comissions/comissions_report/filter.js": 344,
	"./betShopManagement/comissions/comissions_report/recordDepositReports": 1229,
	"./betShopManagement/comissions/comissions_report/recordDepositReports.js": 1229,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports": 1230,
	"./betShopManagement/comissions/comissions_report/recordTableDepositReports.js": 1230,
	"./betShopManagement/comissions/comissions_report/table": 345,
	"./betShopManagement/comissions/comissions_report/table.js": 345,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports": 1231,
	"./betShopManagement/comissions/comissions_report_detail/detailsDepositReports.js": 1231,
	"./betShopManagement/comissions/comissions_report_detail/filter": 346,
	"./betShopManagement/comissions/comissions_report_detail/filter.js": 346,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports": 1232,
	"./betShopManagement/comissions/comissions_report_detail/recordDepositReports.js": 1232,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports": 1233,
	"./betShopManagement/comissions/comissions_report_detail/recordTableDepositReports.js": 1233,
	"./betShopManagement/comissions/comissions_report_detail/table": 347,
	"./betShopManagement/comissions/comissions_report_detail/table.js": 347,
	"./betShopManagement/comissions/expenses": 1234,
	"./betShopManagement/comissions/expenses.js": 1234,
	"./betShopManagement/comissions/expenses/filter": 1235,
	"./betShopManagement/comissions/expenses/filter.js": 1235,
	"./betShopManagement/comissions/expenses/table": 1236,
	"./betShopManagement/comissions/expenses/table.js": 1236,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja": 1237,
	"./betShopManagement/comissions/flujocaja/detailsFlujoCaja.js": 1237,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja": 1238,
	"./betShopManagement/comissions/flujocaja/filterFlujoCaja.js": 1238,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja": 1239,
	"./betShopManagement/comissions/flujocaja/recordFlujoCaja.js": 1239,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja": 1240,
	"./betShopManagement/comissions/flujocaja/recordTableFlujoCaja.js": 1240,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja": 1241,
	"./betShopManagement/comissions/flujocaja/tableFlujoCaja.js": 1241,
	"./betShopManagement/comissions/incomes": 1242,
	"./betShopManagement/comissions/incomes.js": 1242,
	"./betShopManagement/comissions/incomes/filter": 1243,
	"./betShopManagement/comissions/incomes/filter.js": 1243,
	"./betShopManagement/comissions/incomes/table": 1244,
	"./betShopManagement/comissions/incomes/table.js": 1244,
	"./betShopManagement/comissions/productsThird": 1245,
	"./betShopManagement/comissions/productsThird.js": 1245,
	"./betShopManagement/comissions/productsThird/filter": 1246,
	"./betShopManagement/comissions/productsThird/filter.js": 1246,
	"./betShopManagement/comissions/productsThird/table": 1247,
	"./betShopManagement/comissions/productsThird/table.js": 1247,
	"./betShopManagement/comissions/promotionalCodes": 1248,
	"./betShopManagement/comissions/promotionalCodes.js": 1248,
	"./betShopManagement/comissions/promotionalCodes/filter": 1249,
	"./betShopManagement/comissions/promotionalCodes/filter.js": 1249,
	"./betShopManagement/comissions/promotionalCodes/table": 1250,
	"./betShopManagement/comissions/promotionalCodes/table.js": 1250,
	"./betShopManagement/comissions/withdrawalRequests": 1251,
	"./betShopManagement/comissions/withdrawalRequests.js": 1251,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests": 350,
	"./betShopManagement/comissions/withdrawalRequests/detailsWithdrawalRequests.js": 350,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest": 348,
	"./betShopManagement/comissions/withdrawalRequests/filterWithdrawalRequest.js": 348,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest": 1252,
	"./betShopManagement/comissions/withdrawalRequests/recordTableWithdrawalRequest.js": 1252,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest": 351,
	"./betShopManagement/comissions/withdrawalRequests/recordWithdrawalRequest.js": 351,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest": 349,
	"./betShopManagement/comissions/withdrawalRequests/tableWithdrawalRequest.js": 349,
	"./betShopManagement/configuration/changePassword": 1253,
	"./betShopManagement/configuration/changePassword.js": 1253,
	"./betShopManagement/configuration/changePassword/changePasswordView": 352,
	"./betShopManagement/configuration/changePassword/changePasswordView.js": 352,
	"./betShopManagement/configuration/generateToken": 1254,
	"./betShopManagement/configuration/generateToken.js": 1254,
	"./betShopManagement/configuration/generateToken/filter": 353,
	"./betShopManagement/configuration/generateToken/filter.js": 353,
	"./betShopManagement/configuration/generateToken/table": 354,
	"./betShopManagement/configuration/generateToken/table.js": 354,
	"./betShopManagement/configuration/qrgoogle": 1255,
	"./betShopManagement/configuration/qrgoogle.js": 1255,
	"./betShopManagement/configuration/securityChanges": 1256,
	"./betShopManagement/configuration/securityChanges.js": 1256,
	"./betShopManagement/configuration/securityChanges/filter": 979,
	"./betShopManagement/configuration/securityChanges/filter.js": 979,
	"./betShopManagement/configuration/securityChanges/table": 355,
	"./betShopManagement/configuration/securityChanges/table.js": 355,
	"./betShopManagement/configurationBetShop": 1257,
	"./betShopManagement/configurationBetShop.js": 1257,
	"./betShopManagement/depositReportBetShop": 1258,
	"./betShopManagement/depositReportBetShop.js": 1258,
	"./betShopManagement/financescustomerBetShop": 1259,
	"./betShopManagement/financescustomerBetShop.js": 1259,
	"./betShopManagement/financial/bankAccountsBetShop": 1260,
	"./betShopManagement/financial/bankAccountsBetShop.js": 1260,
	"./betShopManagement/financial/bankAccountsBetShop/details": 1261,
	"./betShopManagement/financial/bankAccountsBetShop/details.js": 1261,
	"./betShopManagement/financial/bankAccountsBetShop/filter": 358,
	"./betShopManagement/financial/bankAccountsBetShop/filter.js": 358,
	"./betShopManagement/financial/bankAccountsBetShop/record": 1262,
	"./betShopManagement/financial/bankAccountsBetShop/record.js": 1262,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable": 1263,
	"./betShopManagement/financial/bankAccountsBetShop/recordTable.js": 1263,
	"./betShopManagement/financial/bankAccountsBetShop/table": 359,
	"./betShopManagement/financial/bankAccountsBetShop/table.js": 359,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup": 1264,
	"./betShopManagement/financial/bankAccountsBetShop/tablePopup.js": 1264,
	"./betShopManagement/financial/informationFinancialBetShop": 1265,
	"./betShopManagement/financial/informationFinancialBetShop.js": 1265,
	"./betShopManagement/financial/withdrawalRequestsBetShop": 1266,
	"./betShopManagement/financial/withdrawalRequestsBetShop.js": 1266,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/detailsWithdrawalRequestsBetShop.js": 137,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop": 360,
	"./betShopManagement/financial/withdrawalRequestsBetShop/filterWithdrawalRequestBetShop.js": 360,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop": 362,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordTableWithdrawalRequestBetShop.js": 362,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/recordWithdrawalRequestBetShop.js": 138,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop": 361,
	"./betShopManagement/financial/withdrawalRequestsBetShop/tableWithdrawalRequestBetShop.js": 361,
	"./betShopManagement/flujoCajaBetShop": 1267,
	"./betShopManagement/flujoCajaBetShop.js": 1267,
	"./betShopManagement/geo": 1268,
	"./betShopManagement/geo.js": 1268,
	"./betShopManagement/informationBetShop": 1269,
	"./betShopManagement/informationBetShop.js": 1269,
	"./betShopManagement/money": 1270,
	"./betShopManagement/money.js": 1270,
	"./betShopManagement/paymenthistory": 1271,
	"./betShopManagement/paymenthistory.js": 1271,
	"./betShopManagement/positions": 1272,
	"./betShopManagement/positions.js": 1272,
	"./betShopManagement/reports/autoexclusionUsers": 1273,
	"./betShopManagement/reports/autoexclusionUsers.js": 1273,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1274,
	"./betShopManagement/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1274,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers": 1275,
	"./betShopManagement/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1275,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers": 1276,
	"./betShopManagement/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1276,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1277,
	"./betShopManagement/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1277,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers": 1278,
	"./betShopManagement/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1278,
	"./betShopManagement/reports/balanceTransactionReport": 1279,
	"./betShopManagement/reports/balanceTransactionReport.js": 1279,
	"./betShopManagement/reports/balanceTransactionReport/filter": 365,
	"./betShopManagement/reports/balanceTransactionReport/filter.js": 365,
	"./betShopManagement/reports/balanceTransactionReport/table": 366,
	"./betShopManagement/reports/balanceTransactionReport/table.js": 366,
	"./betShopManagement/reports/betsReport/detailsReport": 1280,
	"./betShopManagement/reports/betsReport/detailsReport.js": 1280,
	"./betShopManagement/reports/betsReport/filterReport": 49,
	"./betShopManagement/reports/betsReport/filterReport.js": 49,
	"./betShopManagement/reports/betsReport/recordReport": 45,
	"./betShopManagement/reports/betsReport/recordReport.js": 45,
	"./betShopManagement/reports/betsReport/recordTableReport": 1281,
	"./betShopManagement/reports/betsReport/recordTableReport.js": 1281,
	"./betShopManagement/reports/betsReport/recordTableTransReport": 89,
	"./betShopManagement/reports/betsReport/recordTableTransReport.js": 89,
	"./betShopManagement/reports/betsReport/recordTransReport": 44,
	"./betShopManagement/reports/betsReport/recordTransReport.js": 44,
	"./betShopManagement/reports/betsReport/tableReport": 50,
	"./betShopManagement/reports/betsReport/tableReport.js": 50,
	"./betShopManagement/reports/betsReportBetShop": 1282,
	"./betShopManagement/reports/betsReportBetShop.js": 1282,
	"./betShopManagement/reports/bonusReport/detailsBonusReport": 331,
	"./betShopManagement/reports/bonusReport/detailsBonusReport.js": 331,
	"./betShopManagement/reports/bonusReport/filterBonusReport": 329,
	"./betShopManagement/reports/bonusReport/filterBonusReport.js": 329,
	"./betShopManagement/reports/bonusReport/recordBonusReport": 332,
	"./betShopManagement/reports/bonusReport/recordBonusReport.js": 332,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport": 1283,
	"./betShopManagement/reports/bonusReport/recordTableBonusReport.js": 1283,
	"./betShopManagement/reports/bonusReport/tableBonusReport": 330,
	"./betShopManagement/reports/bonusReport/tableBonusReport.js": 330,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport": 341,
	"./betShopManagement/reports/casinoReport/detailsCasinoReport.js": 341,
	"./betShopManagement/reports/casinoReport/filterCasinoReport": 339,
	"./betShopManagement/reports/casinoReport/filterCasinoReport.js": 339,
	"./betShopManagement/reports/casinoReport/recordCasinoReport": 342,
	"./betShopManagement/reports/casinoReport/recordCasinoReport.js": 342,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport": 1284,
	"./betShopManagement/reports/casinoReport/recordTableCasinoReport.js": 1284,
	"./betShopManagement/reports/casinoReport/tableCasinoReport": 340,
	"./betShopManagement/reports/casinoReport/tableCasinoReport.js": 340,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport": 1285,
	"./betShopManagement/reports/casinoReport2/detailsCasinoReport.js": 1285,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport": 1286,
	"./betShopManagement/reports/casinoReport2/filterCasinoReport.js": 1286,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport": 1287,
	"./betShopManagement/reports/casinoReport2/recordCasinoReport.js": 1287,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport": 1288,
	"./betShopManagement/reports/casinoReport2/recordTableCasinoReport.js": 1288,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport": 1289,
	"./betShopManagement/reports/casinoReport2/tableCasinoReport.js": 1289,
	"./betShopManagement/reports/deposit_report/detailsDepositReports": 980,
	"./betShopManagement/reports/deposit_report/detailsDepositReports.js": 980,
	"./betShopManagement/reports/deposit_report/filterDepositReports": 356,
	"./betShopManagement/reports/deposit_report/filterDepositReports.js": 356,
	"./betShopManagement/reports/deposit_report/recordDepositReports": 136,
	"./betShopManagement/reports/deposit_report/recordDepositReports.js": 136,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports": 1290,
	"./betShopManagement/reports/deposit_report/recordTableDepositReports.js": 1290,
	"./betShopManagement/reports/deposit_report/tableDepositReports": 357,
	"./betShopManagement/reports/deposit_report/tableDepositReports.js": 357,
	"./betShopManagement/reports/expenses": 1291,
	"./betShopManagement/reports/expenses.js": 1291,
	"./betShopManagement/reports/expenses/filter": 51,
	"./betShopManagement/reports/expenses/filter.js": 51,
	"./betShopManagement/reports/expenses/table": 52,
	"./betShopManagement/reports/expenses/table.js": 52,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja": 1292,
	"./betShopManagement/reports/flujocaja/detailsFlujoCaja.js": 1292,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja": 363,
	"./betShopManagement/reports/flujocaja/filterFlujoCaja.js": 363,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja": 1293,
	"./betShopManagement/reports/flujocaja/recordFlujoCaja.js": 1293,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja": 1294,
	"./betShopManagement/reports/flujocaja/recordTableFlujoCaja.js": 1294,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja": 364,
	"./betShopManagement/reports/flujocaja/tableFlujoCaja.js": 364,
	"./betShopManagement/reports/historyMovement": 1295,
	"./betShopManagement/reports/historyMovement.js": 1295,
	"./betShopManagement/reports/historyMovement/filter": 367,
	"./betShopManagement/reports/historyMovement/filter.js": 367,
	"./betShopManagement/reports/historyMovement/table": 368,
	"./betShopManagement/reports/historyMovement/table.js": 368,
	"./betShopManagement/reports/incomes": 1296,
	"./betShopManagement/reports/incomes.js": 1296,
	"./betShopManagement/reports/incomes/filter": 53,
	"./betShopManagement/reports/incomes/filter.js": 53,
	"./betShopManagement/reports/incomes/table": 54,
	"./betShopManagement/reports/incomes/table.js": 54,
	"./betShopManagement/reports/productsThird": 1297,
	"./betShopManagement/reports/productsThird.js": 1297,
	"./betShopManagement/reports/productsThird/filter": 55,
	"./betShopManagement/reports/productsThird/filter.js": 55,
	"./betShopManagement/reports/productsThird/table": 56,
	"./betShopManagement/reports/productsThird/table.js": 56,
	"./betShopManagement/reports/promotionalCodes": 1298,
	"./betShopManagement/reports/promotionalCodes.js": 1298,
	"./betShopManagement/reports/promotionalCodes/filter": 57,
	"./betShopManagement/reports/promotionalCodes/filter.js": 57,
	"./betShopManagement/reports/promotionalCodes/table": 58,
	"./betShopManagement/reports/promotionalCodes/table.js": 58,
	"./betShopManagement/reports/userAffiliatesBetShop": 1299,
	"./betShopManagement/reports/userAffiliatesBetShop.js": 1299,
	"./betShopManagement/reports/userAffiliatesBetShop/filter": 369,
	"./betShopManagement/reports/userAffiliatesBetShop/filter.js": 369,
	"./betShopManagement/reports/userAffiliatesBetShop/table": 370,
	"./betShopManagement/reports/userAffiliatesBetShop/table.js": 370,
	"./betShopManagement/reportscustomerBetShop": 1300,
	"./betShopManagement/reportscustomerBetShop.js": 1300,
	"./betShopManagement/statisticsBetShop": 1301,
	"./betShopManagement/statisticsBetShop.js": 1301,
	"./betShopManagement/tags": 1302,
	"./betShopManagement/tags.js": 1302,
	"./betsHistory": 1303,
	"./betsHistory.js": 1303,
	"./betsHistory2": 1304,
	"./betsHistory2.js": 1304,
	"./betsReport": 1305,
	"./betsReport.js": 1305,
	"./betsReportBetShop": 1306,
	"./betsReportBetShop.js": 1306,
	"./betsReportSecond": 1307,
	"./betsReportSecond.js": 1307,
	"./betsSport": 1308,
	"./betsSport.js": 1308,
	"./betsSportLive": 1309,
	"./betsSportLive.js": 1309,
	"./betsVirtual": 1310,
	"./betsVirtual.js": 1310,
	"./betting": 1311,
	"./betting.js": 1311,
	"./bettingVirtual": 1312,
	"./bettingVirtual.js": 1312,
	"./blockchains": 1313,
	"./blockchains.js": 1313,
	"./bonusReport": 1314,
	"./bonusReport.js": 1314,
	"./bonusReport2": 1315,
	"./bonusReport2.js": 1315,
	"./cash/bankAccounts/filter": 319,
	"./cash/bankAccounts/filter.js": 319,
	"./cash/bankAccounts/table": 320,
	"./cash/bankAccounts/table.js": 320,
	"./cash/bets/betHistory": 92,
	"./cash/bets/betHistory.js": 92,
	"./cash/bets/betHistory2": 1316,
	"./cash/bets/betHistory2.js": 1316,
	"./cash/bets/sport": 70,
	"./cash/bets/sport.js": 70,
	"./cash/bets/sportLive": 375,
	"./cash/bets/sportLive.js": 375,
	"./cash/bets/sportVirtual": 376,
	"./cash/bets/sportVirtual.js": 376,
	"./cash/closeBox-edit/creditCards": 383,
	"./cash/closeBox-edit/creditCards.js": 383,
	"./cash/closeBox-edit/otherExpenses": 384,
	"./cash/closeBox-edit/otherExpenses.js": 384,
	"./cash/closeBox-edit/otherIncome": 385,
	"./cash/closeBox-edit/otherIncome.js": 385,
	"./cash/closeBox-edit/products": 386,
	"./cash/closeBox-edit/products.js": 386,
	"./cash/closeBox-edit/total": 387,
	"./cash/closeBox-edit/total.js": 387,
	"./cash/closeBox-old/otherExpenses": 1317,
	"./cash/closeBox-old/otherExpenses.js": 1317,
	"./cash/closeBox-old/otherIncome": 1318,
	"./cash/closeBox-old/otherIncome.js": 1318,
	"./cash/closeBox-old/products": 1319,
	"./cash/closeBox-old/products.js": 1319,
	"./cash/closeBox-old/total": 1320,
	"./cash/closeBox-old/total.js": 1320,
	"./cash/closeBox/creditCards": 388,
	"./cash/closeBox/creditCards.js": 388,
	"./cash/closeBox/otherExpenses": 96,
	"./cash/closeBox/otherExpenses.js": 96,
	"./cash/closeBox/otherIncome": 97,
	"./cash/closeBox/otherIncome.js": 97,
	"./cash/closeBox/products": 98,
	"./cash/closeBox/products.js": 98,
	"./cash/closeBox/total": 99,
	"./cash/closeBox/total.js": 99,
	"./cash/flujocaja/detailsFlujoCaja": 389,
	"./cash/flujocaja/detailsFlujoCaja.js": 389,
	"./cash/flujocaja/filterFlujoCaja": 390,
	"./cash/flujocaja/filterFlujoCaja.js": 390,
	"./cash/flujocaja/recordFlujoCaja": 391,
	"./cash/flujocaja/recordFlujoCaja.js": 391,
	"./cash/flujocaja/recordTableFlujoCaja": 14,
	"./cash/flujocaja/recordTableFlujoCaja.js": 14,
	"./cash/flujocaja/tableFlujoCaja": 392,
	"./cash/flujocaja/tableFlujoCaja.js": 392,
	"./cash/pagoNotaRetiro/PagoNotaRetiro": 393,
	"./cash/pagoNotaRetiro/PagoNotaRetiro.js": 393,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro": 394,
	"./cash/pagoNotaRetiro/filterPagoNotaRetiro.js": 394,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro": 981,
	"./cash/pagoNotaRetiro/tablePagoNotaRetiro.js": 981,
	"./cash/pagopremio/PagoPremio": 395,
	"./cash/pagopremio/PagoPremio.js": 395,
	"./cash/pagopremio/detailsPagoPremio": 396,
	"./cash/pagopremio/detailsPagoPremio.js": 396,
	"./cash/pagopremio/filterPagoPremio": 397,
	"./cash/pagopremio/filterPagoPremio.js": 397,
	"./cash/pagopremio/recordPagoPremio": 398,
	"./cash/pagopremio/recordPagoPremio.js": 398,
	"./cash/pagopremio/recordTablePagoPremio": 1321,
	"./cash/pagopremio/recordTablePagoPremio.js": 1321,
	"./cash/pagopremio/tablePagoPremio": 399,
	"./cash/pagopremio/tablePagoPremio.js": 399,
	"./cash/pagopremiovirtuales/PagoPremio": 400,
	"./cash/pagopremiovirtuales/PagoPremio.js": 400,
	"./cash/pagopremiovirtuales/detailsPagoPremio": 401,
	"./cash/pagopremiovirtuales/detailsPagoPremio.js": 401,
	"./cash/pagopremiovirtuales/filterPagoPremio": 402,
	"./cash/pagopremiovirtuales/filterPagoPremio.js": 402,
	"./cash/pagopremiovirtuales/recordPagoPremio": 403,
	"./cash/pagopremiovirtuales/recordPagoPremio.js": 403,
	"./cash/pagopremiovirtuales/recordTablePagoPremio": 1322,
	"./cash/pagopremiovirtuales/recordTablePagoPremio.js": 1322,
	"./cash/pagopremiovirtuales/tablePagoPremio": 404,
	"./cash/pagopremiovirtuales/tablePagoPremio.js": 404,
	"./cash/payPrizesLoyalty/PagoPremio": 405,
	"./cash/payPrizesLoyalty/PagoPremio.js": 405,
	"./cash/payPrizesLoyalty/filterPagoPremio": 406,
	"./cash/payPrizesLoyalty/filterPagoPremio.js": 406,
	"./cash/recargacredito/RecargaCredito": 407,
	"./cash/recargacredito/RecargaCredito.js": 407,
	"./cash/recargacredito/filterRecargaCredito": 408,
	"./cash/recargacredito/filterRecargaCredito.js": 408,
	"./cash/recargacreditoAgent/RecargaCredito": 409,
	"./cash/recargacreditoAgent/RecargaCredito.js": 409,
	"./cash/recargacreditoAgent/filterRecargaCredito": 410,
	"./cash/recargacreditoAgent/filterRecargaCredito.js": 410,
	"./cash/withdrawal/filter": 411,
	"./cash/withdrawal/filter.js": 411,
	"./cash/withdrawal/table": 412,
	"./cash/withdrawal/table.js": 412,
	"./cashiers": 1323,
	"./cashiers.js": 1323,
	"./casinoGamesReport": 1324,
	"./casinoGamesReport.js": 1324,
	"./casinoGamesReport2": 1325,
	"./casinoGamesReport2.js": 1325,
	"./categories": 1326,
	"./categories.js": 1326,
	"./categoriesProducts": 1327,
	"./categoriesProducts.js": 1327,
	"./closeBox": 1328,
	"./closeBox-old": 1329,
	"./closeBox-old.js": 1329,
	"./closeBox.js": 1328,
	"./closeBoxEdit": 1330,
	"./closeBoxEdit.js": 1330,
	"./comissionsReport": 1331,
	"./comissionsReport.js": 1331,
	"./comissionsReport2": 1332,
	"./comissionsReport2.js": 1332,
	"./commisionsPay": 1333,
	"./commisionsPay.js": 1333,
	"./competitors/competitors": 1334,
	"./competitors/competitors.js": 1334,
	"./competitors/filter": 429,
	"./competitors/filter.js": 429,
	"./competitors/table": 430,
	"./competitors/table.js": 430,
	"./consolidatedIncomeOwner": 1335,
	"./consolidatedIncomeOwner.js": 1335,
	"./consolidatedIncomeOwner2": 1336,
	"./consolidatedIncomeOwner2.js": 1336,
	"./contingency": 1337,
	"./contingency.js": 1337,
	"./countries": 1338,
	"./countries.js": 1338,
	"./coupons": 1339,
	"./coupons.js": 1339,
	"./couponsReport": 1340,
	"./couponsReport.js": 1340,
	"./cryptos": 1341,
	"./cryptos.js": 1341,
	"./customReport": 1342,
	"./customReport.js": 1342,
	"./customers": 1343,
	"./customers.js": 1343,
	"./customers/age": 34,
	"./customers/age.js": 34,
	"./customers/bonusReport": 1344,
	"./customers/bonusReport.js": 1344,
	"./customers/bonusReport2": 1345,
	"./customers/bonusReport2.js": 1345,
	"./customers/casinoGamesReport": 1346,
	"./customers/casinoGamesReport.js": 1346,
	"./customers/configuration": 1347,
	"./customers/configuration.js": 1347,
	"./customers/configuration/changePassword": 1348,
	"./customers/configuration/changePassword.js": 1348,
	"./customers/configuration/changePassword/changePasswordView": 104,
	"./customers/configuration/changePassword/changePasswordView.js": 104,
	"./customers/configuration/generateToken": 1349,
	"./customers/configuration/generateToken.js": 1349,
	"./customers/configuration/generateToken/filter": 105,
	"./customers/configuration/generateToken/filter.js": 105,
	"./customers/configuration/generateToken/table": 106,
	"./customers/configuration/generateToken/table.js": 106,
	"./customers/configuration/limitChanges": 1350,
	"./customers/configuration/limitChanges.js": 1350,
	"./customers/configuration/securityChanges": 1351,
	"./customers/configuration/securityChanges.js": 1351,
	"./customers/configuration/securityChanges/filter": 83,
	"./customers/configuration/securityChanges/filter.js": 83,
	"./customers/configuration/securityChanges/securityForm": 85,
	"./customers/configuration/securityChanges/securityForm.js": 85,
	"./customers/configuration/securityChanges/table": 48,
	"./customers/configuration/securityChanges/table.js": 48,
	"./customers/configuration/securityChanges2": 1352,
	"./customers/configuration/securityChanges2.js": 1352,
	"./customers/depositReport": 1353,
	"./customers/depositReport.js": 1353,
	"./customers/financescustomer": 1354,
	"./customers/financescustomer.js": 1354,
	"./customers/financial/bankAccounts": 1355,
	"./customers/financial/bankAccounts.js": 1355,
	"./customers/financial/bankAccounts/details": 986,
	"./customers/financial/bankAccounts/details.js": 986,
	"./customers/financial/bankAccounts/filter": 109,
	"./customers/financial/bankAccounts/filter.js": 109,
	"./customers/financial/bankAccounts/record": 448,
	"./customers/financial/bankAccounts/record.js": 448,
	"./customers/financial/bankAccounts/recordTable": 1356,
	"./customers/financial/bankAccounts/recordTable.js": 1356,
	"./customers/financial/bankAccounts/table": 110,
	"./customers/financial/bankAccounts/table.js": 110,
	"./customers/financial/bankAccounts/tablePopup": 1357,
	"./customers/financial/bankAccounts/tablePopup.js": 1357,
	"./customers/financial/informationFinancial": 1358,
	"./customers/financial/informationFinancial.js": 1358,
	"./customers/financial/withdrawalRequests": 1359,
	"./customers/financial/withdrawalRequests.js": 1359,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests": 77,
	"./customers/financial/withdrawalRequests/detailsWithdrawalRequests.js": 77,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest": 111,
	"./customers/financial/withdrawalRequests/filterWithdrawalRequest.js": 111,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest": 63,
	"./customers/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 63,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest": 78,
	"./customers/financial/withdrawalRequests/recordWithdrawalRequest.js": 78,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest": 112,
	"./customers/financial/withdrawalRequests/tableWithdrawalRequest.js": 112,
	"./customers/geo": 19,
	"./customers/geo.js": 19,
	"./customers/information": 1360,
	"./customers/information.js": 1360,
	"./customers/money": 33,
	"./customers/money.js": 33,
	"./customers/paymenthistory": 449,
	"./customers/paymenthistory.js": 449,
	"./customers/players/filter": 450,
	"./customers/players/filter.js": 450,
	"./customers/players/table": 451,
	"./customers/players/table.js": 451,
	"./customers/players2/filter": 452,
	"./customers/players2/filter.js": 452,
	"./customers/players2/table": 453,
	"./customers/players2/table.js": 453,
	"./customers/playersAggregator/filter": 454,
	"./customers/playersAggregator/filter.js": 454,
	"./customers/playersAggregator/table": 455,
	"./customers/playersAggregator/table.js": 455,
	"./customers/positions": 20,
	"./customers/positions.js": 20,
	"./customers/referralsReport": 1361,
	"./customers/referralsReport.js": 1361,
	"./customers/reports/autoexclusionUsers": 1362,
	"./customers/reports/autoexclusionUsers.js": 1362,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers": 27,
	"./customers/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 27,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers": 21,
	"./customers/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 21,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers": 67,
	"./customers/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 67,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 88,
	"./customers/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 88,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers": 22,
	"./customers/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 22,
	"./customers/reports/balanceAdjustments": 1363,
	"./customers/reports/balanceAdjustments.js": 1363,
	"./customers/reports/balanceAdjustments/filter": 458,
	"./customers/reports/balanceAdjustments/filter.js": 458,
	"./customers/reports/balanceAdjustments/table": 459,
	"./customers/reports/balanceAdjustments/table.js": 459,
	"./customers/reports/balanceHistory": 1364,
	"./customers/reports/balanceHistory.js": 1364,
	"./customers/reports/balanceHistory/filter": 460,
	"./customers/reports/balanceHistory/filter.js": 460,
	"./customers/reports/balanceHistory/table": 461,
	"./customers/reports/balanceHistory/table.js": 461,
	"./customers/reports/betsReport": 1365,
	"./customers/reports/betsReport.js": 1365,
	"./customers/reports/betsReport/detailsReport": 1366,
	"./customers/reports/betsReport/detailsReport.js": 1366,
	"./customers/reports/betsReport/filterReport": 113,
	"./customers/reports/betsReport/filterReport.js": 113,
	"./customers/reports/betsReport/recordReport": 36,
	"./customers/reports/betsReport/recordReport.js": 36,
	"./customers/reports/betsReport/recordTableReport": 41,
	"./customers/reports/betsReport/recordTableReport.js": 41,
	"./customers/reports/betsReport/recordTableTransReport": 40,
	"./customers/reports/betsReport/recordTableTransReport.js": 40,
	"./customers/reports/betsReport/recordTransReport": 79,
	"./customers/reports/betsReport/recordTransReport.js": 79,
	"./customers/reports/betsReport/tableReport": 114,
	"./customers/reports/betsReport/tableReport.js": 114,
	"./customers/reports/bonusReport/detailsBonusReport": 72,
	"./customers/reports/bonusReport/detailsBonusReport.js": 72,
	"./customers/reports/bonusReport/filterBonusReport": 100,
	"./customers/reports/bonusReport/filterBonusReport.js": 100,
	"./customers/reports/bonusReport/recordBonusReport": 73,
	"./customers/reports/bonusReport/recordBonusReport.js": 73,
	"./customers/reports/bonusReport/recordTableBonusReport": 62,
	"./customers/reports/bonusReport/recordTableBonusReport.js": 62,
	"./customers/reports/bonusReport/tableBonusReport": 101,
	"./customers/reports/bonusReport/tableBonusReport.js": 101,
	"./customers/reports/bonusReport2/detailsBonusReport": 148,
	"./customers/reports/bonusReport2/detailsBonusReport.js": 148,
	"./customers/reports/bonusReport2/filterBonusReport": 446,
	"./customers/reports/bonusReport2/filterBonusReport.js": 446,
	"./customers/reports/bonusReport2/recordBonusReport": 149,
	"./customers/reports/bonusReport2/recordBonusReport.js": 149,
	"./customers/reports/bonusReport2/recordTableBonusReport": 1367,
	"./customers/reports/bonusReport2/recordTableBonusReport.js": 1367,
	"./customers/reports/bonusReport2/tableBonusReport": 447,
	"./customers/reports/bonusReport2/tableBonusReport.js": 447,
	"./customers/reports/casinoReport/detailsCasinoReport": 74,
	"./customers/reports/casinoReport/detailsCasinoReport.js": 74,
	"./customers/reports/casinoReport/filterCasinoReport": 102,
	"./customers/reports/casinoReport/filterCasinoReport.js": 102,
	"./customers/reports/casinoReport/recordCasinoReport": 75,
	"./customers/reports/casinoReport/recordCasinoReport.js": 75,
	"./customers/reports/casinoReport/recordTableCasinoReport": 39,
	"./customers/reports/casinoReport/recordTableCasinoReport.js": 39,
	"./customers/reports/casinoReport/tableCasinoReport": 103,
	"./customers/reports/casinoReport/tableCasinoReport.js": 103,
	"./customers/reports/casinoReport2/detailsCasinoReport": 1368,
	"./customers/reports/casinoReport2/detailsCasinoReport.js": 1368,
	"./customers/reports/casinoReport2/filterCasinoReport": 1369,
	"./customers/reports/casinoReport2/filterCasinoReport.js": 1369,
	"./customers/reports/casinoReport2/recordCasinoReport": 1370,
	"./customers/reports/casinoReport2/recordCasinoReport.js": 1370,
	"./customers/reports/casinoReport2/recordTableCasinoReport": 1371,
	"./customers/reports/casinoReport2/recordTableCasinoReport.js": 1371,
	"./customers/reports/casinoReport2/tableCasinoReport": 1372,
	"./customers/reports/casinoReport2/tableCasinoReport.js": 1372,
	"./customers/reports/deposit_report/detailsDepositReports": 171,
	"./customers/reports/deposit_report/detailsDepositReports.js": 171,
	"./customers/reports/deposit_report/filterDepositReports": 107,
	"./customers/reports/deposit_report/filterDepositReports.js": 107,
	"./customers/reports/deposit_report/recordDepositReports": 76,
	"./customers/reports/deposit_report/recordDepositReports.js": 76,
	"./customers/reports/deposit_report/recordTableDepositReports": 18,
	"./customers/reports/deposit_report/recordTableDepositReports.js": 18,
	"./customers/reports/deposit_report/tableDepositReports": 108,
	"./customers/reports/deposit_report/tableDepositReports.js": 108,
	"./customers/reports/historyMovement": 1373,
	"./customers/reports/historyMovement.js": 1373,
	"./customers/reports/historyMovement/filter": 462,
	"./customers/reports/historyMovement/filter.js": 462,
	"./customers/reports/historyMovement/table": 463,
	"./customers/reports/historyMovement/table.js": 463,
	"./customers/reports/historyPoints": 1374,
	"./customers/reports/historyPoints.js": 1374,
	"./customers/reports/historyPoints/filter": 464,
	"./customers/reports/historyPoints/filter.js": 464,
	"./customers/reports/historyPoints/table": 465,
	"./customers/reports/historyPoints/table.js": 465,
	"./customers/reports/logsUser": 1375,
	"./customers/reports/logsUser.js": 1375,
	"./customers/reports/logsUser/filter": 466,
	"./customers/reports/logsUser/filter.js": 466,
	"./customers/reports/logsUser/table": 467,
	"./customers/reports/logsUser/table.js": 467,
	"./customers/reports/notesUser": 1376,
	"./customers/reports/notesUser.js": 1376,
	"./customers/reports/notesUser/filter": 468,
	"./customers/reports/notesUser/filter.js": 468,
	"./customers/reports/notesUser/table": 469,
	"./customers/reports/notesUser/table.js": 469,
	"./customers/reports/referralsReport/filterReferralsReports": 456,
	"./customers/reports/referralsReport/filterReferralsReports.js": 456,
	"./customers/reports/referralsReport/recordReferralsReports": 1377,
	"./customers/reports/referralsReport/recordReferralsReports.js": 1377,
	"./customers/reports/referralsReport/recordTableReferralsReports": 1378,
	"./customers/reports/referralsReport/recordTableReferralsReports.js": 1378,
	"./customers/reports/referralsReport/tableReferralsReports": 457,
	"./customers/reports/referralsReport/tableReferralsReports.js": 457,
	"./customers/reports/registeredDocument": 1379,
	"./customers/reports/registeredDocument.js": 1379,
	"./customers/reports/registeredDocuments/filter": 470,
	"./customers/reports/registeredDocuments/filter.js": 470,
	"./customers/reports/registeredDocuments/table": 471,
	"./customers/reports/registeredDocuments/table.js": 471,
	"./customers/reports/sessionsReport": 1380,
	"./customers/reports/sessionsReport.js": 1380,
	"./customers/reports/sessionsReport/detailsSessionsReport": 474,
	"./customers/reports/sessionsReport/detailsSessionsReport.js": 474,
	"./customers/reports/sessionsReport/filterSessionsReport": 472,
	"./customers/reports/sessionsReport/filterSessionsReport.js": 472,
	"./customers/reports/sessionsReport/recordSessionsReport": 987,
	"./customers/reports/sessionsReport/recordSessionsReport.js": 987,
	"./customers/reports/sessionsReport/recordTableSessionsReport": 988,
	"./customers/reports/sessionsReport/recordTableSessionsReport.js": 988,
	"./customers/reports/sessionsReport/tableSessionsReport": 473,
	"./customers/reports/sessionsReport/tableSessionsReport.js": 473,
	"./customers/reports/sessionsReport2": 1381,
	"./customers/reports/sessionsReport2.js": 1381,
	"./customers/reports/sessionsReport2/filter": 475,
	"./customers/reports/sessionsReport2/filter.js": 475,
	"./customers/reports/sessionsReport2/table": 476,
	"./customers/reports/sessionsReport2/table.js": 476,
	"./customers/reports/walletsReport": 1382,
	"./customers/reports/walletsReport.js": 1382,
	"./customers/reports/walletsReport/filter": 477,
	"./customers/reports/walletsReport/filter.js": 477,
	"./customers/reports/walletsReport/table": 478,
	"./customers/reports/walletsReport/table.js": 478,
	"./customers/reportscustomer": 1383,
	"./customers/reportscustomer.js": 1383,
	"./customers/statistics": 1384,
	"./customers/statistics.js": 1384,
	"./customers/tags": 35,
	"./customers/tags.js": 35,
	"./customersAggregator": 1385,
	"./customersAggregator.js": 1385,
	"./customersAggregator/age": 1386,
	"./customersAggregator/age.js": 1386,
	"./customersAggregator/bonusReport": 1387,
	"./customersAggregator/bonusReport.js": 1387,
	"./customersAggregator/casinoGamesReport": 1388,
	"./customersAggregator/casinoGamesReport.js": 1388,
	"./customersAggregator/configuration": 1389,
	"./customersAggregator/configuration.js": 1389,
	"./customersAggregator/configuration/changePassword": 1390,
	"./customersAggregator/configuration/changePassword.js": 1390,
	"./customersAggregator/configuration/changePassword/changePasswordView": 1391,
	"./customersAggregator/configuration/changePassword/changePasswordView.js": 1391,
	"./customersAggregator/configuration/generateToken": 1392,
	"./customersAggregator/configuration/generateToken.js": 1392,
	"./customersAggregator/configuration/generateToken/filter": 1393,
	"./customersAggregator/configuration/generateToken/filter.js": 1393,
	"./customersAggregator/configuration/generateToken/table": 1394,
	"./customersAggregator/configuration/generateToken/table.js": 1394,
	"./customersAggregator/configuration/securityChanges": 1395,
	"./customersAggregator/configuration/securityChanges.js": 1395,
	"./customersAggregator/configuration/securityChanges/filter": 1396,
	"./customersAggregator/configuration/securityChanges/filter.js": 1396,
	"./customersAggregator/configuration/securityChanges/table": 1397,
	"./customersAggregator/configuration/securityChanges/table.js": 1397,
	"./customersAggregator/depositReport": 1398,
	"./customersAggregator/depositReport.js": 1398,
	"./customersAggregator/financescustomer": 1399,
	"./customersAggregator/financescustomer.js": 1399,
	"./customersAggregator/financial/bankAccounts": 1400,
	"./customersAggregator/financial/bankAccounts.js": 1400,
	"./customersAggregator/financial/bankAccounts/details": 1401,
	"./customersAggregator/financial/bankAccounts/details.js": 1401,
	"./customersAggregator/financial/bankAccounts/filter": 1402,
	"./customersAggregator/financial/bankAccounts/filter.js": 1402,
	"./customersAggregator/financial/bankAccounts/record": 1403,
	"./customersAggregator/financial/bankAccounts/record.js": 1403,
	"./customersAggregator/financial/bankAccounts/recordTable": 1404,
	"./customersAggregator/financial/bankAccounts/recordTable.js": 1404,
	"./customersAggregator/financial/bankAccounts/table": 1405,
	"./customersAggregator/financial/bankAccounts/table.js": 1405,
	"./customersAggregator/financial/bankAccounts/tablePopup": 1406,
	"./customersAggregator/financial/bankAccounts/tablePopup.js": 1406,
	"./customersAggregator/financial/informationFinancial": 1407,
	"./customersAggregator/financial/informationFinancial.js": 1407,
	"./customersAggregator/financial/withdrawalRequests": 1408,
	"./customersAggregator/financial/withdrawalRequests.js": 1408,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests": 1409,
	"./customersAggregator/financial/withdrawalRequests/detailsWithdrawalRequests.js": 1409,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest": 1410,
	"./customersAggregator/financial/withdrawalRequests/filterWithdrawalRequest.js": 1410,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest": 1411,
	"./customersAggregator/financial/withdrawalRequests/recordTableWithdrawalRequest.js": 1411,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest": 1412,
	"./customersAggregator/financial/withdrawalRequests/recordWithdrawalRequest.js": 1412,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest": 1413,
	"./customersAggregator/financial/withdrawalRequests/tableWithdrawalRequest.js": 1413,
	"./customersAggregator/geo": 1414,
	"./customersAggregator/geo.js": 1414,
	"./customersAggregator/information": 1415,
	"./customersAggregator/information.js": 1415,
	"./customersAggregator/money": 1416,
	"./customersAggregator/money.js": 1416,
	"./customersAggregator/paymenthistory": 1417,
	"./customersAggregator/paymenthistory.js": 1417,
	"./customersAggregator/players/filter": 1418,
	"./customersAggregator/players/filter.js": 1418,
	"./customersAggregator/players/table": 1419,
	"./customersAggregator/players/table.js": 1419,
	"./customersAggregator/playersAggregator/filter": 1420,
	"./customersAggregator/playersAggregator/filter.js": 1420,
	"./customersAggregator/playersAggregator/table": 1421,
	"./customersAggregator/playersAggregator/table.js": 1421,
	"./customersAggregator/positions": 1422,
	"./customersAggregator/positions.js": 1422,
	"./customersAggregator/reports/autoexclusionUsers": 1423,
	"./customersAggregator/reports/autoexclusionUsers.js": 1423,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers": 1424,
	"./customersAggregator/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 1424,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers": 1425,
	"./customersAggregator/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 1425,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers": 1426,
	"./customersAggregator/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 1426,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 1427,
	"./customersAggregator/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 1427,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers": 1428,
	"./customersAggregator/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 1428,
	"./customersAggregator/reports/betsReport": 1429,
	"./customersAggregator/reports/betsReport.js": 1429,
	"./customersAggregator/reports/betsReport/detailsReport": 1430,
	"./customersAggregator/reports/betsReport/detailsReport.js": 1430,
	"./customersAggregator/reports/betsReport/filterReport": 1431,
	"./customersAggregator/reports/betsReport/filterReport.js": 1431,
	"./customersAggregator/reports/betsReport/recordReport": 1432,
	"./customersAggregator/reports/betsReport/recordReport.js": 1432,
	"./customersAggregator/reports/betsReport/recordTableReport": 1433,
	"./customersAggregator/reports/betsReport/recordTableReport.js": 1433,
	"./customersAggregator/reports/betsReport/recordTableTransReport": 1434,
	"./customersAggregator/reports/betsReport/recordTableTransReport.js": 1434,
	"./customersAggregator/reports/betsReport/recordTransReport": 1435,
	"./customersAggregator/reports/betsReport/recordTransReport.js": 1435,
	"./customersAggregator/reports/betsReport/tableReport": 1436,
	"./customersAggregator/reports/betsReport/tableReport.js": 1436,
	"./customersAggregator/reports/bonusReport/detailsBonusReport": 1437,
	"./customersAggregator/reports/bonusReport/detailsBonusReport.js": 1437,
	"./customersAggregator/reports/bonusReport/filterBonusReport": 1438,
	"./customersAggregator/reports/bonusReport/filterBonusReport.js": 1438,
	"./customersAggregator/reports/bonusReport/recordBonusReport": 1439,
	"./customersAggregator/reports/bonusReport/recordBonusReport.js": 1439,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport": 1440,
	"./customersAggregator/reports/bonusReport/recordTableBonusReport.js": 1440,
	"./customersAggregator/reports/bonusReport/tableBonusReport": 1441,
	"./customersAggregator/reports/bonusReport/tableBonusReport.js": 1441,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport": 1442,
	"./customersAggregator/reports/casinoReport/detailsCasinoReport.js": 1442,
	"./customersAggregator/reports/casinoReport/filterCasinoReport": 1443,
	"./customersAggregator/reports/casinoReport/filterCasinoReport.js": 1443,
	"./customersAggregator/reports/casinoReport/recordCasinoReport": 1444,
	"./customersAggregator/reports/casinoReport/recordCasinoReport.js": 1444,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport": 1445,
	"./customersAggregator/reports/casinoReport/recordTableCasinoReport.js": 1445,
	"./customersAggregator/reports/casinoReport/tableCasinoReport": 1446,
	"./customersAggregator/reports/casinoReport/tableCasinoReport.js": 1446,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport": 1447,
	"./customersAggregator/reports/casinoReport2/detailsCasinoReport.js": 1447,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport": 1448,
	"./customersAggregator/reports/casinoReport2/filterCasinoReport.js": 1448,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport": 1449,
	"./customersAggregator/reports/casinoReport2/recordCasinoReport.js": 1449,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport": 1450,
	"./customersAggregator/reports/casinoReport2/recordTableCasinoReport.js": 1450,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport": 1451,
	"./customersAggregator/reports/casinoReport2/tableCasinoReport.js": 1451,
	"./customersAggregator/reports/deposit_report/detailsDepositReports": 1452,
	"./customersAggregator/reports/deposit_report/detailsDepositReports.js": 1452,
	"./customersAggregator/reports/deposit_report/filterDepositReports": 1453,
	"./customersAggregator/reports/deposit_report/filterDepositReports.js": 1453,
	"./customersAggregator/reports/deposit_report/recordDepositReports": 1454,
	"./customersAggregator/reports/deposit_report/recordDepositReports.js": 1454,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports": 1455,
	"./customersAggregator/reports/deposit_report/recordTableDepositReports.js": 1455,
	"./customersAggregator/reports/deposit_report/tableDepositReports": 1456,
	"./customersAggregator/reports/deposit_report/tableDepositReports.js": 1456,
	"./customersAggregator/reportscustomer": 1457,
	"./customersAggregator/reportscustomer.js": 1457,
	"./customersAggregator/statistics": 1458,
	"./customersAggregator/statistics.js": 1458,
	"./customersAggregator/tags": 1459,
	"./customersAggregator/tags.js": 1459,
	"./dashboard": 1460,
	"./dashboard.js": 1460,
	"./dashboard/dataview": 87,
	"./dashboard/dataview.js": 87,
	"./dashboard/jugadoresActivos": 84,
	"./dashboard/jugadoresActivos.js": 84,
	"./dashboard/jugadoresNuevos": 128,
	"./dashboard/jugadoresNuevos.js": 128,
	"./dates": 479,
	"./dates.js": 479,
	"./demos": 1461,
	"./demos.js": 1461,
	"./depositReport": 1462,
	"./depositReport.js": 1462,
	"./depositReport3": 1463,
	"./depositReport3.js": 1463,
	"./depositReportBetShop": 1464,
	"./depositReportBetShop.js": 1464,
	"./depositRequests": 1465,
	"./depositRequests.js": 1465,
	"./eliminateNoteWithdraw": 1466,
	"./eliminateNoteWithdraw.js": 1466,
	"./emailsReport": 1467,
	"./emailsReport.js": 1467,
	"./financial/depositRequests/filter": 486,
	"./financial/depositRequests/filter.js": 486,
	"./financial/depositRequests/record": 153,
	"./financial/depositRequests/record.js": 153,
	"./financial/depositRequests/recordTable": 488,
	"./financial/depositRequests/recordTable.js": 488,
	"./financial/depositRequests/table": 487,
	"./financial/depositRequests/table.js": 487,
	"./financial/withdrawalRequests": 1468,
	"./financial/withdrawalRequests.js": 1468,
	"./financial/withdrawalRequests/detailsWithdrawalRequests": 80,
	"./financial/withdrawalRequests/detailsWithdrawalRequests.js": 80,
	"./financial/withdrawalRequests/filterWithdrawalRequest": 115,
	"./financial/withdrawalRequests/filterWithdrawalRequest.js": 115,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest": 15,
	"./financial/withdrawalRequests/recordTableWithdrawalRequest.js": 15,
	"./financial/withdrawalRequests/recordWithdrawalRequest": 81,
	"./financial/withdrawalRequests/recordWithdrawalRequest.js": 81,
	"./financial/withdrawalRequests/tableWithdrawalRequest": 116,
	"./financial/withdrawalRequests/tableWithdrawalRequest.js": 116,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests": 156,
	"./financial/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 156,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest": 495,
	"./financial/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 495,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1469,
	"./financial/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1469,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest": 157,
	"./financial/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 157,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest": 496,
	"./financial/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 496,
	"./flujoCaja": 1470,
	"./flujoCaja.js": 1470,
	"./franchisee": 1471,
	"./franchisee.js": 1471,
	"./franchises": 1472,
	"./franchises.js": 1472,
	"./futureEvents": 1473,
	"./futureEvents.js": 1473,
	"./gamePerformanceReport": 1474,
	"./gamePerformanceReport.js": 1474,
	"./getReportStructureGames": 1475,
	"./getReportStructureGames.js": 1475,
	"./goldenRace": 1476,
	"./goldenRace.js": 1476,
	"./historicalCashFlow": 1477,
	"./historicalCashFlow.js": 1477,
	"./historyMovement": 1478,
	"./historyMovement.js": 1478,
	"./historyMovement/filter": 1479,
	"./historyMovement/filter.js": 1479,
	"./historyMovement/table": 1480,
	"./historyMovement/table.js": 1480,
	"./historyMovementBetShop": 1481,
	"./historyMovementBetShop.js": 1481,
	"./historyPoints": 1482,
	"./historyPoints.js": 1482,
	"./information/details": 24,
	"./information/details.js": 24,
	"./information/filter": 42,
	"./information/filter.js": 42,
	"./information/record": 25,
	"./information/record.js": 25,
	"./information/recordTable": 1483,
	"./information/recordTable.js": 1483,
	"./information/table": 43,
	"./information/table.js": 43,
	"./informationCasino": 1484,
	"./informationCasino.js": 1484,
	"./informationHipica": 1485,
	"./informationHipica.js": 1485,
	"./informationLiveCasino": 1486,
	"./informationLiveCasino.js": 1486,
	"./informationVirtual": 1487,
	"./informationVirtual.js": 1487,
	"./informeCasino": 1488,
	"./informeCasino.js": 1488,
	"./informeGerencial": 1489,
	"./informeGerencial.js": 1489,
	"./informeGerencial2": 1490,
	"./informeGerencial2.js": 1490,
	"./informeGerencialAgentes2": 1491,
	"./informeGerencialAgentes2.js": 1491,
	"./informeGerencialUsuarios2": 1492,
	"./informeGerencialUsuarios2.js": 1492,
	"./jackpotPaymentReports": 1493,
	"./jackpotPaymentReports.js": 1493,
	"./jackpotPaymentReports2": 1494,
	"./jackpotPaymentReports2.js": 1494,
	"./jackpotPrizeReport": 1495,
	"./jackpotPrizeReport.js": 1495,
	"./jackpotPrizeReportSportBet": 1496,
	"./jackpotPrizeReportSportBet.js": 1496,
	"./jackpotWinnersReport": 1497,
	"./jackpotWinnersReport.js": 1497,
	"./landingReport": 1498,
	"./landingReport.js": 1498,
	"./landingReport2": 1499,
	"./landingReport2.js": 1499,
	"./leagues/AddLeague": 1500,
	"./leagues/AddLeague.js": 1500,
	"./leagues/addLeagueManagement": 1501,
	"./leagues/addLeagueManagement.js": 1501,
	"./leagues/configuration": 1502,
	"./leagues/configuration.js": 1502,
	"./leagues/configuration/changePassword": 1503,
	"./leagues/configuration/changePassword.js": 1503,
	"./leagues/configuration/changePassword/changePasswordView": 1504,
	"./leagues/configuration/changePassword/changePasswordView.js": 1504,
	"./leagues/configuration/generateToken": 1505,
	"./leagues/configuration/generateToken.js": 1505,
	"./leagues/configuration/generateToken/filter": 1506,
	"./leagues/configuration/generateToken/filter.js": 1506,
	"./leagues/configuration/generateToken/table": 1507,
	"./leagues/configuration/generateToken/table.js": 1507,
	"./leagues/configuration/qrgoogle": 1508,
	"./leagues/configuration/qrgoogle.js": 1508,
	"./leagues/configuration/securityChanges": 1509,
	"./leagues/configuration/securityChanges.js": 1509,
	"./leagues/configuration/securityChanges/filter": 1510,
	"./leagues/configuration/securityChanges/filter.js": 1510,
	"./leagues/configuration/securityChanges/table": 1511,
	"./leagues/configuration/securityChanges/table.js": 1511,
	"./leagues/information": 1512,
	"./leagues/information.js": 1512,
	"./leagues/leagues-list/filter": 546,
	"./leagues/leagues-list/filter.js": 546,
	"./leagues/leagues-list/table": 547,
	"./leagues/leagues-list/table.js": 547,
	"./leagues/leaguesList": 1513,
	"./leagues/leaguesList.js": 1513,
	"./leagues/leaguesManagement": 1514,
	"./leagues/leaguesManagement.js": 1514,
	"./leagues/reports": 1515,
	"./leagues/reports.js": 1515,
	"./leagues/reports/betsReport": 1516,
	"./leagues/reports/betsReport.js": 1516,
	"./leagues/reports/betsReport/detailsReport": 1517,
	"./leagues/reports/betsReport/detailsReport.js": 1517,
	"./leagues/reports/betsReport/filterReport": 549,
	"./leagues/reports/betsReport/filterReport.js": 549,
	"./leagues/reports/betsReport/recordReport": 1518,
	"./leagues/reports/betsReport/recordReport.js": 1518,
	"./leagues/reports/betsReport/recordTableReport": 1519,
	"./leagues/reports/betsReport/recordTableReport.js": 1519,
	"./leagues/reports/betsReport/recordTableTransReport": 1520,
	"./leagues/reports/betsReport/recordTableTransReport.js": 1520,
	"./leagues/reports/betsReport/recordTransReport": 551,
	"./leagues/reports/betsReport/recordTransReport.js": 551,
	"./leagues/reports/betsReport/tableReport": 550,
	"./leagues/reports/betsReport/tableReport.js": 550,
	"./leagues/reports/casinoGamesReport": 1521,
	"./leagues/reports/casinoGamesReport.js": 1521,
	"./leagues/reports/casinoReport/detailsCasinoReport": 554,
	"./leagues/reports/casinoReport/detailsCasinoReport.js": 554,
	"./leagues/reports/casinoReport/filterCasinoReport": 552,
	"./leagues/reports/casinoReport/filterCasinoReport.js": 552,
	"./leagues/reports/casinoReport/recordCasinoReport": 555,
	"./leagues/reports/casinoReport/recordCasinoReport.js": 555,
	"./leagues/reports/casinoReport/recordTableCasinoReport": 1522,
	"./leagues/reports/casinoReport/recordTableCasinoReport.js": 1522,
	"./leagues/reports/casinoReport/tableCasinoReport": 553,
	"./leagues/reports/casinoReport/tableCasinoReport.js": 553,
	"./leagues/reports/userAfilliatesReport": 1523,
	"./leagues/reports/userAfilliatesReport.js": 1523,
	"./leagues/reports/user_affiliates/detailsReports": 1524,
	"./leagues/reports/user_affiliates/detailsReports.js": 1524,
	"./leagues/reports/user_affiliates/filterReports": 556,
	"./leagues/reports/user_affiliates/filterReports.js": 556,
	"./leagues/reports/user_affiliates/recordReports": 1525,
	"./leagues/reports/user_affiliates/recordReports.js": 1525,
	"./leagues/reports/user_affiliates/recordTableReports": 1526,
	"./leagues/reports/user_affiliates/recordTableReports.js": 1526,
	"./leagues/reports/user_affiliates/tableReports": 557,
	"./leagues/reports/user_affiliates/tableReports.js": 557,
	"./leagues/results/recordTableResponts": 548,
	"./leagues/results/recordTableResponts.js": 548,
	"./leagues/results/tableResults": 117,
	"./leagues/results/tableResults.js": 117,
	"./leagues/statistics": 1527,
	"./leagues/statistics.js": 1527,
	"./leagues/statistics/age": 561,
	"./leagues/statistics/age.js": 561,
	"./leagues/statistics/marketing": 559,
	"./leagues/statistics/marketing.js": 559,
	"./leagues/statistics/marketingvsregistros": 560,
	"./leagues/statistics/marketingvsregistros.js": 560,
	"./leagues/statistics/money": 558,
	"./leagues/statistics/money.js": 558,
	"./limitationsReport": 1528,
	"./limitationsReport.js": 1528,
	"./loading": 1529,
	"./loading.js": 1529,
	"./login": 1530,
	"./login.js": 1530,
	"./logsUserGeneral": 1531,
	"./logsUserGeneral.js": 1531,
	"./loteryReport": 1532,
	"./loteryReport.js": 1532,
	"./machine/AddMachineRegister": 1533,
	"./machine/AddMachineRegister.js": 1533,
	"./machine/addMachineManagement": 1534,
	"./machine/addMachineManagement.js": 1534,
	"./machine/cashier/advertising": 567,
	"./machine/cashier/advertising.js": 567,
	"./machine/cashier/cashier": 1535,
	"./machine/cashier/cashier.js": 1535,
	"./machine/cashier/tableAdvertising": 568,
	"./machine/cashier/tableAdvertising.js": 568,
	"./machine/configuration": 1536,
	"./machine/configuration.js": 1536,
	"./machine/configuration/changePassword": 1537,
	"./machine/configuration/changePassword.js": 1537,
	"./machine/configuration/changePassword/changePasswordView": 1538,
	"./machine/configuration/changePassword/changePasswordView.js": 1538,
	"./machine/configuration/generateToken": 1539,
	"./machine/configuration/generateToken.js": 1539,
	"./machine/configuration/generateToken/filter": 1540,
	"./machine/configuration/generateToken/filter.js": 1540,
	"./machine/configuration/generateToken/table": 1541,
	"./machine/configuration/generateToken/table.js": 1541,
	"./machine/configuration/qrgoogle": 1542,
	"./machine/configuration/qrgoogle.js": 1542,
	"./machine/configuration/securityChanges": 1543,
	"./machine/configuration/securityChanges.js": 1543,
	"./machine/configuration/securityChanges/filter": 992,
	"./machine/configuration/securityChanges/filter.js": 992,
	"./machine/configuration/securityChanges/table": 569,
	"./machine/configuration/securityChanges/table.js": 569,
	"./machine/filter": 570,
	"./machine/filter.js": 570,
	"./machine/information": 1544,
	"./machine/information.js": 1544,
	"./machine/machineManagement": 1545,
	"./machine/machineManagement.js": 1545,
	"./machine/machineRegister": 1546,
	"./machine/machineRegister.js": 1546,
	"./machine/managePointsGraphics": 1547,
	"./machine/managePointsGraphics.js": 1547,
	"./machine/pagoNotaCobro": 1548,
	"./machine/pagoNotaCobro.js": 1548,
	"./machine/pagoNotaCobro/PagoNotaCobro": 993,
	"./machine/pagoNotaCobro/PagoNotaCobro.js": 993,
	"./machine/pagoNotaCobro/filterPagoNotaCobro": 574,
	"./machine/pagoNotaCobro/filterPagoNotaCobro.js": 574,
	"./machine/pagoNotaCobro/tablePagoNotaCobro": 575,
	"./machine/pagoNotaCobro/tablePagoNotaCobro.js": 575,
	"./machine/pagoPremioMaquina": 1549,
	"./machine/pagoPremioMaquina.js": 1549,
	"./machine/pagopremio/PagoPremio": 577,
	"./machine/pagopremio/PagoPremio.js": 577,
	"./machine/pagopremio/detailsPagoPremio": 579,
	"./machine/pagopremio/detailsPagoPremio.js": 579,
	"./machine/pagopremio/filterPagoPremio": 576,
	"./machine/pagopremio/filterPagoPremio.js": 576,
	"./machine/pagopremio/recordPagoPremio": 580,
	"./machine/pagopremio/recordPagoPremio.js": 580,
	"./machine/pagopremio/recordTablePagoPremio": 1550,
	"./machine/pagopremio/recordTablePagoPremio.js": 1550,
	"./machine/pagopremio/tablePagoPremio": 578,
	"./machine/pagopremio/tablePagoPremio.js": 578,
	"./machine/pointsGraphics/filter": 572,
	"./machine/pointsGraphics/filter.js": 572,
	"./machine/pointsGraphics/pointsList": 573,
	"./machine/pointsGraphics/pointsList.js": 573,
	"./machine/products2": 1551,
	"./machine/products2.js": 1551,
	"./machine/products2/categories-products/filter": 581,
	"./machine/products2/categories-products/filter.js": 581,
	"./machine/products2/categories-products/table": 582,
	"./machine/products2/categories-products/table.js": 582,
	"./machine/products2/categoriesProducts": 1552,
	"./machine/products2/categoriesProducts.js": 1552,
	"./machine/products2/partners-games/filter": 583,
	"./machine/products2/partners-games/filter.js": 583,
	"./machine/products2/partners-games/table": 584,
	"./machine/products2/partners-games/table.js": 584,
	"./machine/products2/partners-products/filter": 585,
	"./machine/products2/partners-products/filter.js": 585,
	"./machine/products2/partners-products/table": 586,
	"./machine/products2/partners-products/table.js": 586,
	"./machine/products2/partners-providers/filter": 587,
	"./machine/products2/partners-providers/filter.js": 587,
	"./machine/products2/partners-providers/table": 588,
	"./machine/products2/partners-providers/table.js": 588,
	"./machine/products2/partners-subProviders/filter": 589,
	"./machine/products2/partners-subProviders/filter.js": 589,
	"./machine/products2/partners-subProviders/table": 590,
	"./machine/products2/partners-subProviders/table.js": 590,
	"./machine/products2/partners-tipoproducto/filter": 591,
	"./machine/products2/partners-tipoproducto/filter.js": 591,
	"./machine/products2/partners-tipoproducto/table": 592,
	"./machine/products2/partners-tipoproducto/table.js": 592,
	"./machine/products2/partnersGames": 1553,
	"./machine/products2/partnersGames.js": 1553,
	"./machine/products2/partnersProducts": 1554,
	"./machine/products2/partnersProducts.js": 1554,
	"./machine/products2/partnersProviders": 1555,
	"./machine/products2/partnersProviders.js": 1555,
	"./machine/products2/partnersSubProviders": 1556,
	"./machine/products2/partnersSubProviders.js": 1556,
	"./machine/products2/partnersTypeProduct": 1557,
	"./machine/products2/partnersTypeProduct.js": 1557,
	"./machine/reports": 1558,
	"./machine/reports.js": 1558,
	"./machine/reports/betsReport": 1559,
	"./machine/reports/betsReport.js": 1559,
	"./machine/reports/betsReport/detailsReport": 1560,
	"./machine/reports/betsReport/detailsReport.js": 1560,
	"./machine/reports/betsReport/filterReport": 593,
	"./machine/reports/betsReport/filterReport.js": 593,
	"./machine/reports/betsReport/recordReport": 1561,
	"./machine/reports/betsReport/recordReport.js": 1561,
	"./machine/reports/betsReport/recordTableReport": 1562,
	"./machine/reports/betsReport/recordTableReport.js": 1562,
	"./machine/reports/betsReport/recordTableTransReport": 1563,
	"./machine/reports/betsReport/recordTableTransReport.js": 1563,
	"./machine/reports/betsReport/recordTransReport": 595,
	"./machine/reports/betsReport/recordTransReport.js": 595,
	"./machine/reports/betsReport/tableReport": 594,
	"./machine/reports/betsReport/tableReport.js": 594,
	"./machine/reports/casinoGamesReport": 1564,
	"./machine/reports/casinoGamesReport.js": 1564,
	"./machine/reports/casinoReport/detailsCasinoReport": 598,
	"./machine/reports/casinoReport/detailsCasinoReport.js": 598,
	"./machine/reports/casinoReport/filterCasinoReport": 596,
	"./machine/reports/casinoReport/filterCasinoReport.js": 596,
	"./machine/reports/casinoReport/recordCasinoReport": 599,
	"./machine/reports/casinoReport/recordCasinoReport.js": 599,
	"./machine/reports/casinoReport/recordTableCasinoReport": 1565,
	"./machine/reports/casinoReport/recordTableCasinoReport.js": 1565,
	"./machine/reports/casinoReport/tableCasinoReport": 597,
	"./machine/reports/casinoReport/tableCasinoReport.js": 597,
	"./machine/reports/depositReport": 1566,
	"./machine/reports/depositReport.js": 1566,
	"./machine/reports/deposit_report/detailsDepositReports": 994,
	"./machine/reports/deposit_report/detailsDepositReports.js": 994,
	"./machine/reports/deposit_report/filterDepositReports": 600,
	"./machine/reports/deposit_report/filterDepositReports.js": 600,
	"./machine/reports/deposit_report/recordDepositReports": 602,
	"./machine/reports/deposit_report/recordDepositReports.js": 602,
	"./machine/reports/deposit_report/recordTableDepositReports": 1567,
	"./machine/reports/deposit_report/recordTableDepositReports.js": 1567,
	"./machine/reports/deposit_report/tableDepositReports": 601,
	"./machine/reports/deposit_report/tableDepositReports.js": 601,
	"./machine/reports/flujoCaja": 1568,
	"./machine/reports/flujoCaja.js": 1568,
	"./machine/reports/flujocaja/detailsFlujoCaja": 605,
	"./machine/reports/flujocaja/detailsFlujoCaja.js": 605,
	"./machine/reports/flujocaja/filterFlujoCaja": 603,
	"./machine/reports/flujocaja/filterFlujoCaja.js": 603,
	"./machine/reports/flujocaja/recordFlujoCaja": 606,
	"./machine/reports/flujocaja/recordFlujoCaja.js": 606,
	"./machine/reports/flujocaja/recordTableFlujoCaja": 1569,
	"./machine/reports/flujocaja/recordTableFlujoCaja.js": 1569,
	"./machine/reports/flujocaja/tableFlujoCaja": 604,
	"./machine/reports/flujocaja/tableFlujoCaja.js": 604,
	"./machine/reports/log/log": 607,
	"./machine/reports/log/log.js": 607,
	"./machine/reports/logReport": 1570,
	"./machine/reports/logReport.js": 1570,
	"./machine/reports/updates/filter": 608,
	"./machine/reports/updates/filter.js": 608,
	"./machine/reports/updates/table": 609,
	"./machine/reports/updates/table.js": 609,
	"./machine/reports/updatesReport": 1571,
	"./machine/reports/updatesReport.js": 1571,
	"./machine/reports/userAfilliatesReport": 1572,
	"./machine/reports/userAfilliatesReport.js": 1572,
	"./machine/reports/user_affiliates/detailsReports": 1573,
	"./machine/reports/user_affiliates/detailsReports.js": 1573,
	"./machine/reports/user_affiliates/filterReports": 610,
	"./machine/reports/user_affiliates/filterReports.js": 610,
	"./machine/reports/user_affiliates/recordReports": 1574,
	"./machine/reports/user_affiliates/recordReports.js": 1574,
	"./machine/reports/user_affiliates/recordTableReports": 1575,
	"./machine/reports/user_affiliates/recordTableReports.js": 1575,
	"./machine/reports/user_affiliates/tableReports": 611,
	"./machine/reports/user_affiliates/tableReports.js": 611,
	"./machine/reports/withdrawalRequests": 1576,
	"./machine/reports/withdrawalRequests.js": 1576,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests": 614,
	"./machine/reports/withdrawalRequests/detailsWithdrawalRequests.js": 614,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest": 612,
	"./machine/reports/withdrawalRequests/filterWithdrawalRequest.js": 612,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest": 1577,
	"./machine/reports/withdrawalRequests/recordTableWithdrawalRequest.js": 1577,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest": 615,
	"./machine/reports/withdrawalRequests/recordWithdrawalRequest.js": 615,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest": 613,
	"./machine/reports/withdrawalRequests/tableWithdrawalRequest.js": 613,
	"./machine/results/recordTableResponts": 1578,
	"./machine/results/recordTableResponts.js": 1578,
	"./machine/results/tableResults": 1579,
	"./machine/results/tableResults.js": 1579,
	"./machine/statistics": 1580,
	"./machine/statistics.js": 1580,
	"./machine/statistics/age": 619,
	"./machine/statistics/age.js": 619,
	"./machine/statistics/marketing": 617,
	"./machine/statistics/marketing.js": 617,
	"./machine/statistics/marketingvsregistros": 618,
	"./machine/statistics/marketingvsregistros.js": 618,
	"./machine/statistics/money": 616,
	"./machine/statistics/money.js": 616,
	"./machine/table": 571,
	"./machine/table.js": 571,
	"./management/activateRegistration/filter": 203,
	"./management/activateRegistration/filter.js": 203,
	"./management/activateRegistration/response": 204,
	"./management/activateRegistration/response.js": 204,
	"./management/coupons/coupons": 439,
	"./management/coupons/coupons.js": 439,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw": 490,
	"./management/eliminateNoteWithdraw/EliminateNoteWithdraw.js": 490,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw": 489,
	"./management/eliminateNoteWithdraw/filterEliminateNoteWithdraw.js": 489,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw": 492,
	"./management/eliminateNoteWithdraw/filterTableEliminateNoteWithdraw.js": 492,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw": 491,
	"./management/eliminateNoteWithdraw/tableEliminateNoteWithdraw.js": 491,
	"./management/faltan.txt": 1899,
	"./management/managementClaims/filter": 620,
	"./management/managementClaims/filter.js": 620,
	"./management/managementClaims/table": 621,
	"./management/managementClaims/table.js": 621,
	"./management/managementContact/details": 164,
	"./management/managementContact/details.js": 164,
	"./management/managementContact/detailsTable": 622,
	"./management/managementContact/detailsTable.js": 622,
	"./management/managementContact/filterManagementContact": 623,
	"./management/managementContact/filterManagementContact.js": 623,
	"./management/managementContact/tableManagementContact": 624,
	"./management/managementContact/tableManagementContact.js": 624,
	"./management/managementContactUser/filter": 625,
	"./management/managementContactUser/filter.js": 625,
	"./management/managementContactUser/table": 626,
	"./management/managementContactUser/table.js": 626,
	"./management/managementGenericForms/filter": 627,
	"./management/managementGenericForms/filter.js": 627,
	"./management/managementGenericForms/table": 628,
	"./management/managementGenericForms/table.js": 628,
	"./management/quotaRetraction/Retraction": 629,
	"./management/quotaRetraction/Retraction.js": 629,
	"./management/quotaRetraction/search": 995,
	"./management/quotaRetraction/search.js": 995,
	"./management/registerFast/filterRegisterFast": 630,
	"./management/registerFast/filterRegisterFast.js": 630,
	"./management/registerFast/tableRegisterFast": 631,
	"./management/registerFast/tableRegisterFast.js": 631,
	"./management/reprintCheck/filterReprintCheck": 632,
	"./management/reprintCheck/filterReprintCheck.js": 632,
	"./management/reprintCheck/tableReprintCheck": 633,
	"./management/reprintCheck/tableReprintCheck.js": 633,
	"./management/restrictUser/filter": 634,
	"./management/restrictUser/filter.js": 634,
	"./management/restrictUser/table": 635,
	"./management/restrictUser/table.js": 635,
	"./management/reversionReload/filterReversionReload": 636,
	"./management/reversionReload/filterReversionReload.js": 636,
	"./management/reversionReload/tableReversionReload": 637,
	"./management/reversionReload/tableReversionReload.js": 637,
	"./management/usersVerification/information": 118,
	"./management/usersVerification/information.js": 118,
	"./management/usersVerification/informationJumio": 638,
	"./management/usersVerification/informationJumio.js": 638,
	"./managementClaims": 1581,
	"./managementClaims.js": 1581,
	"./managementContact": 1582,
	"./managementContact.js": 1582,
	"./managementContactUser": 1583,
	"./managementContactUser.js": 1583,
	"./managementGenericForms": 1584,
	"./managementGenericForms.js": 1584,
	"./menu": 11,
	"./menu.js": 11,
	"./menuBonus": 1585,
	"./menuBonus.js": 1585,
	"./menuBuilder": 1586,
	"./menuBuilder.js": 1586,
	"./menuMarketing": 1587,
	"./menuMarketing.js": 1587,
	"./menus": 1588,
	"./menus.js": 1588,
	"./messages/bannerInvasive": 1589,
	"./messages/bannerInvasive.js": 1589,
	"./messages/bannerInvasive/filter": 641,
	"./messages/bannerInvasive/filter.js": 641,
	"./messages/bannerInvasive/table": 642,
	"./messages/bannerInvasive/table.js": 642,
	"./messages/fringe": 1590,
	"./messages/fringe.js": 1590,
	"./messages/fringe/filter": 643,
	"./messages/fringe/filter.js": 643,
	"./messages/fringe/table": 644,
	"./messages/fringe/table.js": 644,
	"./messages/messageIntern/filter": 119,
	"./messages/messageIntern/filter.js": 119,
	"./messages/messageIntern/table": 120,
	"./messages/messageIntern/table.js": 120,
	"./messages/messageInternAgent/filter": 645,
	"./messages/messageInternAgent/filter.js": 645,
	"./messages/messageInternAgent/table": 646,
	"./messages/messageInternAgent/table.js": 646,
	"./messages/messageInternal": 1591,
	"./messages/messageInternal.js": 1591,
	"./messages/messageInternalAgent": 1592,
	"./messages/messageInternalAgent.js": 1592,
	"./messages/messageList": 1593,
	"./messages/messageList.js": 1593,
	"./messages/popup": 1594,
	"./messages/popup.js": 1594,
	"./messages/popup/filter": 647,
	"./messages/popup/filter.js": 647,
	"./messages/popup/table": 648,
	"./messages/popup/table.js": 648,
	"./messagesOld/messageIntern/filter": 1595,
	"./messagesOld/messageIntern/filter.js": 1595,
	"./messagesOld/messageIntern/table": 1596,
	"./messagesOld/messageIntern/table.js": 1596,
	"./messagesOld/messageList": 1597,
	"./messagesOld/messageList.js": 1597,
	"./myComissionsReport": 1598,
	"./myComissionsReport.js": 1598,
	"./myConfiguration/changeMyPassword": 1599,
	"./myConfiguration/changeMyPassword.js": 1599,
	"./myConfiguration/myInfoBetShop": 1600,
	"./myConfiguration/myInfoBetShop.js": 1600,
	"./myConfiguration/myInfoCustomer": 1601,
	"./myConfiguration/myInfoCustomer.js": 1601,
	"./myConfiguration/myInformation": 1602,
	"./myConfiguration/myInformation.js": 1602,
	"./myConfiguration/qrgoogle": 1603,
	"./myConfiguration/qrgoogle.js": 1603,
	"./notesUser": 1604,
	"./notesUser.js": 1604,
	"./notifications": 968,
	"./notifications.js": 968,
	"./operatorResponsibility": 1605,
	"./operatorResponsibility.js": 1605,
	"./ownersIncome": 1606,
	"./ownersIncome.js": 1606,
	"./ownersIncomeSecondLevel": 1607,
	"./ownersIncomeSecondLevel.js": 1607,
	"./pagoNotaRetiro": 1608,
	"./pagoNotaRetiro.js": 1608,
	"./pagoPremio": 1609,
	"./pagoPremio.js": 1609,
	"./pagoPremioVirtuales": 1610,
	"./pagoPremioVirtuales.js": 1610,
	"./paidPendingAwards": 1611,
	"./paidPendingAwards.js": 1611,
	"./partner/PartnerSettings": 1612,
	"./partner/PartnerSettings.js": 1612,
	"./partner/PartnerSettingsOld": 1613,
	"./partner/PartnerSettingsOld.js": 1613,
	"./partner/TRM": 1614,
	"./partner/TRM.js": 1614,
	"./partner/TRM/filter": 663,
	"./partner/TRM/filter.js": 663,
	"./partner/TRM/table": 664,
	"./partner/TRM/table.js": 664,
	"./partner/configuration": 1615,
	"./partner/configuration.js": 1615,
	"./partner/configuration/filter": 121,
	"./partner/configuration/filter.js": 121,
	"./partner/configuration/settings": 122,
	"./partner/configuration/settings.js": 122,
	"./partner/configurationControl": 1616,
	"./partner/configurationControl.js": 1616,
	"./partner/configurationControl/filter": 665,
	"./partner/configurationControl/filter.js": 665,
	"./partner/configurationControl/table": 666,
	"./partner/configurationControl/table.js": 666,
	"./partner/configurationControl2": 1617,
	"./partner/configurationControl2.js": 1617,
	"./partner/configurationControl2/filter": 667,
	"./partner/configurationControl2/filter.js": 667,
	"./partner/configurationControl2/table": 668,
	"./partner/configurationControl2/table.js": 668,
	"./partner/configurationOld/filter": 1618,
	"./partner/configurationOld/filter.js": 1618,
	"./partner/configurationOld/settings": 1619,
	"./partner/configurationOld/settings.js": 1619,
	"./partner/configurationSEO": 1620,
	"./partner/configurationSEO.js": 1620,
	"./partner/configurationSEO/filter": 669,
	"./partner/configurationSEO/filter.js": 669,
	"./partner/configurationSEO/settings": 670,
	"./partner/configurationSEO/settings.js": 670,
	"./partner/countries": 1621,
	"./partner/countries.js": 1621,
	"./partner/countries/countries": 671,
	"./partner/countries/countries.js": 671,
	"./partner/menusUser": 1622,
	"./partner/menusUser.js": 1622,
	"./partner/menusUser/filter": 672,
	"./partner/menusUser/filter.js": 672,
	"./partner/menusUser/table": 673,
	"./partner/menusUser/table.js": 673,
	"./partner/partner-list/filter": 661,
	"./partner/partner-list/filter.js": 661,
	"./partner/partner-list/table": 662,
	"./partner/partner-list/table.js": 662,
	"./partner/partnertManagement": 1623,
	"./partner/partnertManagement.js": 1623,
	"./partner/products": 1624,
	"./partner/products.js": 1624,
	"./partner/products/categories-products/filter": 674,
	"./partner/products/categories-products/filter.js": 674,
	"./partner/products/categories-products/table": 675,
	"./partner/products/categories-products/table.js": 675,
	"./partner/products/categoriesProducts": 1625,
	"./partner/products/categoriesProducts.js": 1625,
	"./partner/products/crypto-blockchain/filter": 676,
	"./partner/products/crypto-blockchain/filter.js": 676,
	"./partner/products/crypto-blockchain/table": 677,
	"./partner/products/crypto-blockchain/table.js": 677,
	"./partner/products/cryptoBlockchain": 1626,
	"./partner/products/cryptoBlockchain.js": 1626,
	"./partner/products/partners-products/filter": 678,
	"./partner/products/partners-products/filter.js": 678,
	"./partner/products/partners-products/table": 679,
	"./partner/products/partners-products/table.js": 679,
	"./partner/products/partners-providers/filter": 680,
	"./partner/products/partners-providers/filter.js": 680,
	"./partner/products/partners-providers/table": 681,
	"./partner/products/partners-providers/table.js": 681,
	"./partner/products/partners-subProviders/filter": 682,
	"./partner/products/partners-subProviders/filter.js": 682,
	"./partner/products/partners-subProviders/table": 683,
	"./partner/products/partners-subProviders/table.js": 683,
	"./partner/products/partners-tipoproducto/filter": 684,
	"./partner/products/partners-tipoproducto/filter.js": 684,
	"./partner/products/partners-tipoproducto/table": 685,
	"./partner/products/partners-tipoproducto/table.js": 685,
	"./partner/products/partnersProducts": 1627,
	"./partner/products/partnersProducts.js": 1627,
	"./partner/products/partnersProviders": 1628,
	"./partner/products/partnersProviders.js": 1628,
	"./partner/products/partnersSubProviders": 1629,
	"./partner/products/partnersSubProviders.js": 1629,
	"./partner/products/partnersTypeProduct": 1630,
	"./partner/products/partnersTypeProduct.js": 1630,
	"./partner/products/products-banks/filter": 686,
	"./partner/products/products-banks/filter.js": 686,
	"./partner/products/products-banks/table": 687,
	"./partner/products/products-banks/table.js": 687,
	"./partner/products/products-franchises/filter": 688,
	"./partner/products/products-franchises/filter.js": 688,
	"./partner/products/products-franchises/table": 689,
	"./partner/products/products-franchises/table.js": 689,
	"./partner/products/productsBanks": 1631,
	"./partner/products/productsBanks.js": 1631,
	"./partner/products/productsFranchises": 1632,
	"./partner/products/productsFranchises.js": 1632,
	"./partner/products2": 1633,
	"./partner/products2.js": 1633,
	"./partner/products2/banks-partners/filter": 690,
	"./partner/products2/banks-partners/filter.js": 690,
	"./partner/products2/banks-partners/table": 691,
	"./partner/products2/banks-partners/table.js": 691,
	"./partner/products2/categories-products/filter": 692,
	"./partner/products2/categories-products/filter.js": 692,
	"./partner/products2/categories-products/table": 693,
	"./partner/products2/categories-products/table.js": 693,
	"./partner/products2/categoriesProducts": 1634,
	"./partner/products2/categoriesProducts.js": 1634,
	"./partner/products2/enablement-products/filter": 694,
	"./partner/products2/enablement-products/filter.js": 694,
	"./partner/products2/enablement-products/table": 695,
	"./partner/products2/enablement-products/table.js": 695,
	"./partner/products2/enablementProducts": 1635,
	"./partner/products2/enablementProducts.js": 1635,
	"./partner/products2/franchises-partner/filter": 696,
	"./partner/products2/franchises-partner/filter.js": 696,
	"./partner/products2/franchises-partner/table": 697,
	"./partner/products2/franchises-partner/table.js": 697,
	"./partner/products2/partners-categories/filter": 698,
	"./partner/products2/partners-categories/filter.js": 698,
	"./partner/products2/partners-categories/table": 699,
	"./partner/products2/partners-categories/table.js": 699,
	"./partner/products2/partners-credentialsSubProviders/filter": 700,
	"./partner/products2/partners-credentialsSubProviders/filter.js": 700,
	"./partner/products2/partners-credentialsSubProviders/table": 701,
	"./partner/products2/partners-credentialsSubProviders/table.js": 701,
	"./partner/products2/partners-games/filter": 702,
	"./partner/products2/partners-games/filter.js": 702,
	"./partner/products2/partners-games/table": 703,
	"./partner/products2/partners-games/table.js": 703,
	"./partner/products2/partners-products/filter": 704,
	"./partner/products2/partners-products/filter.js": 704,
	"./partner/products2/partners-products/table": 705,
	"./partner/products2/partners-products/table.js": 705,
	"./partner/products2/partners-providers-order/filter": 1636,
	"./partner/products2/partners-providers-order/filter.js": 1636,
	"./partner/products2/partners-providers-order/table": 1637,
	"./partner/products2/partners-providers-order/table.js": 1637,
	"./partner/products2/partners-providers/filter": 706,
	"./partner/products2/partners-providers/filter.js": 706,
	"./partner/products2/partners-providers/table": 707,
	"./partner/products2/partners-providers/table.js": 707,
	"./partner/products2/partners-subProviders-order/filter": 708,
	"./partner/products2/partners-subProviders-order/filter.js": 708,
	"./partner/products2/partners-subProviders-order/table": 709,
	"./partner/products2/partners-subProviders-order/table.js": 709,
	"./partner/products2/partners-subProviders/filter": 710,
	"./partner/products2/partners-subProviders/filter.js": 710,
	"./partner/products2/partners-subProviders/table": 711,
	"./partner/products2/partners-subProviders/table.js": 711,
	"./partner/products2/partners-tipoproducto/filter": 712,
	"./partner/products2/partners-tipoproducto/filter.js": 712,
	"./partner/products2/partners-tipoproducto/table": 713,
	"./partner/products2/partners-tipoproducto/table.js": 713,
	"./partner/products2/partnersBanks": 1638,
	"./partner/products2/partnersBanks.js": 1638,
	"./partner/products2/partnersCategories": 1639,
	"./partner/products2/partnersCategories.js": 1639,
	"./partner/products2/partnersCredentialsSubProviders": 1640,
	"./partner/products2/partnersCredentialsSubProviders.js": 1640,
	"./partner/products2/partnersFranchises": 1641,
	"./partner/products2/partnersFranchises.js": 1641,
	"./partner/products2/partnersGames": 1642,
	"./partner/products2/partnersGames.js": 1642,
	"./partner/products2/partnersProducts": 1643,
	"./partner/products2/partnersProducts.js": 1643,
	"./partner/products2/partnersProviders": 1644,
	"./partner/products2/partnersProviders.js": 1644,
	"./partner/products2/partnersSubProviders": 1645,
	"./partner/products2/partnersSubProviders.js": 1645,
	"./partner/products2/partnersSubProvidersOrder": 1646,
	"./partner/products2/partnersSubProvidersOrder.js": 1646,
	"./partner/products2/partnersTypeProduct": 1647,
	"./partner/products2/partnersTypeProduct.js": 1647,
	"./partner/reports": 1648,
	"./partner/reports.js": 1648,
	"./partner/reports/autoexclusionUsers": 1649,
	"./partner/reports/autoexclusionUsers.js": 1649,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers": 716,
	"./partner/reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 716,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers": 714,
	"./partner/reports/autoexclusionUsers/filterAutoexclusionUsers.js": 714,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers": 996,
	"./partner/reports/autoexclusionUsers/recordAutoexclusionUsers.js": 996,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers": 717,
	"./partner/reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 717,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers": 715,
	"./partner/reports/autoexclusionUsers/tableAutoexclusionUsers.js": 715,
	"./partner/reports/balanceAdjustments": 1650,
	"./partner/reports/balanceAdjustments.js": 1650,
	"./partner/reports/balanceAdjustments/filter": 718,
	"./partner/reports/balanceAdjustments/filter.js": 718,
	"./partner/reports/balanceAdjustments/table": 719,
	"./partner/reports/balanceAdjustments/table.js": 719,
	"./partner/reports/balanceHistory": 1651,
	"./partner/reports/balanceHistory.js": 1651,
	"./partner/reports/balanceHistory/filter": 720,
	"./partner/reports/balanceHistory/filter.js": 720,
	"./partner/reports/balanceHistory/table": 721,
	"./partner/reports/balanceHistory/table.js": 721,
	"./partner/reports/balanceHistoryBetShop": 1652,
	"./partner/reports/balanceHistoryBetShop.js": 1652,
	"./partner/reports/balanceHistoryBetShop/filter": 722,
	"./partner/reports/balanceHistoryBetShop/filter.js": 722,
	"./partner/reports/balanceHistoryBetShop/table": 723,
	"./partner/reports/balanceHistoryBetShop/table.js": 723,
	"./partner/reports/balanceUsers": 1653,
	"./partner/reports/balanceUsers.js": 1653,
	"./partner/reports/balanceUsers/filter": 724,
	"./partner/reports/balanceUsers/filter.js": 724,
	"./partner/reports/balanceUsers/record": 726,
	"./partner/reports/balanceUsers/record.js": 726,
	"./partner/reports/balanceUsers/resume": 727,
	"./partner/reports/balanceUsers/resume.js": 727,
	"./partner/reports/balanceUsers/table": 725,
	"./partner/reports/balanceUsers/table.js": 725,
	"./partner/reports/betsReport": 1654,
	"./partner/reports/betsReport.js": 1654,
	"./partner/reports/betsReport/detailsReport": 1655,
	"./partner/reports/betsReport/detailsReport.js": 1655,
	"./partner/reports/betsReport/filterReport": 728,
	"./partner/reports/betsReport/filterReport.js": 728,
	"./partner/reports/betsReport/recordReport": 732,
	"./partner/reports/betsReport/recordReport.js": 732,
	"./partner/reports/betsReport/recordTableReport": 733,
	"./partner/reports/betsReport/recordTableReport.js": 733,
	"./partner/reports/betsReport/recordTableTransReport": 731,
	"./partner/reports/betsReport/recordTableTransReport.js": 731,
	"./partner/reports/betsReport/recordTransReport": 730,
	"./partner/reports/betsReport/recordTransReport.js": 730,
	"./partner/reports/betsReport/tableReport": 729,
	"./partner/reports/betsReport/tableReport.js": 729,
	"./partner/reports/bonusReport": 1656,
	"./partner/reports/bonusReport.js": 1656,
	"./partner/reports/bonusReport/detailsBonusReport": 736,
	"./partner/reports/bonusReport/detailsBonusReport.js": 736,
	"./partner/reports/bonusReport/filterBonusReport": 734,
	"./partner/reports/bonusReport/filterBonusReport.js": 734,
	"./partner/reports/bonusReport/recordBonusReport": 737,
	"./partner/reports/bonusReport/recordBonusReport.js": 737,
	"./partner/reports/bonusReport/recordTableBonusReport": 738,
	"./partner/reports/bonusReport/recordTableBonusReport.js": 738,
	"./partner/reports/bonusReport/tableBonusReport": 735,
	"./partner/reports/bonusReport/tableBonusReport.js": 735,
	"./partner/reports/casinoGamesReport": 1657,
	"./partner/reports/casinoGamesReport.js": 1657,
	"./partner/reports/casinoReport/detailsCasinoReport": 741,
	"./partner/reports/casinoReport/detailsCasinoReport.js": 741,
	"./partner/reports/casinoReport/filterCasinoReport": 739,
	"./partner/reports/casinoReport/filterCasinoReport.js": 739,
	"./partner/reports/casinoReport/recordCasinoReport": 742,
	"./partner/reports/casinoReport/recordCasinoReport.js": 742,
	"./partner/reports/casinoReport/recordTableCasinoReport": 743,
	"./partner/reports/casinoReport/recordTableCasinoReport.js": 743,
	"./partner/reports/casinoReport/tableCasinoReport": 740,
	"./partner/reports/casinoReport/tableCasinoReport.js": 740,
	"./partner/reports/comissionsReport": 1658,
	"./partner/reports/comissionsReport.js": 1658,
	"./partner/reports/comissions_report/filter": 744,
	"./partner/reports/comissions_report/filter.js": 744,
	"./partner/reports/comissions_report/table": 745,
	"./partner/reports/comissions_report/table.js": 745,
	"./partner/reports/depositReport": 1659,
	"./partner/reports/depositReport.js": 1659,
	"./partner/reports/deposit_report/detailsDepositReports": 997,
	"./partner/reports/deposit_report/detailsDepositReports.js": 997,
	"./partner/reports/deposit_report/filterDepositReports": 746,
	"./partner/reports/deposit_report/filterDepositReports.js": 746,
	"./partner/reports/deposit_report/recordDepositReports": 748,
	"./partner/reports/deposit_report/recordDepositReports.js": 748,
	"./partner/reports/deposit_report/recordTableDepositReports": 749,
	"./partner/reports/deposit_report/recordTableDepositReports.js": 749,
	"./partner/reports/deposit_report/tableDepositReports": 747,
	"./partner/reports/deposit_report/tableDepositReports.js": 747,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido": 750,
	"./partner/reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 750,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido": 751,
	"./partner/reports/flujoCajaResumido/filterFlujoCajaResumido.js": 751,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido": 752,
	"./partner/reports/flujoCajaResumido/recordFlujoCajaResumido.js": 752,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido": 123,
	"./partner/reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 123,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido": 753,
	"./partner/reports/flujoCajaResumido/tableFlujoCajaResumido.js": 753,
	"./partner/reports/historicalCashFlow": 1660,
	"./partner/reports/historicalCashFlow.js": 1660,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow": 756,
	"./partner/reports/historicalCashFlow/detailsHistoricalCashFlow.js": 756,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow": 754,
	"./partner/reports/historicalCashFlow/filterHistoricalCashFlow.js": 754,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow": 757,
	"./partner/reports/historicalCashFlow/recordHistoricalCashFlow.js": 757,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow": 758,
	"./partner/reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 758,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow": 755,
	"./partner/reports/historicalCashFlow/tableHistoricalCashFlow.js": 755,
	"./partner/reports/historyMovement": 1661,
	"./partner/reports/historyMovement.js": 1661,
	"./partner/reports/historyMovement/filter": 759,
	"./partner/reports/historyMovement/filter.js": 759,
	"./partner/reports/historyMovement/table": 760,
	"./partner/reports/historyMovement/table.js": 760,
	"./partner/reports/informeCasino/detailsInformeCasino": 1662,
	"./partner/reports/informeCasino/detailsInformeCasino.js": 1662,
	"./partner/reports/informeCasino/filterInformeCasino": 1663,
	"./partner/reports/informeCasino/filterInformeCasino.js": 1663,
	"./partner/reports/informeCasino/recordInformeCasino": 1664,
	"./partner/reports/informeCasino/recordInformeCasino.js": 1664,
	"./partner/reports/informeCasino/recordTableInformeCasino": 1665,
	"./partner/reports/informeCasino/recordTableInformeCasino.js": 1665,
	"./partner/reports/informeCasino/tableInformeCasino": 1666,
	"./partner/reports/informeCasino/tableInformeCasino.js": 1666,
	"./partner/reports/informeGerencial": 1667,
	"./partner/reports/informeGerencial.js": 1667,
	"./partner/reports/informeGerencial/detailsInformeGerencial": 763,
	"./partner/reports/informeGerencial/detailsInformeGerencial.js": 763,
	"./partner/reports/informeGerencial/filterInformeGerencial": 761,
	"./partner/reports/informeGerencial/filterInformeGerencial.js": 761,
	"./partner/reports/informeGerencial/recordInformeGerencial": 764,
	"./partner/reports/informeGerencial/recordInformeGerencial.js": 764,
	"./partner/reports/informeGerencial/recordTableInformeGerencial": 765,
	"./partner/reports/informeGerencial/recordTableInformeGerencial.js": 765,
	"./partner/reports/informeGerencial/tableInformeGerencial": 762,
	"./partner/reports/informeGerencial/tableInformeGerencial.js": 762,
	"./partner/reports/landingReport/detailsLandingReport": 1668,
	"./partner/reports/landingReport/detailsLandingReport.js": 1668,
	"./partner/reports/landingReport/filterLandingReport": 1669,
	"./partner/reports/landingReport/filterLandingReport.js": 1669,
	"./partner/reports/landingReport/recordLandingReport": 1670,
	"./partner/reports/landingReport/recordLandingReport.js": 1670,
	"./partner/reports/landingReport/recordTableLandingReport": 1671,
	"./partner/reports/landingReport/recordTableLandingReport.js": 1671,
	"./partner/reports/landingReport/tableLandingReport": 1672,
	"./partner/reports/landingReport/tableLandingReport.js": 1672,
	"./partner/reports/logsUser/filter": 1673,
	"./partner/reports/logsUser/filter.js": 1673,
	"./partner/reports/logsUser/table": 1674,
	"./partner/reports/logsUser/table.js": 1674,
	"./partner/reports/operatorResponsibility/filter": 1675,
	"./partner/reports/operatorResponsibility/filter.js": 1675,
	"./partner/reports/operatorResponsibility/table": 1676,
	"./partner/reports/operatorResponsibility/table.js": 1676,
	"./partner/reports/paidPendingAwards": 1677,
	"./partner/reports/paidPendingAwards.js": 1677,
	"./partner/reports/playersReport/detailsPlayersReport": 1678,
	"./partner/reports/playersReport/detailsPlayersReport.js": 1678,
	"./partner/reports/playersReport/filterPlayersReport": 1679,
	"./partner/reports/playersReport/filterPlayersReport.js": 1679,
	"./partner/reports/playersReport/recordPlayersReport": 1680,
	"./partner/reports/playersReport/recordPlayersReport.js": 1680,
	"./partner/reports/playersReport/recordTablePlayersReport": 769,
	"./partner/reports/playersReport/recordTablePlayersReport.js": 769,
	"./partner/reports/playersReport/tablePlayersReport": 1681,
	"./partner/reports/playersReport/tablePlayersReport.js": 1681,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 998,
	"./partner/reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 998,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar": 766,
	"./partner/reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 766,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar": 999,
	"./partner/reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 999,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 768,
	"./partner/reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 768,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar": 767,
	"./partner/reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 767,
	"./partner/reports/promotionalCodes/filter": 1682,
	"./partner/reports/promotionalCodes/filter.js": 1682,
	"./partner/reports/promotionalCodes/table": 1683,
	"./partner/reports/promotionalCodes/table.js": 1683,
	"./partner/reports/quotaRetraction/filter": 1684,
	"./partner/reports/quotaRetraction/filter.js": 1684,
	"./partner/reports/quotaRetraction/table": 1685,
	"./partner/reports/quotaRetraction/table.js": 1685,
	"./partner/reports/registeredDocument": 1686,
	"./partner/reports/registeredDocument.js": 1686,
	"./partner/reports/registeredDocuments/filter": 770,
	"./partner/reports/registeredDocuments/filter.js": 770,
	"./partner/reports/registeredDocuments/table": 771,
	"./partner/reports/registeredDocuments/table.js": 771,
	"./partner/reports/relationUserAggregator": 1687,
	"./partner/reports/relationUserAggregator.js": 1687,
	"./partner/reports/relationUserAggregator/filter": 772,
	"./partner/reports/relationUserAggregator/filter.js": 772,
	"./partner/reports/relationUserAggregator/table": 773,
	"./partner/reports/relationUserAggregator/table.js": 773,
	"./partner/reports/reportHash/filter": 1688,
	"./partner/reports/reportHash/filter.js": 1688,
	"./partner/reports/reportHash/table": 1689,
	"./partner/reports/reportHash/table.js": 1689,
	"./partner/reports/sessionsReport/detailsSessionsReport": 1690,
	"./partner/reports/sessionsReport/detailsSessionsReport.js": 1690,
	"./partner/reports/sessionsReport/filterSessionsReport": 1691,
	"./partner/reports/sessionsReport/filterSessionsReport.js": 1691,
	"./partner/reports/sessionsReport/recordSessionsReport": 1692,
	"./partner/reports/sessionsReport/recordSessionsReport.js": 1692,
	"./partner/reports/sessionsReport/recordTableSessionsReport": 1000,
	"./partner/reports/sessionsReport/recordTableSessionsReport.js": 1000,
	"./partner/reports/sessionsReport/tableSessionsReport": 1693,
	"./partner/reports/sessionsReport/tableSessionsReport.js": 1693,
	"./partner/reports/sportsTransactions": 1694,
	"./partner/reports/sportsTransactions.js": 1694,
	"./partner/reports/sportsTransactions/filter": 774,
	"./partner/reports/sportsTransactions/filter.js": 774,
	"./partner/reports/sportsTransactions/table": 775,
	"./partner/reports/sportsTransactions/table.js": 775,
	"./partner/reports/summaryCashFlow": 1695,
	"./partner/reports/summaryCashFlow.js": 1695,
	"./partner/reports/taxableEarnings/filter": 1696,
	"./partner/reports/taxableEarnings/filter.js": 1696,
	"./partner/reports/taxableEarnings/table": 1697,
	"./partner/reports/taxableEarnings/table.js": 1697,
	"./partner/reports/transfersReport/filter": 1698,
	"./partner/reports/transfersReport/filter.js": 1698,
	"./partner/reports/transfersReport/table": 1699,
	"./partner/reports/transfersReport/table.js": 1699,
	"./partner/reports/usuarioOnlineResumido": 1700,
	"./partner/reports/usuarioOnlineResumido.js": 1700,
	"./partner/reports/usuarioOnlineResumido/filter": 776,
	"./partner/reports/usuarioOnlineResumido/filter.js": 776,
	"./partner/reports/usuarioOnlineResumido/table": 777,
	"./partner/reports/usuarioOnlineResumido/table.js": 777,
	"./partner/reports/wallets": 1701,
	"./partner/reports/wallets.js": 1701,
	"./partner/reports/wallets/filter": 778,
	"./partner/reports/wallets/filter.js": 778,
	"./partner/reports/wallets/table": 779,
	"./partner/reports/wallets/table.js": 779,
	"./partner/templates": 1702,
	"./partner/templates.js": 1702,
	"./partner/templates/email": 1703,
	"./partner/templates/email.js": 1703,
	"./partner/templates/email/filter": 780,
	"./partner/templates/email/filter.js": 780,
	"./partner/templates/email/table": 781,
	"./partner/templates/email/table.js": 781,
	"./partner/templates/email/template": 782,
	"./partner/templates/email/template.js": 782,
	"./partner/templates/emailTemplate": 1704,
	"./partner/templates/emailTemplate.js": 1704,
	"./partner/templates/pdf": 1705,
	"./partner/templates/pdf.js": 1705,
	"./partner/templates/pdf/filter": 783,
	"./partner/templates/pdf/filter.js": 783,
	"./partner/templates/pdf/table": 784,
	"./partner/templates/pdf/table.js": 784,
	"./partner/templates/pdf/template": 785,
	"./partner/templates/pdf/template.js": 785,
	"./partner/templates/pdfTemplate": 1706,
	"./partner/templates/pdfTemplate.js": 1706,
	"./partner/templates/sms": 1707,
	"./partner/templates/sms.js": 1707,
	"./partner/templates/sms/filter": 786,
	"./partner/templates/sms/filter.js": 786,
	"./partner/templates/sms/table": 787,
	"./partner/templates/sms/table.js": 787,
	"./partner/templates/sms/template": 788,
	"./partner/templates/sms/template.js": 788,
	"./partner/templates/smsTemplate": 1708,
	"./partner/templates/smsTemplate.js": 1708,
	"./partners": 1709,
	"./partners.js": 1709,
	"./partnersCategories": 1710,
	"./partnersCategories.js": 1710,
	"./partnersProducts": 1711,
	"./partnersProducts.js": 1711,
	"./partnersProductsCountry": 1712,
	"./partnersProductsCountry.js": 1712,
	"./partnersProviders": 1713,
	"./partnersProviders.js": 1713,
	"./partnersTypeProduct": 1714,
	"./partnersTypeProduct.js": 1714,
	"./payPrizesLoyalty": 1715,
	"./payPrizesLoyalty.js": 1715,
	"./payhistoryview": 1716,
	"./payhistoryview.js": 1716,
	"./platformSpecific": 1717,
	"./platformSpecific.js": 1717,
	"./platformSpecific2": 1718,
	"./platformSpecific2.js": 1718,
	"./playerAccount": 1719,
	"./playerAccount.js": 1719,
	"./playerAccount2": 1720,
	"./playerAccount2.js": 1720,
	"./players": 3,
	"./players.js": 3,
	"./playersList": 1721,
	"./playersList.js": 1721,
	"./playersList2": 1722,
	"./playersList2.js": 1722,
	"./playersListAggregator": 1723,
	"./playersListAggregator.js": 1723,
	"./playersLists": 1724,
	"./playersLists.js": 1724,
	"./playersReport": 1725,
	"./playersReport.js": 1725,
	"./pointSettings": 1726,
	"./pointSettings.js": 1726,
	"./pointsUsers": 1727,
	"./pointsUsers.js": 1727,
	"./pokerReport": 1728,
	"./pokerReport.js": 1728,
	"./prices": 1729,
	"./prices.js": 1729,
	"./prizesLoyalty": 1730,
	"./prizesLoyalty.js": 1730,
	"./products": 1731,
	"./products.js": 1731,
	"./products/banks/filterBanks": 321,
	"./products/banks/filterBanks.js": 321,
	"./products/banks/tableBanks": 322,
	"./products/banks/tableBanks.js": 322,
	"./products/blockchain-networks/filterBlockchainNetworks": 377,
	"./products/blockchain-networks/filterBlockchainNetworks.js": 377,
	"./products/blockchain-networks/tableBlockchainNetworks": 378,
	"./products/blockchain-networks/tableBlockchainNetworks.js": 378,
	"./products/categories-products/detailsCategoriesProducts": 984,
	"./products/categories-products/detailsCategoriesProducts.js": 984,
	"./products/categories-products/filterCategoriesProducts": 420,
	"./products/categories-products/filterCategoriesProducts.js": 420,
	"./products/categories-products/recordCategoriesProducts": 985,
	"./products/categories-products/recordCategoriesProducts.js": 985,
	"./products/categories-products/recordTableCategoriesProducts": 422,
	"./products/categories-products/recordTableCategoriesProducts.js": 422,
	"./products/categories-products/tableCategoriesProducts": 421,
	"./products/categories-products/tableCategoriesProducts.js": 421,
	"./products/categories/detailsCategories": 982,
	"./products/categories/detailsCategories.js": 982,
	"./products/categories/filterCategories": 417,
	"./products/categories/filterCategories.js": 417,
	"./products/categories/recordCategories": 983,
	"./products/categories/recordCategories.js": 983,
	"./products/categories/recordTableCategories": 419,
	"./products/categories/recordTableCategories.js": 419,
	"./products/categories/tableCategories": 418,
	"./products/categories/tableCategories.js": 418,
	"./products/cryptos/filterCrypto": 442,
	"./products/cryptos/filterCrypto.js": 442,
	"./products/cryptos/tableCrypto": 443,
	"./products/cryptos/tableCrypto.js": 443,
	"./products/franchises/filterFranchises": 499,
	"./products/franchises/filterFranchises.js": 499,
	"./products/franchises/tableFranchises": 500,
	"./products/franchises/tableFranchises.js": 500,
	"./products/partners-products-country/detailsPartnersProductsCountry": 799,
	"./products/partners-products-country/detailsPartnersProductsCountry.js": 799,
	"./products/partners-products-country/filterPartnersProductsCountry": 797,
	"./products/partners-products-country/filterPartnersProductsCountry.js": 797,
	"./products/partners-products-country/recordPartnersProductsCountry": 800,
	"./products/partners-products-country/recordPartnersProductsCountry.js": 800,
	"./products/partners-products-country/recordTablePartnersProductsCountry": 801,
	"./products/partners-products-country/recordTablePartnersProductsCountry.js": 801,
	"./products/partners-products-country/tablePartnersProductsCountry": 798,
	"./products/partners-products-country/tablePartnersProductsCountry.js": 798,
	"./products/partners-products/detailsPartnersProducts": 795,
	"./products/partners-products/detailsPartnersProducts.js": 795,
	"./products/partners-products/filterPartnersProducts": 793,
	"./products/partners-products/filterPartnersProducts.js": 793,
	"./products/partners-products/recordPartnersProducts": 796,
	"./products/partners-products/recordPartnersProducts.js": 796,
	"./products/partners-products/recordTablePartnersProducts": 31,
	"./products/partners-products/recordTablePartnersProducts.js": 31,
	"./products/partners-products/tablePartnersProducts": 794,
	"./products/partners-products/tablePartnersProducts.js": 794,
	"./products/partners-providers/details": 804,
	"./products/partners-providers/details.js": 804,
	"./products/partners-providers/filter": 802,
	"./products/partners-providers/filter.js": 802,
	"./products/partners-providers/record": 805,
	"./products/partners-providers/record.js": 805,
	"./products/partners-providers/recordTable": 1732,
	"./products/partners-providers/recordTable.js": 1732,
	"./products/partners-providers/table": 803,
	"./products/partners-providers/table.js": 803,
	"./products/partners-tipoproducto/details": 808,
	"./products/partners-tipoproducto/details.js": 808,
	"./products/partners-tipoproducto/filter": 806,
	"./products/partners-tipoproducto/filter.js": 806,
	"./products/partners-tipoproducto/record": 809,
	"./products/partners-tipoproducto/record.js": 809,
	"./products/partners-tipoproducto/recordTable": 1733,
	"./products/partners-tipoproducto/recordTable.js": 1733,
	"./products/partners-tipoproducto/table": 807,
	"./products/partners-tipoproducto/table.js": 807,
	"./products/partners/filter": 789,
	"./products/partners/filter.js": 789,
	"./products/partners/table": 790,
	"./products/partners/table.js": 790,
	"./products/products/detailsProducts": 1001,
	"./products/products/detailsProducts.js": 1001,
	"./products/products/filterProducts": 831,
	"./products/products/filterProducts.js": 831,
	"./products/products/recordProducts": 1002,
	"./products/products/recordProducts.js": 1002,
	"./products/products/recordTableProducts": 833,
	"./products/products/recordTableProducts.js": 833,
	"./products/products/tableProducts": 832,
	"./products/products/tableProducts.js": 832,
	"./products/providers/detailsProviders": 68,
	"./products/providers/detailsProviders.js": 68,
	"./products/providers/filterProviders": 834,
	"./products/providers/filterProviders.js": 834,
	"./products/providers/recordProviders": 69,
	"./products/providers/recordProviders.js": 69,
	"./products/providers/recordTableProviders": 323,
	"./products/providers/recordTableProviders.js": 323,
	"./products/providers/tableProviders": 835,
	"./products/providers/tableProviders.js": 835,
	"./products/subProviders/filter": 836,
	"./products/subProviders/filter.js": 836,
	"./products/subProviders/table": 837,
	"./products/subProviders/table.js": 837,
	"./products/tags/detailsTags": 1003,
	"./products/tags/detailsTags.js": 1003,
	"./products/tags/filterTags": 838,
	"./products/tags/filterTags.js": 838,
	"./products/tags/recordTableTags": 839,
	"./products/tags/recordTableTags.js": 839,
	"./products/tags/recordTags": 1004,
	"./products/tags/recordTags.js": 1004,
	"./products/tags/tableTags": 840,
	"./products/tags/tableTags.js": 840,
	"./profile": 1734,
	"./profile.js": 1734,
	"./profileOptions": 1735,
	"./profileOptions.js": 1735,
	"./profileOptions2": 1736,
	"./profileOptions2.js": 1736,
	"./profileOptionsOld": 1737,
	"./profileOptionsOld.js": 1737,
	"./promotionalCasinoCampaings": 1738,
	"./promotionalCasinoCampaings.js": 1738,
	"./promotionalCodes": 1739,
	"./promotionalCodes.js": 1739,
	"./promotionalSportbookCampaings": 1740,
	"./promotionalSportbookCampaings.js": 1740,
	"./providers": 1741,
	"./providers.js": 1741,
	"./qualifying": 1742,
	"./qualifying.js": 1742,
	"./quotaRetraction": 1743,
	"./quotaRetraction.js": 1743,
	"./quotaRetractionReport": 1744,
	"./quotaRetractionReport.js": 1744,
	"./recargarCredito": 1745,
	"./recargarCredito.js": 1745,
	"./recargarCreditoAgente": 1746,
	"./recargarCreditoAgente.js": 1746,
	"./referralsAwardsReport": 1747,
	"./referralsAwardsReport.js": 1747,
	"./referralsReport": 1748,
	"./referralsReport.js": 1748,
	"./registerFast": 1749,
	"./registerFast.js": 1749,
	"./registeredDocument": 1750,
	"./registeredDocument.js": 1750,
	"./registeredDocuments": 1751,
	"./registeredDocuments.js": 1751,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports": 431,
	"./regulations/consolidatedIncomeOwner/filterConsolidatedIncomeOwnerReports.js": 431,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports": 432,
	"./regulations/consolidatedIncomeOwner/tableConsolidatedIncomeOwnerReports.js": 432,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports": 433,
	"./regulations/consolidatedIncomeOwner2/filterConsolidatedIncomeOwnerReports.js": 433,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports": 434,
	"./regulations/consolidatedIncomeOwner2/tableConsolidatedIncomeOwnerReports.js": 434,
	"./regulations/futureEvents/filterFutureEventsReports": 501,
	"./regulations/futureEvents/filterFutureEventsReports.js": 501,
	"./regulations/futureEvents/tableFutureEventsReports": 502,
	"./regulations/futureEvents/tableFutureEventsReports.js": 502,
	"./regulations/gamesPerformance/filterGamesPerformanceReports": 503,
	"./regulations/gamesPerformance/filterGamesPerformanceReports.js": 503,
	"./regulations/gamesPerformance/tableGamesPerformanceReports": 504,
	"./regulations/gamesPerformance/tableGamesPerformanceReports.js": 504,
	"./regulations/getReportStructureGames/filterGetReportStructureGames": 505,
	"./regulations/getReportStructureGames/filterGetReportStructureGames.js": 505,
	"./regulations/getReportStructureGames/tableGetReportStructureGames": 506,
	"./regulations/getReportStructureGames/tableGetReportStructureGames.js": 506,
	"./regulations/jackpotPayment/filterJackpotPaymentReports": 530,
	"./regulations/jackpotPayment/filterJackpotPaymentReports.js": 530,
	"./regulations/jackpotPayment/tableJackpotPaymentReports": 531,
	"./regulations/jackpotPayment/tableJackpotPaymentReports.js": 531,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports": 532,
	"./regulations/jackpotPayment2/filterJackpotPaymentReports.js": 532,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports": 533,
	"./regulations/jackpotPayment2/tableJackpotPaymentReports.js": 533,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino": 534,
	"./regulations/jackpotPrizeReportCasino/filterJackpotPrizeReportCasino.js": 534,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino": 535,
	"./regulations/jackpotPrizeReportCasino/tableJackpotPrizeReportCasino.js": 535,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet": 536,
	"./regulations/jackpotPrizeReportSportBet/filterJackpotPrizeReportSportBet.js": 536,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet": 537,
	"./regulations/jackpotPrizeReportSportBet/tableJackpotPrizeReportSportBet.js": 537,
	"./regulations/ownersIncome/filterOwnersIncomeReports": 655,
	"./regulations/ownersIncome/filterOwnersIncomeReports.js": 655,
	"./regulations/ownersIncome/tableOwnersIncomeReports": 656,
	"./regulations/ownersIncome/tableOwnersIncomeReports.js": 656,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports": 657,
	"./regulations/ownersIncomeSecondLevel/filterOwnersIncomeSecondLevelReports.js": 657,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports": 658,
	"./regulations/ownersIncomeSecondLevel/tableOwnersIncomeSecondLevelReports.js": 658,
	"./regulations/platformSpecific/filterPlatformSpecificReports": 810,
	"./regulations/platformSpecific/filterPlatformSpecificReports.js": 810,
	"./regulations/platformSpecific/tablePlatformSpecificReports": 811,
	"./regulations/platformSpecific/tablePlatformSpecificReports.js": 811,
	"./regulations/platformSpecific2/filterPlatformSpecificReports": 812,
	"./regulations/platformSpecific2/filterPlatformSpecificReports.js": 812,
	"./regulations/platformSpecific2/tablePlatformSpecificReports": 813,
	"./regulations/platformSpecific2/tablePlatformSpecificReports.js": 813,
	"./regulations/playerAccount/filterPlayerAccountReports": 814,
	"./regulations/playerAccount/filterPlayerAccountReports.js": 814,
	"./regulations/playerAccount/tablePlayerAccountReports": 815,
	"./regulations/playerAccount/tablePlayerAccountReports.js": 815,
	"./regulations/playerAccount2/filterPlayerAccountReports": 816,
	"./regulations/playerAccount2/filterPlayerAccountReports.js": 816,
	"./regulations/playerAccount2/tablePlayerAccountReports": 817,
	"./regulations/playerAccount2/tablePlayerAccountReports.js": 817,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports": 865,
	"./regulations/significantEventsAndAlterations/filterSignificantEventsAndAlterationsReports.js": 865,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports": 866,
	"./regulations/significantEventsAndAlterations/tableSignificantEventsAndAlterationsReports.js": 866,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports": 867,
	"./regulations/significantEventsAndAlterations2/filterSignificantEventsAndAlterationsReports.js": 867,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports": 868,
	"./regulations/significantEventsAndAlterations2/tableSignificantEventsAndAlterationsReports.js": 868,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports": 869,
	"./regulations/transactionsByPlayer/filterTransactionsByPlayerReports.js": 869,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports": 870,
	"./regulations/transactionsByPlayer/tableTransactionsByPlayerReports.js": 870,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports": 871,
	"./regulations/transactionsByPlayerDeposit/filterTransactionsByPlayerDepositReports.js": 871,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports": 872,
	"./regulations/transactionsByPlayerDeposit/tableTransactionsByPlayerDepositReports.js": 872,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports": 873,
	"./regulations/transactionsByPlayerFirstLevel/filterTransactionsByPlayerFirstLevelReports.js": 873,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports": 874,
	"./regulations/transactionsByPlayerFirstLevel/tableTransactionsByPlayerFirstLevelReports.js": 874,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports": 875,
	"./regulations/transactionsByPlayerSecondLevel/filterTransactionsByPlayerSecondLevelReports.js": 875,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports": 876,
	"./regulations/transactionsByPlayerSecondLevel/tableTransactionsByPlayerSecondLevelReports.js": 876,
	"./relationUserAggregator": 1752,
	"./relationUserAggregator.js": 1752,
	"./reportHash": 1753,
	"./reportHash.js": 1753,
	"./reportMarketing": 1754,
	"./reportMarketing.js": 1754,
	"./reports/affiliatesBetShop/filter": 207,
	"./reports/affiliatesBetShop/filter.js": 207,
	"./reports/affiliatesBetShop/table": 208,
	"./reports/affiliatesBetShop/table.js": 208,
	"./reports/assignmentQuota/filter": 292,
	"./reports/assignmentQuota/filter.js": 292,
	"./reports/assignmentQuota/table": 293,
	"./reports/assignmentQuota/table.js": 293,
	"./reports/assignmentQuotaMade/filter": 290,
	"./reports/assignmentQuotaMade/filter.js": 290,
	"./reports/assignmentQuotaMade/table": 291,
	"./reports/assignmentQuotaMade/table.js": 291,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers": 296,
	"./reports/autoexclusionUsers/detailsAutoexclusionUsers.js": 296,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers": 294,
	"./reports/autoexclusionUsers/filterAutoexclusionUsers.js": 294,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers": 297,
	"./reports/autoexclusionUsers/recordAutoexclusionUsers.js": 297,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers": 28,
	"./reports/autoexclusionUsers/recordTableAutoexclusionUsers.js": 28,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers": 295,
	"./reports/autoexclusionUsers/tableAutoexclusionUsers.js": 295,
	"./reports/balanceAdjustments/filter": 298,
	"./reports/balanceAdjustments/filter.js": 298,
	"./reports/balanceAdjustments/table": 299,
	"./reports/balanceAdjustments/table.js": 299,
	"./reports/balanceHistory/filter": 300,
	"./reports/balanceHistory/filter.js": 300,
	"./reports/balanceHistory/table": 301,
	"./reports/balanceHistory/table.js": 301,
	"./reports/balanceHistory2/filter": 1755,
	"./reports/balanceHistory2/filter.js": 1755,
	"./reports/balanceHistory2/filter2": 302,
	"./reports/balanceHistory2/filter2.js": 302,
	"./reports/balanceHistory2/table": 1756,
	"./reports/balanceHistory2/table.js": 1756,
	"./reports/balanceHistory2/table2": 303,
	"./reports/balanceHistory2/table2.js": 303,
	"./reports/balanceHistoryBetShop/filter": 306,
	"./reports/balanceHistoryBetShop/filter.js": 306,
	"./reports/balanceHistoryBetShop/table": 307,
	"./reports/balanceHistoryBetShop/table.js": 307,
	"./reports/balanceHistoryBetShop2/filter": 1757,
	"./reports/balanceHistoryBetShop2/filter.js": 1757,
	"./reports/balanceHistoryBetShop2/filter2": 308,
	"./reports/balanceHistoryBetShop2/filter2.js": 308,
	"./reports/balanceHistoryBetShop2/table": 1758,
	"./reports/balanceHistoryBetShop2/table.js": 1758,
	"./reports/balanceHistoryBetShop2/table2": 309,
	"./reports/balanceHistoryBetShop2/table2.js": 309,
	"./reports/balanceHistoryForAdminUser/filter": 304,
	"./reports/balanceHistoryForAdminUser/filter.js": 304,
	"./reports/balanceHistoryForAdminUser/table": 305,
	"./reports/balanceHistoryForAdminUser/table.js": 305,
	"./reports/balanceHistoryForAgent/filter": 310,
	"./reports/balanceHistoryForAgent/filter.js": 310,
	"./reports/balanceHistoryForAgent/table": 311,
	"./reports/balanceHistoryForAgent/table.js": 311,
	"./reports/balanceHistoryForBetShop/filter": 312,
	"./reports/balanceHistoryForBetShop/filter.js": 312,
	"./reports/balanceHistoryForBetShop/table": 313,
	"./reports/balanceHistoryForBetShop/table.js": 313,
	"./reports/balanceHistoryMachine/filter": 314,
	"./reports/balanceHistoryMachine/filter.js": 314,
	"./reports/balanceHistoryMachine/table": 315,
	"./reports/balanceHistoryMachine/table.js": 315,
	"./reports/balanceUsers/filter": 316,
	"./reports/balanceUsers/filter.js": 316,
	"./reports/balanceUsers/record": 135,
	"./reports/balanceUsers/record.js": 135,
	"./reports/balanceUsers/resume": 318,
	"./reports/balanceUsers/resume.js": 318,
	"./reports/balanceUsers/table": 317,
	"./reports/balanceUsers/table.js": 317,
	"./reports/betsReport/detailsReport": 1759,
	"./reports/betsReport/detailsReport.js": 1759,
	"./reports/betsReport/filterReport": 93,
	"./reports/betsReport/filterReport.js": 93,
	"./reports/betsReport/recordReport": 71,
	"./reports/betsReport/recordReport.js": 71,
	"./reports/betsReport/recordTableReport": 23,
	"./reports/betsReport/recordTableReport.js": 23,
	"./reports/betsReport/recordTableTransReport": 38,
	"./reports/betsReport/recordTableTransReport.js": 38,
	"./reports/betsReport/recordTransReport": 95,
	"./reports/betsReport/recordTransReport.js": 95,
	"./reports/betsReport/tableReport": 94,
	"./reports/betsReport/tableReport.js": 94,
	"./reports/betsReportBetShop/detailsReport": 1760,
	"./reports/betsReportBetShop/detailsReport.js": 1760,
	"./reports/betsReportBetShop/filterReport": 371,
	"./reports/betsReportBetShop/filterReport.js": 371,
	"./reports/betsReportBetShop/recordReport": 374,
	"./reports/betsReportBetShop/recordReport.js": 374,
	"./reports/betsReportBetShop/recordTableReport": 1761,
	"./reports/betsReportBetShop/recordTableReport.js": 1761,
	"./reports/betsReportBetShop/recordTableTransReport": 1762,
	"./reports/betsReportBetShop/recordTableTransReport.js": 1762,
	"./reports/betsReportBetShop/recordTransReport": 373,
	"./reports/betsReportBetShop/recordTransReport.js": 373,
	"./reports/betsReportBetShop/tableReport": 372,
	"./reports/betsReportBetShop/tableReport.js": 372,
	"./reports/bonusReport/detailsBonusReport": 139,
	"./reports/bonusReport/detailsBonusReport.js": 139,
	"./reports/bonusReport/filterBonusReport": 379,
	"./reports/bonusReport/filterBonusReport.js": 379,
	"./reports/bonusReport/recordBonusReport": 140,
	"./reports/bonusReport/recordBonusReport.js": 140,
	"./reports/bonusReport/recordTableBonusReport": 17,
	"./reports/bonusReport/recordTableBonusReport.js": 17,
	"./reports/bonusReport/tableBonusReport": 380,
	"./reports/bonusReport/tableBonusReport.js": 380,
	"./reports/bonusReport2/detailsBonusReport": 141,
	"./reports/bonusReport2/detailsBonusReport.js": 141,
	"./reports/bonusReport2/filterBonusReport": 381,
	"./reports/bonusReport2/filterBonusReport.js": 381,
	"./reports/bonusReport2/recordBonusReport": 142,
	"./reports/bonusReport2/recordBonusReport.js": 142,
	"./reports/bonusReport2/recordTableBonusReport": 1763,
	"./reports/bonusReport2/recordTableBonusReport.js": 1763,
	"./reports/bonusReport2/tableBonusReport": 382,
	"./reports/bonusReport2/tableBonusReport.js": 382,
	"./reports/casinoReport/detailsCasinoReport": 143,
	"./reports/casinoReport/detailsCasinoReport.js": 143,
	"./reports/casinoReport/filterCasinoReport": 413,
	"./reports/casinoReport/filterCasinoReport.js": 413,
	"./reports/casinoReport/recordCasinoReport": 144,
	"./reports/casinoReport/recordCasinoReport.js": 144,
	"./reports/casinoReport/recordTableCasinoReport": 9,
	"./reports/casinoReport/recordTableCasinoReport.js": 9,
	"./reports/casinoReport/tableCasinoReport": 414,
	"./reports/casinoReport/tableCasinoReport.js": 414,
	"./reports/casinoReport2/detailsCasinoReport": 145,
	"./reports/casinoReport2/detailsCasinoReport.js": 145,
	"./reports/casinoReport2/filterCasinoReport": 1764,
	"./reports/casinoReport2/filterCasinoReport.js": 1764,
	"./reports/casinoReport2/filterCasinoReport2": 415,
	"./reports/casinoReport2/filterCasinoReport2.js": 415,
	"./reports/casinoReport2/recordCasinoReport": 146,
	"./reports/casinoReport2/recordCasinoReport.js": 146,
	"./reports/casinoReport2/recordTableCasinoReport": 1765,
	"./reports/casinoReport2/recordTableCasinoReport.js": 1765,
	"./reports/casinoReport2/tableCasinoReport": 1766,
	"./reports/casinoReport2/tableCasinoReport.js": 1766,
	"./reports/casinoReport2/tableCasinoReport2": 416,
	"./reports/casinoReport2/tableCasinoReport2.js": 416,
	"./reports/comissions_report/filter": 423,
	"./reports/comissions_report/filter.js": 423,
	"./reports/comissions_report/table": 424,
	"./reports/comissions_report/table.js": 424,
	"./reports/comissions_report2/filter": 425,
	"./reports/comissions_report2/filter.js": 425,
	"./reports/comissions_report2/table": 426,
	"./reports/comissions_report2/table.js": 426,
	"./reports/commisionsPay/filter": 427,
	"./reports/commisionsPay/filter.js": 427,
	"./reports/commisionsPay/table": 428,
	"./reports/commisionsPay/table.js": 428,
	"./reports/coupons_report/details": 1767,
	"./reports/coupons_report/details.js": 1767,
	"./reports/coupons_report/filter": 440,
	"./reports/coupons_report/filter.js": 440,
	"./reports/coupons_report/record": 147,
	"./reports/coupons_report/record.js": 147,
	"./reports/coupons_report/recordReports": 1768,
	"./reports/coupons_report/recordReports.js": 1768,
	"./reports/coupons_report/table": 441,
	"./reports/coupons_report/table.js": 441,
	"./reports/customReport/filter": 444,
	"./reports/customReport/filter.js": 444,
	"./reports/customReport/table": 445,
	"./reports/customReport/table.js": 445,
	"./reports/deposit_report/detailsDepositReports": 989,
	"./reports/deposit_report/detailsDepositReports.js": 989,
	"./reports/deposit_report/filterDepositReports": 480,
	"./reports/deposit_report/filterDepositReports.js": 480,
	"./reports/deposit_report/recordDepositReports": 150,
	"./reports/deposit_report/recordDepositReports.js": 150,
	"./reports/deposit_report/recordTableDepositReports": 10,
	"./reports/deposit_report/recordTableDepositReports.js": 10,
	"./reports/deposit_report/tableDepositReports": 481,
	"./reports/deposit_report/tableDepositReports.js": 481,
	"./reports/deposit_report_3/detailsDepositReports": 990,
	"./reports/deposit_report_3/detailsDepositReports.js": 990,
	"./reports/deposit_report_3/filterDepositReports": 482,
	"./reports/deposit_report_3/filterDepositReports.js": 482,
	"./reports/deposit_report_3/recordDepositReports": 151,
	"./reports/deposit_report_3/recordDepositReports.js": 151,
	"./reports/deposit_report_3/recordTableDepositReports": 1769,
	"./reports/deposit_report_3/recordTableDepositReports.js": 1769,
	"./reports/deposit_report_3/tableDepositReports": 483,
	"./reports/deposit_report_3/tableDepositReports.js": 483,
	"./reports/deposit_report_betshop/detailsDepositReports": 991,
	"./reports/deposit_report_betshop/detailsDepositReports.js": 991,
	"./reports/deposit_report_betshop/filterDepositReports": 484,
	"./reports/deposit_report_betshop/filterDepositReports.js": 484,
	"./reports/deposit_report_betshop/recordDepositReports": 152,
	"./reports/deposit_report_betshop/recordDepositReports.js": 152,
	"./reports/deposit_report_betshop/recordTableDepositReports": 1770,
	"./reports/deposit_report_betshop/recordTableDepositReports.js": 1770,
	"./reports/deposit_report_betshop/tableDepositReports": 485,
	"./reports/deposit_report_betshop/tableDepositReports.js": 485,
	"./reports/emailsReport/detailsEmailsReport": 154,
	"./reports/emailsReport/detailsEmailsReport.js": 154,
	"./reports/emailsReport/filterEmailsReport": 493,
	"./reports/emailsReport/filterEmailsReport.js": 493,
	"./reports/emailsReport/recordEmailsReport": 155,
	"./reports/emailsReport/recordEmailsReport.js": 155,
	"./reports/emailsReport/recordTableEmailsReport": 1771,
	"./reports/emailsReport/recordTableEmailsReport.js": 1771,
	"./reports/emailsReport/tableEmailsReport": 494,
	"./reports/emailsReport/tableEmailsReport.js": 494,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido": 883,
	"./reports/flujoCajaResumido/detailsFlujoCajaResumido.js": 883,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido": 884,
	"./reports/flujoCajaResumido/filterFlujoCajaResumido.js": 884,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido": 885,
	"./reports/flujoCajaResumido/recordFlujoCajaResumido.js": 885,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido": 30,
	"./reports/flujoCajaResumido/recordTableFlujoCajaResumido.js": 30,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido": 886,
	"./reports/flujoCajaResumido/tableFlujoCajaResumido.js": 886,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido": 887,
	"./reports/flujoCajaResumido2/detailsFlujoCajaResumido.js": 887,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido": 1772,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido.js": 1772,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2": 888,
	"./reports/flujoCajaResumido2/filterFlujoCajaResumido2.js": 888,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido": 889,
	"./reports/flujoCajaResumido2/recordFlujoCajaResumido.js": 889,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido": 1773,
	"./reports/flujoCajaResumido2/recordTableFlujoCajaResumido.js": 1773,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido": 1774,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido.js": 1774,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2": 890,
	"./reports/flujoCajaResumido2/tableFlujoCajaResumido2.js": 890,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido": 891,
	"./reports/flujoCajaResumidoMaquina/detailsFlujoCajaResumido.js": 891,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido": 892,
	"./reports/flujoCajaResumidoMaquina/filterFlujoCajaResumido.js": 892,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido": 893,
	"./reports/flujoCajaResumidoMaquina/recordFlujoCajaResumido.js": 893,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido": 1775,
	"./reports/flujoCajaResumidoMaquina/recordTableFlujoCajaResumido.js": 1775,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido": 894,
	"./reports/flujoCajaResumidoMaquina/tableFlujoCajaResumido.js": 894,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow": 509,
	"./reports/historicalCashFlow/detailsHistoricalCashFlow.js": 509,
	"./reports/historicalCashFlow/filterHistoricalCashFlow": 507,
	"./reports/historicalCashFlow/filterHistoricalCashFlow.js": 507,
	"./reports/historicalCashFlow/recordHistoricalCashFlow": 510,
	"./reports/historicalCashFlow/recordHistoricalCashFlow.js": 510,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow": 511,
	"./reports/historicalCashFlow/recordTableHistoricalCashFlow.js": 511,
	"./reports/historicalCashFlow/tableHistoricalCashFlow": 508,
	"./reports/historicalCashFlow/tableHistoricalCashFlow.js": 508,
	"./reports/historyMovement/filter": 512,
	"./reports/historyMovement/filter.js": 512,
	"./reports/historyMovement/table": 513,
	"./reports/historyMovement/table.js": 513,
	"./reports/historyMovementBetShop/filter": 514,
	"./reports/historyMovementBetShop/filter.js": 514,
	"./reports/historyMovementBetShop/table": 515,
	"./reports/historyMovementBetShop/table.js": 515,
	"./reports/historyPoints/filter": 516,
	"./reports/historyPoints/filter.js": 516,
	"./reports/historyPoints/table": 517,
	"./reports/historyPoints/table.js": 517,
	"./reports/informeCasino/detailsInformeCasino": 520,
	"./reports/informeCasino/detailsInformeCasino.js": 520,
	"./reports/informeCasino/filterInformeCasino": 518,
	"./reports/informeCasino/filterInformeCasino.js": 518,
	"./reports/informeCasino/recordInformeCasino": 521,
	"./reports/informeCasino/recordInformeCasino.js": 521,
	"./reports/informeCasino/recordTableInformeCasino": 1776,
	"./reports/informeCasino/recordTableInformeCasino.js": 1776,
	"./reports/informeCasino/tableInformeCasino": 519,
	"./reports/informeCasino/tableInformeCasino.js": 519,
	"./reports/informeGerencial/detailsInformeGerencial": 1777,
	"./reports/informeGerencial/detailsInformeGerencial.js": 1777,
	"./reports/informeGerencial/filterInformeGerencial": 522,
	"./reports/informeGerencial/filterInformeGerencial.js": 522,
	"./reports/informeGerencial/recordInformeGerencial": 1778,
	"./reports/informeGerencial/recordInformeGerencial.js": 1778,
	"./reports/informeGerencial/recordTableInformeGerencial": 29,
	"./reports/informeGerencial/recordTableInformeGerencial.js": 29,
	"./reports/informeGerencial/tableInformeGerencial": 523,
	"./reports/informeGerencial/tableInformeGerencial.js": 523,
	"./reports/informeGerencial2/detailsInformeGerencial": 1779,
	"./reports/informeGerencial2/detailsInformeGerencial.js": 1779,
	"./reports/informeGerencial2/filterInformeGerencial": 1780,
	"./reports/informeGerencial2/filterInformeGerencial.js": 1780,
	"./reports/informeGerencial2/filterInformeGerencial2": 524,
	"./reports/informeGerencial2/filterInformeGerencial2.js": 524,
	"./reports/informeGerencial2/recordInformeGerencial": 1781,
	"./reports/informeGerencial2/recordInformeGerencial.js": 1781,
	"./reports/informeGerencial2/recordTableInformeGerencial": 1782,
	"./reports/informeGerencial2/recordTableInformeGerencial.js": 1782,
	"./reports/informeGerencial2/tableInformeGerencial": 1783,
	"./reports/informeGerencial2/tableInformeGerencial.js": 1783,
	"./reports/informeGerencial2/tableInformeGerencial2": 525,
	"./reports/informeGerencial2/tableInformeGerencial2.js": 525,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial": 1784,
	"./reports/informeGerencialAgentes2/detailsInformeGerencial.js": 1784,
	"./reports/informeGerencialAgentes2/filterInformeGerencial": 1785,
	"./reports/informeGerencialAgentes2/filterInformeGerencial.js": 1785,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2": 526,
	"./reports/informeGerencialAgentes2/filterInformeGerencial2.js": 526,
	"./reports/informeGerencialAgentes2/recordInformeGerencial": 1786,
	"./reports/informeGerencialAgentes2/recordInformeGerencial.js": 1786,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial": 1787,
	"./reports/informeGerencialAgentes2/recordTableInformeGerencial.js": 1787,
	"./reports/informeGerencialAgentes2/tableInformeGerencial": 1788,
	"./reports/informeGerencialAgentes2/tableInformeGerencial.js": 1788,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2": 527,
	"./reports/informeGerencialAgentes2/tableInformeGerencial2.js": 527,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial": 1789,
	"./reports/informeGerencialUsuarios2/detailsInformeGerencial.js": 1789,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial": 1790,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial.js": 1790,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2": 528,
	"./reports/informeGerencialUsuarios2/filterInformeGerencial2.js": 528,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial": 1791,
	"./reports/informeGerencialUsuarios2/recordInformeGerencial.js": 1791,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial": 1792,
	"./reports/informeGerencialUsuarios2/recordTableInformeGerencial.js": 1792,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial": 1793,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial.js": 1793,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2": 529,
	"./reports/informeGerencialUsuarios2/tableInformeGerencial2.js": 529,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports": 538,
	"./reports/jackpotWinnersReport/filterReferralsAwardsReports.js": 538,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports": 1794,
	"./reports/jackpotWinnersReport/recordReferralsAwardsReports.js": 1794,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports": 1795,
	"./reports/jackpotWinnersReport/recordTableReferralsAwardsReports.js": 1795,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports": 539,
	"./reports/jackpotWinnersReport/tableReferralsAwardsReports.js": 539,
	"./reports/landingReport/detailsLandingReport": 542,
	"./reports/landingReport/detailsLandingReport.js": 542,
	"./reports/landingReport/filterLandingReport": 540,
	"./reports/landingReport/filterLandingReport.js": 540,
	"./reports/landingReport/recordLandingReport": 543,
	"./reports/landingReport/recordLandingReport.js": 543,
	"./reports/landingReport/recordTableLandingReport": 1796,
	"./reports/landingReport/recordTableLandingReport.js": 1796,
	"./reports/landingReport/tableLandingReport": 541,
	"./reports/landingReport/tableLandingReport.js": 541,
	"./reports/landingReport2/detailsLandingReport": 158,
	"./reports/landingReport2/detailsLandingReport.js": 158,
	"./reports/landingReport2/filterLandingReport": 544,
	"./reports/landingReport2/filterLandingReport.js": 544,
	"./reports/landingReport2/recordLandingReport": 159,
	"./reports/landingReport2/recordLandingReport.js": 159,
	"./reports/landingReport2/recordTableLandingReport": 1797,
	"./reports/landingReport2/recordTableLandingReport.js": 1797,
	"./reports/landingReport2/tableLandingReport": 545,
	"./reports/landingReport2/tableLandingReport.js": 545,
	"./reports/limitationsReport/filterDepositReports": 562,
	"./reports/limitationsReport/filterDepositReports.js": 562,
	"./reports/limitationsReport/tableDepositReports": 563,
	"./reports/limitationsReport/tableDepositReports.js": 563,
	"./reports/logsUser/filter": 564,
	"./reports/logsUser/filter.js": 564,
	"./reports/logsUser/table": 565,
	"./reports/logsUser/table.js": 565,
	"./reports/loteryReport/detailsLoteryReport": 162,
	"./reports/loteryReport/detailsLoteryReport.js": 162,
	"./reports/loteryReport/filterLoteryReport": 566,
	"./reports/loteryReport/filterLoteryReport.js": 566,
	"./reports/loteryReport/recordLoteryReport": 163,
	"./reports/loteryReport/recordLoteryReport.js": 163,
	"./reports/loteryReport/recordTableLoteryReport": 1798,
	"./reports/loteryReport/recordTableLoteryReport.js": 1798,
	"./reports/loteryReport/tableLoteryReport": 47,
	"./reports/loteryReport/tableLoteryReport.js": 47,
	"./reports/my_comissions_report/filter": 649,
	"./reports/my_comissions_report/filter.js": 649,
	"./reports/my_comissions_report/table": 650,
	"./reports/my_comissions_report/table.js": 650,
	"./reports/notesUser/filter": 651,
	"./reports/notesUser/filter.js": 651,
	"./reports/notesUser/table": 652,
	"./reports/notesUser/table.js": 652,
	"./reports/operatorResponsibility/filter": 653,
	"./reports/operatorResponsibility/filter.js": 653,
	"./reports/operatorResponsibility/table": 654,
	"./reports/operatorResponsibility/table.js": 654,
	"./reports/partners-categories/filter": 791,
	"./reports/partners-categories/filter.js": 791,
	"./reports/partners-categories/table": 792,
	"./reports/partners-categories/table.js": 792,
	"./reports/playersReport/detailsPlayersReport": 820,
	"./reports/playersReport/detailsPlayersReport.js": 820,
	"./reports/playersReport/filterPlayersReport": 818,
	"./reports/playersReport/filterPlayersReport.js": 818,
	"./reports/playersReport/recordPlayersReport": 821,
	"./reports/playersReport/recordPlayersReport.js": 821,
	"./reports/playersReport/recordTablePlayersReport": 822,
	"./reports/playersReport/recordTablePlayersReport.js": 822,
	"./reports/playersReport/tablePlayersReport": 819,
	"./reports/playersReport/tablePlayersReport.js": 819,
	"./reports/pointSettings/filter": 823,
	"./reports/pointSettings/filter.js": 823,
	"./reports/pointSettings/table": 824,
	"./reports/pointSettings/table.js": 824,
	"./reports/pointsUsers/filter": 825,
	"./reports/pointsUsers/filter.js": 825,
	"./reports/pointsUsers/table": 826,
	"./reports/pointsUsers/table.js": 826,
	"./reports/pokerReport/filterCasinoReport": 827,
	"./reports/pokerReport/filterCasinoReport.js": 827,
	"./reports/pokerReport/tableCasinoReport": 828,
	"./reports/pokerReport/tableCasinoReport.js": 828,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar": 1799,
	"./reports/premiosPendientesPagar/detailsPremiosPendientesPagar.js": 1799,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar": 659,
	"./reports/premiosPendientesPagar/filterPremiosPendientesPagar.js": 659,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar": 1800,
	"./reports/premiosPendientesPagar/recordPremiosPendientesPagar.js": 1800,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar": 895,
	"./reports/premiosPendientesPagar/recordTablePremiosPendientesPagar.js": 895,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar": 660,
	"./reports/premiosPendientesPagar/tablePremiosPendientesPagar.js": 660,
	"./reports/prizesLoyalty/filter": 829,
	"./reports/prizesLoyalty/filter.js": 829,
	"./reports/prizesLoyalty/table": 830,
	"./reports/prizesLoyalty/table.js": 830,
	"./reports/promotionalCasinoCampaings/filter": 846,
	"./reports/promotionalCasinoCampaings/filter.js": 846,
	"./reports/promotionalCasinoCampaings/table": 847,
	"./reports/promotionalCasinoCampaings/table.js": 847,
	"./reports/promotionalCodes/filter": 848,
	"./reports/promotionalCodes/filter.js": 848,
	"./reports/promotionalCodes/table": 849,
	"./reports/promotionalCodes/table.js": 849,
	"./reports/promotionalSpoortbookCampaings/filter": 850,
	"./reports/promotionalSpoortbookCampaings/filter.js": 850,
	"./reports/promotionalSpoortbookCampaings/table": 851,
	"./reports/promotionalSpoortbookCampaings/table.js": 851,
	"./reports/quotaRetraction/filter": 854,
	"./reports/quotaRetraction/filter.js": 854,
	"./reports/quotaRetraction/table": 855,
	"./reports/quotaRetraction/table.js": 855,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports": 856,
	"./reports/referralsAwardsReport/filterReferralsAwardsReports.js": 856,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports": 1801,
	"./reports/referralsAwardsReport/recordReferralsAwardsReports.js": 1801,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports": 1802,
	"./reports/referralsAwardsReport/recordTableReferralsAwardsReports.js": 1802,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports": 857,
	"./reports/referralsAwardsReport/tableReferralsAwardsReports.js": 857,
	"./reports/referralsReport/filterReferralsReports": 858,
	"./reports/referralsReport/filterReferralsReports.js": 858,
	"./reports/referralsReport/recordReferralsReports": 1803,
	"./reports/referralsReport/recordReferralsReports.js": 1803,
	"./reports/referralsReport/recordTableReferralsReports": 1804,
	"./reports/referralsReport/recordTableReferralsReports.js": 1804,
	"./reports/referralsReport/tableReferralsReports": 859,
	"./reports/referralsReport/tableReferralsReports.js": 859,
	"./reports/registeredDocuments/filter": 860,
	"./reports/registeredDocuments/filter.js": 860,
	"./reports/registeredDocuments/record": 165,
	"./reports/registeredDocuments/record.js": 165,
	"./reports/registeredDocuments/recordTable": 862,
	"./reports/registeredDocuments/recordTable.js": 862,
	"./reports/registeredDocuments/table": 861,
	"./reports/registeredDocuments/table.js": 861,
	"./reports/relationUserAggregator/filter": 877,
	"./reports/relationUserAggregator/filter.js": 877,
	"./reports/relationUserAggregator/table": 878,
	"./reports/relationUserAggregator/table.js": 878,
	"./reports/reportHash/filter": 879,
	"./reports/reportHash/filter.js": 879,
	"./reports/reportHash/table": 880,
	"./reports/reportHash/table.js": 880,
	"./reports/reportMarketing/filter": 881,
	"./reports/reportMarketing/filter.js": 881,
	"./reports/reportMarketing/table": 882,
	"./reports/reportMarketing/table.js": 882,
	"./reports/sessionsReport/detailsSessionsReport": 896,
	"./reports/sessionsReport/detailsSessionsReport.js": 896,
	"./reports/sessionsReport/filterSessionsReport": 897,
	"./reports/sessionsReport/filterSessionsReport.js": 897,
	"./reports/sessionsReport/recordSessionsReport": 1005,
	"./reports/sessionsReport/recordSessionsReport.js": 1005,
	"./reports/sessionsReport/recordTableSessionsReport": 1006,
	"./reports/sessionsReport/recordTableSessionsReport.js": 1006,
	"./reports/sessionsReport/tableSessionsReport": 898,
	"./reports/sessionsReport/tableSessionsReport.js": 898,
	"./reports/sessionsReport2/filter": 899,
	"./reports/sessionsReport2/filter.js": 899,
	"./reports/sessionsReport2/table": 900,
	"./reports/sessionsReport2/table.js": 900,
	"./reports/sportsTransactions/filter": 901,
	"./reports/sportsTransactions/filter.js": 901,
	"./reports/sportsTransactions/table": 902,
	"./reports/sportsTransactions/table.js": 902,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido": 903,
	"./reports/summaryBetsReport/detailsFlujoCajaResumido.js": 903,
	"./reports/summaryBetsReport/filterFlujoCajaResumido": 904,
	"./reports/summaryBetsReport/filterFlujoCajaResumido.js": 904,
	"./reports/summaryBetsReport/recordFlujoCajaResumido": 905,
	"./reports/summaryBetsReport/recordFlujoCajaResumido.js": 905,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido": 1805,
	"./reports/summaryBetsReport/recordTableFlujoCajaResumido.js": 1805,
	"./reports/summaryBetsReport/tableFlujoCajaResumido": 906,
	"./reports/summaryBetsReport/tableFlujoCajaResumido.js": 906,
	"./reports/taxPaymentsReport/filter": 907,
	"./reports/taxPaymentsReport/filter.js": 907,
	"./reports/taxPaymentsReport/table": 908,
	"./reports/taxPaymentsReport/table.js": 908,
	"./reports/taxableEarnings/filter": 909,
	"./reports/taxableEarnings/filter.js": 909,
	"./reports/taxableEarnings/table": 910,
	"./reports/taxableEarnings/table.js": 910,
	"./reports/transactionReport/filter": 911,
	"./reports/transactionReport/filter.js": 911,
	"./reports/transactionReport/table": 912,
	"./reports/transactionReport/table.js": 912,
	"./reports/transfersReport/filter": 913,
	"./reports/transfersReport/filter.js": 913,
	"./reports/transfersReport/table": 914,
	"./reports/transfersReport/table.js": 914,
	"./reports/userAffiliatesAgent/filter": 915,
	"./reports/userAffiliatesAgent/filter.js": 915,
	"./reports/userAffiliatesAgent/table": 916,
	"./reports/userAffiliatesAgent/table.js": 916,
	"./reports/userAffiliatesBetShop/filter": 917,
	"./reports/userAffiliatesBetShop/filter.js": 917,
	"./reports/userAffiliatesBetShop/table": 918,
	"./reports/userAffiliatesBetShop/table.js": 918,
	"./reports/usuarioOnlineResumido/filter": 919,
	"./reports/usuarioOnlineResumido/filter.js": 919,
	"./reports/usuarioOnlineResumido/table": 920,
	"./reports/usuarioOnlineResumido/table.js": 920,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests": 921,
	"./reports/withdrawalRequestsBetShop/detailsWithdrawalRequests.js": 921,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest": 922,
	"./reports/withdrawalRequestsBetShop/filterWithdrawalRequest.js": 922,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest": 1806,
	"./reports/withdrawalRequestsBetShop/recordTableWithdrawalRequest.js": 1806,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest": 923,
	"./reports/withdrawalRequestsBetShop/recordWithdrawalRequest.js": 923,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest": 924,
	"./reports/withdrawalRequestsBetShop/tableWithdrawalRequest.js": 924,
	"./reports/withdrawalRequestsComissions/filter": 925,
	"./reports/withdrawalRequestsComissions/filter.js": 925,
	"./reports/withdrawalRequestsComissions/table": 926,
	"./reports/withdrawalRequestsComissions/table.js": 926,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop": 166,
	"./reports/withdrawalRequestsForBetShop/detailsWithdrawalRequestsBetShop.js": 166,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop": 927,
	"./reports/withdrawalRequestsForBetShop/filterWithdrawalRequestBetShop.js": 927,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop": 126,
	"./reports/withdrawalRequestsForBetShop/recordTableWithdrawalRequestBetShop.js": 126,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop": 167,
	"./reports/withdrawalRequestsForBetShop/recordWithdrawalRequestBetShop.js": 167,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop": 928,
	"./reports/withdrawalRequestsForBetShop/tableWithdrawalRequestBetShop.js": 928,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop": 168,
	"./reports/withdrawalRequestsForBetShop2/detailsWithdrawalRequestsBetShop.js": 168,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop": 929,
	"./reports/withdrawalRequestsForBetShop2/filterWithdrawalRequestBetShop.js": 929,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop": 1807,
	"./reports/withdrawalRequestsForBetShop2/recordTableWithdrawalRequestBetShop.js": 1807,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop": 169,
	"./reports/withdrawalRequestsForBetShop2/recordWithdrawalRequestBetShop.js": 169,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop": 930,
	"./reports/withdrawalRequestsForBetShop2/tableWithdrawalRequestBetShop.js": 930,
	"./reprintCheck": 1808,
	"./reprintCheck.js": 1808,
	"./requests/registration-requests/filter": 931,
	"./requests/registration-requests/filter.js": 931,
	"./requests/registration-requests/generateRequests": 932,
	"./requests/registration-requests/generateRequests.js": 932,
	"./requests/registration-requests/recordTableResponts": 933,
	"./requests/registration-requests/recordTableResponts.js": 933,
	"./requests/registration-requests/table": 935,
	"./requests/registration-requests/table.js": 935,
	"./requests/registration-requests/tableResponts": 934,
	"./requests/registration-requests/tableResponts.js": 934,
	"./requests/registrationRequests": 1809,
	"./requests/registrationRequests.js": 1809,
	"./resources-locale_es.json": 1900,
	"./restrictUser": 1810,
	"./restrictUser.js": 1810,
	"./reversionReload": 1811,
	"./reversionReload.js": 1811,
	"./security/adminuser/addAdminUser": 1812,
	"./security/adminuser/addAdminUser.js": 1812,
	"./security/adminuser/configuration/changePassword": 1813,
	"./security/adminuser/configuration/changePassword.js": 1813,
	"./security/adminuser/configuration/changePassword/changePasswordView": 936,
	"./security/adminuser/configuration/changePassword/changePasswordView.js": 936,
	"./security/adminuser/configuration/generateToken": 1814,
	"./security/adminuser/configuration/generateToken.js": 1814,
	"./security/adminuser/configuration/generateToken/filter": 937,
	"./security/adminuser/configuration/generateToken/filter.js": 937,
	"./security/adminuser/configuration/generateToken/table": 938,
	"./security/adminuser/configuration/generateToken/table.js": 938,
	"./security/adminuser/configuration/qrgoogle": 1815,
	"./security/adminuser/configuration/qrgoogle.js": 1815,
	"./security/adminuser/configuration/securityChanges": 1816,
	"./security/adminuser/configuration/securityChanges.js": 1816,
	"./security/adminuser/configuration/securityChanges/filter": 172,
	"./security/adminuser/configuration/securityChanges/filter.js": 172,
	"./security/adminuser/configuration/securityChanges/table": 129,
	"./security/adminuser/configuration/securityChanges/table.js": 129,
	"./security/adminuser/configurationAdminUser": 1817,
	"./security/adminuser/configurationAdminUser.js": 1817,
	"./security/adminuser/detailsAdminUser": 1818,
	"./security/adminuser/detailsAdminUser.js": 1818,
	"./security/adminuser/filterAdminUser": 205,
	"./security/adminuser/filterAdminUser.js": 205,
	"./security/adminuser/informationAdminUser": 1819,
	"./security/adminuser/informationAdminUser.js": 1819,
	"./security/adminuser/recordAdminUser": 1820,
	"./security/adminuser/recordAdminUser.js": 1820,
	"./security/adminuser/recordTableAdminUser": 939,
	"./security/adminuser/recordTableAdminUser.js": 939,
	"./security/adminuser/reports/logsUser": 1821,
	"./security/adminuser/reports/logsUser.js": 1821,
	"./security/adminuser/reports/logsUser/filter": 940,
	"./security/adminuser/reports/logsUser/filter.js": 940,
	"./security/adminuser/reports/logsUser/table": 941,
	"./security/adminuser/reports/logsUser/table.js": 941,
	"./security/adminuser/reportsAdminUser": 1822,
	"./security/adminuser/reportsAdminUser.js": 1822,
	"./security/adminuser/tableAdminUser": 206,
	"./security/adminuser/tableAdminUser.js": 206,
	"./security/approvalLogs/filter": 284,
	"./security/approvalLogs/filter.js": 284,
	"./security/approvalLogs/table": 285,
	"./security/approvalLogs/table.js": 285,
	"./security/approvalLogs2/filter": 286,
	"./security/approvalLogs2/filter.js": 286,
	"./security/approvalLogs2/table": 287,
	"./security/approvalLogs2/table.js": 287,
	"./security/approvalLogsBetShop/filter": 288,
	"./security/approvalLogsBetShop/filter.js": 288,
	"./security/approvalLogsBetShop/table": 289,
	"./security/approvalLogsBetShop/table.js": 289,
	"./security/contingencia/detailsContingencia": 1823,
	"./security/contingencia/detailsContingencia.js": 1823,
	"./security/contingencia/filterContingencia": 435,
	"./security/contingencia/filterContingencia.js": 435,
	"./security/contingencia/recordContingencia": 1824,
	"./security/contingencia/recordContingencia.js": 1824,
	"./security/contingencia/recordTableContingencia": 942,
	"./security/contingencia/recordTableContingencia.js": 942,
	"./security/contingencia/tableContingencia": 436,
	"./security/contingencia/tableContingencia.js": 436,
	"./security/menu/filter": 639,
	"./security/menu/filter.js": 639,
	"./security/menu/table": 640,
	"./security/menu/table.js": 640,
	"./security/perfil/detailsPerfil": 843,
	"./security/perfil/detailsPerfil.js": 843,
	"./security/perfil/filterPerfil": 841,
	"./security/perfil/filterPerfil.js": 841,
	"./security/perfil/recordPerfil": 844,
	"./security/perfil/recordPerfil.js": 844,
	"./security/perfil/recordTablePerfil": 845,
	"./security/perfil/recordTablePerfil.js": 845,
	"./security/perfil/tablePerfil": 842,
	"./security/perfil/tablePerfil.js": 842,
	"./security/perfilopciones/detailsPerfilOpciones": 124,
	"./security/perfilopciones/detailsPerfilOpciones.js": 124,
	"./security/perfilopciones/filterPerfilOpciones": 86,
	"./security/perfilopciones/filterPerfilOpciones.js": 86,
	"./security/perfilopciones/recordPerfilOpciones": 125,
	"./security/perfilopciones/recordPerfilOpciones.js": 125,
	"./security/perfilopciones/recordTablePerfilOpciones": 65,
	"./security/perfilopciones/recordTablePerfilOpciones.js": 65,
	"./security/perfilopciones/tablePerfilOpciones": 64,
	"./security/perfilopciones/tablePerfilOpciones.js": 64,
	"./security/perfilopciones2/detailsPerfilOpciones": 1825,
	"./security/perfilopciones2/detailsPerfilOpciones.js": 1825,
	"./security/perfilopciones2/filterPerfilOpciones": 1826,
	"./security/perfilopciones2/filterPerfilOpciones.js": 1826,
	"./security/perfilopciones2/recordPerfilOpciones": 1827,
	"./security/perfilopciones2/recordPerfilOpciones.js": 1827,
	"./security/perfilopciones2/recordTablePerfilOpciones": 1828,
	"./security/perfilopciones2/recordTablePerfilOpciones.js": 1828,
	"./security/perfilopciones2/tablePerfilOpciones": 1829,
	"./security/perfilopciones2/tablePerfilOpciones.js": 1829,
	"./security/perfilopcionesOld/detailsPerfilOpciones": 1830,
	"./security/perfilopcionesOld/detailsPerfilOpciones.js": 1830,
	"./security/perfilopcionesOld/filterPerfilOpciones": 1831,
	"./security/perfilopcionesOld/filterPerfilOpciones.js": 1831,
	"./security/perfilopcionesOld/recordPerfilOpciones": 1832,
	"./security/perfilopcionesOld/recordPerfilOpciones.js": 1832,
	"./security/perfilopcionesOld/recordTablePerfilOpciones": 1833,
	"./security/perfilopcionesOld/recordTablePerfilOpciones.js": 1833,
	"./security/perfilopcionesOld/tablePerfilOpciones": 1834,
	"./security/perfilopcionesOld/tablePerfilOpciones.js": 1834,
	"./security/submenu/detailsSubMenu": 943,
	"./security/submenu/detailsSubMenu.js": 943,
	"./security/submenu/filterSubMenu": 944,
	"./security/submenu/filterSubMenu.js": 944,
	"./security/submenu/recordSubMenu": 945,
	"./security/submenu/recordSubMenu.js": 945,
	"./security/submenu/recordTableSubMenu": 946,
	"./security/submenu/recordTableSubMenu.js": 946,
	"./security/submenu/tableSubMenu": 947,
	"./security/submenu/tableSubMenu.js": 947,
	"./security/totalContingencies/table": 948,
	"./security/totalContingencies/table.js": 948,
	"./security/userSitebuilder/filter": 949,
	"./security/userSitebuilder/filter.js": 949,
	"./security/userSitebuilder/information": 1835,
	"./security/userSitebuilder/information.js": 1835,
	"./security/userSitebuilder/table": 950,
	"./security/userSitebuilder/table.js": 950,
	"./security/userVerification2/filter": 951,
	"./security/userVerification2/filter.js": 951,
	"./security/userVerification2/information": 1836,
	"./security/userVerification2/information.js": 1836,
	"./security/userVerification2/table": 952,
	"./security/userVerification2/table.js": 952,
	"./security/usuarioperfil/detailsUsuarioPerfil": 1837,
	"./security/usuarioperfil/detailsUsuarioPerfil.js": 1837,
	"./security/usuarioperfil/filterUsuarioPerfil": 953,
	"./security/usuarioperfil/filterUsuarioPerfil.js": 953,
	"./security/usuarioperfil/recordTableUsuarioPerfil": 954,
	"./security/usuarioperfil/recordTableUsuarioPerfil.js": 954,
	"./security/usuarioperfil/recordUsuarioPerfil": 1838,
	"./security/usuarioperfil/recordUsuarioPerfil.js": 1838,
	"./security/usuarioperfil/tableUsuarioPerfil": 955,
	"./security/usuarioperfil/tableUsuarioPerfil.js": 955,
	"./security/usuariosbloqueados/add": 1839,
	"./security/usuariosbloqueados/add.js": 1839,
	"./security/usuariosbloqueados/filter": 956,
	"./security/usuariosbloqueados/filter.js": 956,
	"./security/usuariosbloqueados/table": 957,
	"./security/usuariosbloqueados/table.js": 957,
	"./security/wallets/filter": 958,
	"./security/wallets/filter.js": 958,
	"./security/wallets/table": 959,
	"./security/wallets/table.js": 959,
	"./sessionsReport": 1840,
	"./sessionsReport.js": 1840,
	"./sessionsReport2": 1841,
	"./sessionsReport2.js": 1841,
	"./settings": 1842,
	"./settings.js": 1842,
	"./significantEventsAndAlterations": 1843,
	"./significantEventsAndAlterations.js": 1843,
	"./significantEventsAndAlterations2": 1844,
	"./significantEventsAndAlterations2.js": 1844,
	"./sportsTransactions": 1845,
	"./sportsTransactions.js": 1845,
	"./subMenu": 1846,
	"./subMenu.js": 1846,
	"./subProviders": 1847,
	"./subProviders.js": 1847,
	"./summaryBetsReport": 1848,
	"./summaryBetsReport.js": 1848,
	"./summaryCashFlow": 1849,
	"./summaryCashFlow.js": 1849,
	"./summaryCashFlow2": 1850,
	"./summaryCashFlow2.js": 1850,
	"./summaryCashFlowMachine": 1851,
	"./summaryCashFlowMachine.js": 1851,
	"./tags": 1852,
	"./tags.js": 1852,
	"./taxPaymentsReport": 1853,
	"./taxPaymentsReport.js": 1853,
	"./taxableEarnings": 1854,
	"./taxableEarnings.js": 1854,
	"./teacher/concessionaire/filterConcessionaire": 497,
	"./teacher/concessionaire/filterConcessionaire.js": 497,
	"./teacher/concessionaire/tableConcessionaire": 498,
	"./teacher/concessionaire/tableConcessionaire.js": 498,
	"./teacher/qualifying/filterQualifying": 852,
	"./teacher/qualifying/filterQualifying.js": 852,
	"./teacher/qualifying/tableQualifying": 853,
	"./teacher/qualifying/tableQualifying.js": 853,
	"./teacher/registered-documents/filterRegisteredDocuments": 863,
	"./teacher/registered-documents/filterRegisteredDocuments.js": 863,
	"./teacher/registered-documents/tableRegisteredDocuments": 864,
	"./teacher/registered-documents/tableRegisteredDocuments.js": 864,
	"./termsAndConditions": 1855,
	"./termsAndConditions.js": 1855,
	"./toolbar": 12,
	"./toolbar.js": 12,
	"./tools/countries/filter": 437,
	"./tools/countries/filter.js": 437,
	"./tools/countries/table": 438,
	"./tools/countries/table.js": 438,
	"./tools/translationManager": 1856,
	"./tools/translationManager.js": 1856,
	"./tools/translationManager/filter": 960,
	"./tools/translationManager/filter.js": 960,
	"./tools/translationManager/table": 961,
	"./tools/translationManager/table.js": 961,
	"./tools/uploadImage": 1857,
	"./tools/uploadImage.js": 1857,
	"./top": 1858,
	"./top.js": 1858,
	"./totalContingencies": 1859,
	"./totalContingencies.js": 1859,
	"./transactionReport": 1860,
	"./transactionReport.js": 1860,
	"./transactions": 1861,
	"./transactions.js": 1861,
	"./transactionsByPlayer": 1862,
	"./transactionsByPlayer.js": 1862,
	"./transactionsByPlayerDeposit": 1863,
	"./transactionsByPlayerDeposit.js": 1863,
	"./transactionsByPlayerFirstLevel": 1864,
	"./transactionsByPlayerFirstLevel.js": 1864,
	"./transactionsByPlayerSecondLevel": 1865,
	"./transactionsByPlayerSecondLevel.js": 1865,
	"./trasnfersReport": 1866,
	"./trasnfersReport.js": 1866,
	"./tutorials": 1867,
	"./tutorials.js": 1867,
	"./userAffiliatesAgent": 1868,
	"./userAffiliatesAgent.js": 1868,
	"./userAffiliatesBetShop": 1869,
	"./userAffiliatesBetShop.js": 1869,
	"./userManagement": 1870,
	"./userManagement.js": 1870,
	"./userManagement/userManagement/detailsUserManagement": 964,
	"./userManagement/userManagement/detailsUserManagement.js": 964,
	"./userManagement/userManagement/filterUserManagement": 962,
	"./userManagement/userManagement/filterUserManagement.js": 962,
	"./userManagement/userManagement/recordTableUserManagement": 966,
	"./userManagement/userManagement/recordTableUserManagement.js": 966,
	"./userManagement/userManagement/recordUserManagement": 965,
	"./userManagement/userManagement/recordUserManagement.js": 965,
	"./userManagement/userManagement/tableUserManagement": 963,
	"./userManagement/userManagement/tableUserManagement.js": 963,
	"./userProfile": 1871,
	"./userProfile.js": 1871,
	"./usersSitebuilder": 1872,
	"./usersSitebuilder.js": 1872,
	"./usersVerification": 1873,
	"./usersVerification.js": 1873,
	"./usersVerification/information": 967,
	"./usersVerification/information.js": 967,
	"./usersVerification2": 1874,
	"./usersVerification2.js": 1874,
	"./usersVerificationManagement": 1875,
	"./usersVerificationManagement.js": 1875,
	"./usuarioOnlineResumido": 1876,
	"./usuarioOnlineResumido.js": 1876,
	"./usuariosbloqueados": 1877,
	"./usuariosbloqueados.js": 1877,
	"./verifyAccount": 1878,
	"./verifyAccount.js": 1878,
	"./verifyAccountAgent": 1879,
	"./verifyAccountAgent.js": 1879,
	"./verifyAccountJumio": 1880,
	"./verifyAccountJumio.js": 1880,
	"./wallets": 1881,
	"./wallets.js": 1881,
	"./widgets": 1882,
	"./widgets.js": 1882,
	"./withdrawal": 1883,
	"./withdrawal.js": 1883,
	"./withdrawalRequests": 1884,
	"./withdrawalRequests.js": 1884,
	"./withdrawalRequestsBetShop": 1885,
	"./withdrawalRequestsBetShop.js": 1885,
	"./withdrawalRequestsComissions": 1886,
	"./withdrawalRequestsComissions.js": 1886,
	"./withdrawalRequestsForBetShop": 1887,
	"./withdrawalRequestsForBetShop.js": 1887,
	"./withdrawalRequestsForBetShop2": 1888,
	"./withdrawalRequestsForBetShop2.js": 1888,
	"./withdrawalRequestsRetail": 1889,
	"./withdrawalRequestsRetail.js": 1889
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1897;